
import { DatePipe, formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { CancelRepDialogComponent } from '../cancel-rep-dialog/cancel-rep-dialog.component';
import { CreditvoucherDialogComponent } from '../creditvoucher-dialog/creditvoucher-dialog.component';
import { UpdateOfficeRepresentativeComponent } from '../update-office-representative/update-office-representative.component';
import { IssueSellerRegistrationReportComponentComponent } from '../issue-seller-registration-report-component/issue-seller-registration-report-component.component';
import { IssueSellerInvoiceBillComponent } from '../issue-seller-invoice-bill/issue-seller-invoice-bill.component';
import { ViewIssueSellerInvoiceComponent } from 'src/app/view-issue-seller-invoice/view-issue-seller-invoice.component';
import { BookSellerRegistrationBriflyReortComponent } from 'src/app/book-seller-registration-brifly-reort/book-seller-registration-brifly-reort.component';
import { IssueSellerRegistrationRepwiseIndetailReportComponent } from 'src/app/issue-seller-registration-repwise-indetail-report/issue-seller-registration-repwise-indetail-report.component';
import { IssueSellerOffwiseIndetailRepgistrationReportComponent } from 'src/app/issue-seller-offwise-indetail-repgistration-report/issue-seller-offwise-indetail-repgistration-report.component';
import { IssueSellerRegistationOffwiseBriflyReportComponent } from 'src/app/issue-seller-registation-offwise-brifly-report/issue-seller-registation-offwise-brifly-report.component';
import { AddIssueSellerPerPriceComponent } from 'src/app/add-issue-seller-per-price/add-issue-seller-per-price.component';
import { UpdateIssueSellerPerPriceComponentComponent } from 'src/app/update-issue-seller-per-price-component/update-issue-seller-per-price-component.component';
import { IssueSellerInvoicePaymentReceiptComponent } from 'src/app/issue-seller-invoice-payment-receipt/issue-seller-invoice-payment-receipt.component';
import { IssueCotractBriefReportComponent } from 'src/app/issue-cotract-brief-report/issue-cotract-brief-report.component';
import { TworeceiptComponent } from 'src/app/tworeceipt/tworeceipt.component';
import { AdvtInvoiceRegisterComponent } from '../advt-invoice-register/advt-invoice-register.component';
import { IssueSellerInvoiceRegisterComponent } from 'src/app/issue-seller-invoice-register/issue-seller-invoice-register.component';
import { IssueContractReportComponent } from 'src/app/issue-contract-report/issue-contract-report.component';
import { IssueCreditVoucherPaymtRecieptBriflyReportComponent } from 'src/app/issue-credit-voucher-paymt-reciept-brifly-report/issue-credit-voucher-paymt-reciept-brifly-report.component';
import { IssueCreditVoucheofficerIndetailReportComponent } from 'src/app/issue-credit-voucheofficer-indetail-report/issue-credit-voucheofficer-indetail-report.component';
import { IssueCreditVoucherVeryBriflyOfficerReportComponent } from 'src/app/issue-credit-voucher-very-brifly-officer-report/issue-credit-voucher-very-brifly-officer-report.component';
import { IssuecreditvoucherbrieflyofficerreportComponent } from 'src/app/issuecreditvoucherbrieflyofficerreport/issuecreditvoucherbrieflyofficerreport.component';
import { IssueSellerIndetailCreditVoucherReportComponent } from 'src/app/issue-seller-indetail-credit-voucher-report/issue-seller-indetail-credit-voucher-report.component';
import { CreaditReceiptComponentComponent } from 'src/app/creadit-receipt-component/creadit-receipt-component.component';
import { OpenselectmodalComponent } from 'src/app/openselectmodal/openselectmodal.component';
import { OpenIssueSellerCreditNoteComponent } from 'src/app/open-issue-seller-credit-note/open-issue-seller-credit-note.component';
import { ContractBriefReportComponent } from '../contract-brief-report/contract-brief-report.component';
import { IssueSellerPersonalLedgerComponent } from 'src/app/issue-seller-personal-ledger/issue-seller-personal-ledger.component';
import { IssueSellerBrieflyPersonalLedgerComponentComponent } from 'src/app/issue-seller-briefly-personal-ledger-component/issue-seller-briefly-personal-ledger-component.component';
import { IssueSellerAddressGSTReportComponent } from 'src/app/issue-seller-address-gstreport/issue-seller-address-gstreport.component';
import { AdvertisementAddressComponent } from 'src/app/advertisement-address/advertisement-address.component';
import { AdvertisementAddressListComponent } from 'src/app/advertisement-address-list/advertisement-address-list.component';
import { IssueSellerContractBriefReportComponent } from 'src/app/issue-seller-contract-brief-report/issue-seller-contract-brief-report.component';
import { IssueSellerOutstandibgIndetailReportsComponent } from 'src/app/issue-seller-outstandibg-indetail-reports/issue-seller-outstandibg-indetail-reports.component';
import { IssueSellerAddressComponent } from 'src/app/issue-seller-address/issue-seller-address.component';
import { VeryBriflyDatewiseComponent } from 'src/app/very-brifly-datewise/very-brifly-datewise.component';
import { IssueBriflyDatewiseComponent } from 'src/app/issue-brifly-datewise/issue-brifly-datewise.component';
import { IndetailDatewiseRptComponent } from 'src/app/indetail-datewise-rpt/indetail-datewise-rpt.component';
import { VeryBrifOffRepresantativeComponent } from 'src/app/very-brif-off-represantative/very-brif-off-represantative.component';
import { IssueVeryBrifRepresentativeComponent } from 'src/app/issue-very-brif-representative/issue-very-brif-representative.component';
import { BrifRepresentativeReportComponent } from 'src/app/brif-representative-report/brif-representative-report.component';
import { IssueSellerCreditNoteRegisterInDetailComponent } from 'src/app/issue-seller-credit-note-register-in-detail/issue-seller-credit-note-register-in-detail.component';
import { IssueSellerCreditNoteBrieflyComponent } from 'src/app/issue-seller-credit-note-briefly/issue-seller-credit-note-briefly.component';
import { IssueSellerCreditNoteMonthwiseComponent } from 'src/app/issue-seller-credit-note-monthwise/issue-seller-credit-note-monthwise.component';
import { IssueSellerCreditNoteInDetailOfficerComponent } from 'src/app/issue-seller-credit-note-in-detail-officer/issue-seller-credit-note-in-detail-officer.component';
import { IssueSellerCreditNoteVeryBrieflyCreditNoteComponent } from 'src/app/issue-seller-credit-note-very-briefly-credit-note/issue-seller-credit-note-very-briefly-credit-note.component';
import { IssueSellerBrieflyOfficeCreditComponent } from 'src/app/issue-seller-briefly-office-credit/issue-seller-briefly-office-credit.component';
import { IssueSellerAddressListComponentComponent } from 'src/app/issue-seller-address-list-component/issue-seller-address-list-component.component';
import { IssueSellerOtherStatePincodewiseStatementComponent } from 'src/app/issue-seller-other-state-pincodewise-statement/issue-seller-other-state-pincodewise-statement.component';
import { IssueSellerPincodewiseStatementComponent } from 'src/app/issue-seller-pincodewise-statement/issue-seller-pincodewise-statement.component';
import { IssueSellerStatewisestatementComponent } from 'src/app/issue-seller-statewisestatement/issue-seller-statewisestatement.component';
import { IssueSellerDistrictwiseStatementComponentComponent } from 'src/app/issue-seller-districtwise-statement-component/issue-seller-districtwise-statement-component.component';
import { IssueSellerHanddeliverylabelslistComponent } from 'src/app/issue-seller-handdeliverylabelslist/issue-seller-handdeliverylabelslist.component';
import { IssueSellerHandDeliveryComponentComponent } from 'src/app/issue-seller-hand-delivery-component/issue-seller-hand-delivery-component.component';
import { IssueSellerPostStatementComponentComponent } from 'src/app/issue-seller-post-statement-component/issue-seller-post-statement-component.component';
import { IssueSellerPrantwiseVarganidarReportComponent } from 'src/app/issue-seller-prantwise-varganidar-report/issue-seller-prantwise-varganidar-report.component';
import { IssueSellerDistrictwiseVarganidarSubscriptionReportComponent } from 'src/app/issue-seller-districtwise-varganidar-subscription-report/issue-seller-districtwise-varganidar-subscription-report.component';
import { IssueSellerDistrictwiseSubscriptionReportComponent } from 'src/app/issue-seller-districtwise-subscription-report/issue-seller-districtwise-subscription-report.component';
import { IssueSellerPrintJavakComponentComponent } from 'src/app/issue-seller-print-javak-component/issue-seller-print-javak-component.component';
import { IssueSellerUpdatePrintOrderComponentComponent } from 'src/app/issue-seller-update-print-order-component/issue-seller-update-print-order-component.component';
import { IssueSellerViewPrintOrderComponentComponent } from 'src/app/issue-seller-view-print-order-component/issue-seller-view-print-order-component.component';
import { IssueSellerPrintOrderStatementComponentComponent } from 'src/app/issue-seller-print-order-statement-component/issue-seller-print-order-statement-component.component';
import { IssueSellerLabelsOfHandDeliveryComponent } from 'src/app/issue-seller-labels-of-hand-delivery/issue-seller-labels-of-hand-delivery.component';
import { IssueSellerBarcodeDialogComponent } from 'src/app/issue-seller-barcode-dialog/issue-seller-barcode-dialog.component';
import { IssueSellerPostingLabelBriefComponent } from 'src/app/issue-seller-posting-label-brief/issue-seller-posting-label-brief.component';
import { IssueSellerPostingLabelBriefComponentComponent } from 'src/app/issue-seller-posting-label-brief-component/issue-seller-posting-label-brief-component.component';
import { IssueSellerAddressLabelsMobileNoComponent } from 'src/app/issue-seller-address-labels-mobile-no/issue-seller-address-labels-mobile-no.component';
import { IssueSellerAddressLabelsComponent } from 'src/app/issue-seller-address-labels/issue-seller-address-labels.component';
import * as XLSX from 'xlsx';
import { IssueSellerChallanBillComponent } from 'src/app/issue-seller-challan-bill/issue-seller-challan-bill.component';
import { TwoReceiptIssuesaleComponentComponent } from 'src/app/two-receipt-issuesale-component/two-receipt-issuesale-component.component';
import { IssueSellerCreditNoteRegisterComponentComponent } from 'src/app/issue-seller-credit-note-register-component/issue-seller-credit-note-register-component.component';
import { IssuesellerdispatchreportlistComponent } from 'src/app/issuesellerdispatchreportlist/issuesellerdispatchreportlist.component';
import { IssueSellerpostingOfficerepreportComponent } from 'src/app/issue-sellerposting-officerepreport/issue-sellerposting-officerepreport.component';
import { ExpenseLedgerReportComponent } from 'src/app/expense-ledger-report/expense-ledger-report.component';
import { SendReminderLetterIssueComponent } from 'src/app/send-reminder-letter-issue/send-reminder-letter-issue.component';
import { SendReminderLetterIssueRepComponent } from 'src/app/send-reminder-letter-issue-rep/send-reminder-letter-issue-rep.component';

interface tableData {
  id: number;
  name: string;
  mobile: string;
}

// export class BookSellerRegistrationComponent {
//   showFields: boolean = false; // Initially hidden


// }

export const _filter = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter1 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter6 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};
export const _filter4 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export function financialYearValidator(): ValidatorFn {
  return (control: FormControl) => {
    const selectedDateStr = control.value;
    const selectedDate = new Date(selectedDateStr);

    // Read financial year boundaries from localStorage
    const startDateStr = sessionStorage.getItem('startDate'); // e.g. "2025-04-01"
    const endDateStr = sessionStorage.getItem('endDate');     // e.g. "2026-03-31"

    if (!startDateStr || !endDateStr || isNaN(selectedDate.getTime())) {
      return { financialYear: true }; // invalid or missing data
    }

    const financialYearStart = new Date(startDateStr);
    const financialYearEnd = new Date(endDateStr);

    // Check if the selected date is within the stored financial year range
    if (selectedDate >= financialYearStart && selectedDate <= financialYearEnd) {
      return null; // Valid
    } else {
      return { financialYear: true }; // Invalid
    }
  };
}


@Component({
  selector: 'app-book-seller-registration',
  templateUrl: './book-seller-registration.component.html',
  styleUrls: ['./book-seller-registration.component.scss'],
})
export class BookSellerRegistrationComponent implements OnInit {

  publisheddate: string;
  invoice_amt: any;
  newdismode: any;
  dev_mode: any;
  credit_remark: any;
  remaining_amt: any;
  amount: number;
  issueChildList: any[];
  repnames: string;
  iscustomer: any = 'no';
  disRepData: any;
  dist_rep_name: any;
  userprofileForm: any;
  issueselForm: FormGroup<{ vstart_date: FormControl<string>; vend_date: FormControl<string>; estart_date: FormControl<string>; eend_date: FormControl<string>; rep_name: FormControl<string>; advtName: FormControl<string>; }>;
  entryForm: FormGroup<{ start: FormControl<string>; end: FormControl<string>; }>;
  priceTotal: number;
  commissionTotal: number;
  remainingTotal: number;
  bookselnamedata1: any[];
  distributionModeList: any;
  FilteredsubDistributionModeData: any;
  selectedCategory: string;
  allIssueDates: any;
  filteredIssueDates: any[];
  issueSellerchallanFormsecond: FormGroup<{ start: FormControl<string>; end: FormControl<string>; }>;
  prant_names: string;
  total_amt: any;
  prant_ids: string;
  discount: any;
  net_amt: any;
  issuesellerList: any;
  curweekfirstday: any;
  preweekfirstday: any;
  selectedCountry: string;
  selectedDistrict: string;
  selectedDeliveryMode: string;
  selectedDistributionRep: string;
  selectedOfficeRep: string;
  selectedRepName: string;
  selectedIssueSellerName: string;
  filteredIssueSellerList: any;
  dispatchissueForm: FormGroup<{
    deliveryModes: FormControl<any>;
    distributionRepresentatives: FormControl<any>; distributionModes: FormControl<any>;
    deliverySubModes: FormControl<any>;
  }>;
  filteredOptions6Source: any;
  filteredOptions7Source: any;
  filteredOptions28Source: any;
  financialYearMin: Date;
  financialYearMax: Date;
  allIssueBookingSellerList: any[];

  getChangedDateContractM2() {
    if (
      this.CreditNoteForm.get('start').value != null &&
      this.CreditNoteForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.CreditNoteForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.CreditNoteForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }

  OutStandingForm: FormGroup<{ start: FormControl<any>; end: FormControl<any>; repname: FormControl<any>; offrepname: FormControl<any>; issuecate: FormControl<any>; advtname: FormControl<any>; name: FormControl<any>; issuename: FormControl<any>; issueDates: FormControl<any>; }>;
  issueCopies: any;
  complementaryCopies1: number;
  issueSellerPrice1: number;
  issueSellerPrice: any;


  getChangedDateAdvtRemainder() {
    throw new Error('Method not implemented.');
  }
  countries = [];
  countries1 = []
  states = [];
  cities = [];
  advt_mag_name_details = [];
  selectedState = '';
  selectedCity = '';
  AdvtDetails = [];
  issuesellerentryForm: FormGroup;
  expense: FormGroup;
  publicationsaleForm: FormGroup;
  publicationpaymententriesForm: FormGroup;
  issueForm: FormGroup;
  RegistrationreportRange: FormGroup;

  generateform: FormGroup;
  distributionForm: FormGroup;
  advtpymtrecptform: FormGroup;
  advtCreditNoteform: FormGroup;
  issueSellerbillForm: FormGroup;
  issueSellerFormsecond: FormGroup;
  contractDetailsForm: FormGroup;
  issueSellerbillFormsecond: FormGroup;
  PersonalNoteform: FormGroup;
  advtCategorylist;
  issueSellerName;
  tableData: tableData[] = [];
  dataLoaded = false;
  yourMessage = [];
  data1: string[];
  key;
  data2: string[];
  issue_seller_name: any = [];
  filteredOptions: any = [];
  filteredOptions1: Observable<string[]>;
  issuewisereplist;
  // demo1TabIndex: number;
  filterissuedate: any[];
  LabelsDispatchSubnames = [];
  LabelsDispatchSubtypes = [];
  LabelsDispatchRepNames = [];
  LabelsDispatchOffRepNames = [];
  LabelsDispatchDeliveryModes = [];
  LabelsDispatchDisRepNames = [];
  FilteredlabelsforPostStatement = [];
  FilteredlabelsforDispatch = [];
  offfilteroption: any = [];
  offfilteroption2: any = [];
  offfilteroption22: any = [];
  offfilteroption3: any = [];
  FilteredgetSubDetailsData = [];
  labelsforDispatch = [];
  pp_off_rep_names = [];


  // assignOfficeRepresentatives: any[];
  issueSellerNames: any = [];
  issueSellerNames2: any = [];
  selectAll: boolean = false;
  searchControl = new FormControl('');
  selectedItems = [];
  searchControl2 = new FormControl('');
  selectedItems2 = new FormControl([]);
  officeRepNames: any[];
  PaymentReceiptRegister: FormGroup;
  issueinvoiceForm: FormGroup;
  contractRepName: any[] = [];
  issueCategorylist: any[] = [];
  contractOffRepName = [];
  // getMagIssueDatesandNames: any[] = [];
  advtPaymentRegiInDetailsFormBeans: any;
  // allSelectedtable: boolean = false;

  // filteredOptions2: string[] = this.issueSellerNames;
  // options = ['Apple', 'Banana', 'Cherry', 'Mango', 'Orange', 'Pineapple', 'Strawberry'];
  filteredOptions2: string[] = []
  LabelsDispatchTitles = [];
  allSelecteddrop = false;
  voucherdate: any;
  getentrybyrepnamelist: Object;
  pendingAdvtData: any;
  autogeneratedno: any;
  pendingissueData: any;
  GetOffRep: any;
  filterrep: any;
  disRepData1: any;
  name: any;
  pindcodelist: any;
  // newadvtname: any;
  newadvtname: any[] = [];
  arraynew: any;
  invoicenumberlist: any;
  startDate_contract: string;
  enddate_contract: string;
  issuePaymentRegiInDetailsFormBeans: Object;
  PaymentissueOffInDTotal: number;
  data_for_two_receipt: any;
  contractReportissueRepName: any;
  newList1: any;
  data: any;
  total: number;
  Sendreminderform: FormGroup<{ start: FormControl<any>; end: FormControl<any>; Repname: FormControl<any>; Advtname: FormControl<any>, startDate: FormControl<any>, endDate: FormControl<any>; }>;
  Advtremainingamt: any;
  newg: any;
  advtCreditNote: any;
  advtAdvanceStampform: any;
  advtCreditNote1: any;
  credit_type: any;
  remark: any;
  crdtvno: any;
  selectedTaluka: any;
  talukas: any;
  countries2: any[];
  getContractReportTypeInDetail: any;
  getContractReportTypeBriefly: any;
  GSTFullReportForm: FormGroup;
  RNIFullReportForm: FormGroup;
  Sendreminderissueform:FormGroup;
  CreditNoteForm: any;
  advt_name: any;
  advtcreditnotetRegiInDetailsFormBeans: any;
  PaymentadvtOffInDTotal: number;
  advtName: any;
  labeldata: any;
  totalamountofsub = 0;
  totaldiscountofsub = 0;
  totalnetamtofsub = 0;
  totalrepcomofsub = 0;



  // advtCreditNoteform: FormGroup<{ date: FormControl<string>; crdtvno: FormControl<string>; recptdate: FormControl<string>; repname: FormControl<string>; recptno: FormControl<string>; CrNno: FormControl<string>; seamt: FormControl<string>; balamt: FormControl<string>; advtname: FormControl<string>; advtnamesearch: FormControl<string>; newordeleted: FormControl<string>; }>;

  getDatafromLabelsDispatch() {
    for (
      let index = 0;
      index < Object.keys(this.FilteredlabelsforDispatch).length;
      index++
    ) {
      // if (this.FilteredlabelsforDispatch[index]['title'] != '') {
      // this.LabelsDispatchTitles.push({
      //   title: this.FilteredlabelsforDispatch[index]['title'],
      // });
      // }

      this.LabelsDispatchSubnames.push({
        sub_name: this.FilteredlabelsforDispatch[index]['name'],
      });

      // this.LabelsDispatchSubtypes.push({
      //   sub_type: this.FilteredlabelsforDispatch[index]['Subscription_Type'],
      // });

      // this.LabelsDispatchCountryName.push({
      //   country_name: this.FilteredlabelsforDispatch[index]['country'],
      // });

      // this.LabelsDispatchStateName.push({
      //   state_name: this.FilteredlabelsforDispatch[index]['state'],
      // });

      // this.LabelsDispatchDistrictName.push({
      //   district_name: this.FilteredlabelsforDispatch[index]['district'],
      // });

      // this.LabelsDispatchTalukaName.push({
      //   taluka_name: this.FilteredlabelsforDispatch[index]['taluka'],
      // });

      // this.LabelsDispatchPincode.push({
      //   pincode: this.FilteredlabelsforDispatch[index]['pincode'],
      // });

      this.LabelsDispatchRepNames.push({
        rep_name: this.FilteredlabelsforDispatch[index]['rep_name'],
      });

      this.LabelsDispatchOffRepNames.push({
        off_rep_name: this.FilteredlabelsforDispatch[index]['office_rep_name'],
      });

      // Step 1: Add items to LabelsDispatchDisRepNames
      this.LabelsDispatchDisRepNames.push({
        dis_rep_name: this.FilteredlabelsforDispatch[index]['distribution_rep'],
      });




      // this.LabelsDisModes.push({
      //   dis_mode: this.FilteredlabelsforDispatch[index]['dis_mode'],
      // });

      // if (this.FilteredlabelsforDispatch[index]['dis_mode'] != '') {
      //   this.LabelsDisModes.push({
      //     dis_mode: this.FilteredlabelsforDispatch[index]['dis_mode'],
      //   });
      // }

      // if (this.FilteredlabelsforDispatch[index]['dis_mode'] != '') {
      //   this.LabelsSubDisModes.push({
      //     dis_mode: this.FilteredlabelsforDispatch[index]['dis_mode'],
      //     sub_dis_mode: this.FilteredlabelsforDispatch[index]['dis_sub_mode'],
      //   });
      // }

      this.LabelsDispatchDeliveryModes.push({
        mode_name: this.FilteredlabelsforDispatch[index]['delivery_mode'],
      });
    }

    // this.LabelsDispatchTitles = this.uniqueid(
    //   this.LabelsDispatchTitles,
    //   (a) => a['title']
    // );

    // this.LabelsDispatchSubnames = this.uniqueid(
    //   this.LabelsDispatchSubnames,
    //   (a) => a['sub_name']
    // );

    // this.LabelsDispatchSubtypes = this.uniqueid(
    //   this.LabelsDispatchSubtypes,
    //   (a) => a['sub_type']
    // );
    // this.LabelsDispatchSubtypes.sort((a, b) => a.sub_type.localeCompare(b.sub_type));


    // this.LabelsDispatchCountryName = this.uniqueid(
    //   this.LabelsDispatchCountryName,
    //   (a) => a['country_name']
    // );

    // this.LabelsDispatchStateName = this.uniqueid(
    //   this.LabelsDispatchStateName,
    //   (a) => a['state_name']
    // );

    // this.LabelsDispatchDistrictName = this.uniqueid(
    //   this.LabelsDispatchDistrictName,
    //   (a) => a['district_name']
    // );

    // this.LabelsDispatchTalukaName = this.uniqueid(
    //   this.LabelsDispatchTalukaName,
    //   (a) => a['taluka_name']
    // );

    // this.LabelsDispatchPincode = this.uniqueid(
    //   this.LabelsDispatchPincode,
    //   (a) => a['pincode']
    // );

    this.LabelsDispatchRepNames = this.uniqueid(
      this.LabelsDispatchRepNames,
      (a) => a['rep_name']
    );

    this.LabelsDispatchOffRepNames = this.uniqueid(
      this.LabelsDispatchOffRepNames,
      (a) => a['off_rep_name']
    );

    this.LabelsDispatchDisRepNames = this.uniqueid(
      this.LabelsDispatchDisRepNames,
      (a) => a['dis_rep_name']
    );

    // this.LabelsDisModes = this.uniqueid(
    //   this.LabelsDisModes,
    //   (a) => a['dis_mode']
    // );

    // this.LabelsSubDisModes = this.uniqueid(
    //   this.LabelsSubDisModes,
    //   (a) => a['sub_dis_mode']
    // );

    this.LabelsDispatchDeliveryModes = this.uniqueid(
      this.LabelsDispatchDeliveryModes,
      (a) => a['mode_name']
    );
    // console.log('running');

    // Step 2: Use a Map to store unique items based on dis_rep_name
    let uniqueMap = new Map<string, any>();
    this.LabelsDispatchDisRepNames.forEach(item => {
      uniqueMap.set(item.dis_rep_name, item);
    });

    // Step 3: Convert the Map back to an ArrayList
    let uniqueArrayList: any[] = Array.from(uniqueMap.values());
    this.LabelsDispatchDisRepNames = uniqueArrayList

  }



  selectAllOptions(event: any) {

    event.stopPropagation();
    if (this.allSelected) {
      this.selectedItems2.setValue([]);
      this.allSelected = false;
    } else {
      this.selectedItems2.setValue(this.filteredOptions2);
      this.allSelected = true;
    }
  }

  updateAllSelectedState() {
    const selected = this.selectedItems2.value || [];
    this.allSelected = selected.length === this.filteredOptions2.length;
  }

  allSelectedState = false;
  @ViewChild('mySelState') skillselState: MatSelect;
  toggleAllSelectionState() {
    this.allSelectedState = !this.allSelectedState;
    if (this.allSelectedState) {
      this.skillselState.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillselState.options.forEach((item: MatOption) => item.deselect());
      this.state_names = '';
    }
    this.skillselState.close();
  }

  allSelected8 = false;
  @ViewChild('mySel8') skillsel8: MatSelect;
  toggleAllSelection8() {
    this.allSelected8 = !this.allSelected8;
    if (this.allSelected8) {
      this.skillsel8.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillsel8.options.forEach((item: MatOption) => item.deselect());
      this.repnames = '';
    }
    this.skillsel8.close();
  }


  allSelected9 = false;
  @ViewChild('mySel9') skillsel9: MatSelect;
  toggleAllSelection9() {
    this.allSelected9 = !this.allSelected9;
    if (this.allSelected9) {
      this.skillsel9.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillsel9.options.forEach((item: MatOption) => item.deselect());
      this.officerepnames = '';
    }
    this.skillsel9.close();
  }

  allSelected10 = false;
  @ViewChild('mySel10') mySel10!: MatSelect;

  toggleAllSelection10() {
    this.allSelected10 = !this.allSelected10;

    if (this.allSelected10) {
      // Select all options
      this.mySel10.options.forEach((item: MatOption) => item.select());
    } else {
      // Deselect all
      this.mySel10.options.forEach((item: MatOption) => item.deselect());
      this.mode_names = '';
    }

    // Safely get selected values
    const selectedModes = this.mySel10.options
      .filter(option => option.selected)
      .map(option => option.value);

    // Call the handler with array of selected modes
    this.onDeliveryModeChange1(selectedModes);

    this.mySel10.close();
  }

  allSelected100 = false;
  @ViewChild('mySel13') skillsel100: MatSelect;
  // toggleAllSelection100() {
  //   this.allSelected10 = !this.allSelected10;
  //   if (this.allSelected10) {
  //     this.skillsel10.options.forEach((item: MatOption) => item.select());
  //   } else {
  //     this.skillsel10.options.forEach((item: MatOption) => item.deselect());
  //     this.mode_names = '';
  //   }
  //   this.skillsel10.close();
  // }
  toggleAllSelection21() {
    const ctrl = this.dispatchissueForm.get('distributionRepresentatives');
    const selected = ctrl?.value || [];
    if (selected.includes('all')) {
      ctrl?.setValue([]);
    } else {
      ctrl?.setValue(this.filteredOptions6Source.map(opt => opt.name));
    }
  }

  toggleAllSelection12() {
    const ctrl = this.dispatchissueForm.get('distributionModes');
    const selected = ctrl?.value || [];
    if (selected.includes('all')) {
      ctrl?.setValue([]);
    } else {
      ctrl?.setValue(this.filteredOptions7Source.map(opt => opt.name));
    }
  }

  selectedModes: string[] = [];

  toggleAllSelection7() {
    if (this.selectedModes.length === this.delivery_mode.length) {
      this.selectedModes = [];
    } else {
      this.selectedModes = this.delivery_mode.map(x => x.delivery_mode);
    }
    this.issueForm.get('deliveryModeId')?.setValue(this.selectedModes);
    this.onDeliveryModeChange(this.selectedModes); // update distributor list
  }

  resetDeliveryModes() {
    this.selectedModes = [];
    this.issueForm.get('deliveryModeId')?.reset();
    this.filteredDistributorList = [];
  }
  selectedModes1: string[] = [];

  toggleAllSelectionpl() {
    if (this.selectedModes.length === this.delivery_mode.length) {
      this.selectedModes = [];
    } else {
      this.selectedModes1 = this.delivery_mode.map(x => x.delivery_mode);
    }
    this.issueForm.get('deliveryModeId')?.setValue(this.selectedModes1);
    this.onDeliveryModeChange(this.selectedModes1); // update distributor list
  }


  resetDeliveryModes1() {
    this.selectedModes1 = [];
    this.issueForm.get('deliveryModeId')?.reset();
    this.filteredDistributorList = [];
  }
  selectedModes3: string[] = [];

  // Toggle All selection manually
  toggleAllSelectionspl(event: Event) {
    event.stopPropagation(); // prevent selectionChange issues

    this.filteredOptions28.subscribe((options: any[]) => {
      if (this.selectedModes3.length === options.length) {
        // All selected → deselect all
        this.selectedModes3 = [];
      } else {
        // Select all
        this.selectedModes3 = options.map(x => x.name);
      }

      // Update form control manually
      this.issueForm.get('deliverySubModeId')?.setValue(this.selectedModes3);

      // Call backend manually
      this.callSubDistributionModeBackend(this.selectedModes3);
    });
  }
  callSubDistributionModeBackend(selectedModes3: string[]) {
    if (!selectedModes3 || selectedModes3.length === 0) return;

    // Replace 'All' with full list if needed
    if (selectedModes3.includes('all')) {
      selectedModes3 = this.FilteredsubDistributionModeData.map(m => m.name);
    }
  }
  // Reset manually
  resetsubDeliveryModes1() {
    this.selectedModes = [];
    this.issueForm.get('deliverySubModeId')?.reset();
  }


  // selectedModes2: string[] = [];

  // toggleAllSelectiondpl() {
  //   this.filteredOptions7.subscribe((options: any[]) => {
  //     if (this.selectedModes2.length === options.length) {
  //       this.selectedModes2 = [];
  //     } else {
  //       this.selectedModes2 = options.map(x => x.name);
  //     }

  //     this.issueForm.get('distributionModes')?.setValue(this.selectedModes2);

  //     // Update backend
  //     this.onDeliveryModeChange3(this.selectedModes2);
  //   });

  // }


  // resetDistributionModeModes1() {
  //   this.selectedModes2 = [];
  //   this.issueForm.get('distributionModes')?.reset();
  //   this.filteredDistributorList = [];
  // }

  toggleAllSelection13() {
    const ctrl = this.dispatchissueForm.get('deliverySubModes');
    const selected = ctrl?.value || [];
    if (selected.includes('all')) {
      ctrl?.setValue([]);
    } else {
      ctrl?.setValue(this.filteredOptions28Source.map(opt => opt.name));
    }
  }


  allSelected6 = false;
  @ViewChild('mySel6') skillsel6: MatSelect;
  toggleAllSelection6() {
    this.allSelected6 = !this.allSelected6;
    if (this.allSelected6) {
      this.skillsel6.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillsel6.options.forEach((item: MatOption) => item.deselect());
      this.taluka_names = '';
    }
    this.skillsel6.close();
  }


  allSelected5 = false;
  @ViewChild('mySel5') skillsel5: MatSelect;
  toggleAllSelection5() {
    this.allSelected5 = !this.allSelected5;
    if (this.allSelected5) {
      this.skillsel5.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillsel5.options.forEach((item: MatOption) => item.deselect());
      this.district_names = '';
    }
    this.skillsel5.close();
  }
  // changeData(){
  //   debugger
  //  console.log( this.selectedItems2)
  // }

  toggleSelectAll() {
    this.selectAll = !this.selectAll;

    if (this.selectAll) {
      this.selectedItems = this.issueBookingSellerList.map(item => item); // Select all items
    } else {
      this.selectedItems = []; // Deselect all
    }
  }

  toggleSelection(item: any) {
    const index = this.selectedItems.findIndex(selected => selected === item);
    if (index > -1) {
      this.selectedItems.splice(index, 1); // Remove item
    } else {
      this.selectedItems.push(item); // Add item
    }

    // Update "Select All" checkbox state
    this.selectAll = this.selectedItems.length === this.issueBookingSellerList.length;
  }

  showFields: boolean = false; // Initially hidden
  toggleFields() {
    this.showFields = !this.showFields;
  }


  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private router: Router,
    public service: DigisubservicesService,
    public datePipe: DatePipe,
  ) {
    this.searchControl2.valueChanges.subscribe(value => {
      this.filterOptions(value);
    });

    this.expense = formBuilder.group({
      expnameother: [''],
      subexpnameother: [''],
      start: [''],
      end: [''],
    });

    this.advtCreditNoteform = this.formBuilder.group({
      date: [''],
      crdtvno: [''],
      recptdate: [''],
      repname: [''],
      recptno: [''],
      CrNno: [''],
      seamt: [''],
      balamt: [''],
      advtname: [''],
      advtnamesearch: [''],
      newordeleted: [''],

    })

    this.distributionForm = formBuilder.group({
      disrep: [''],
      dismode: [''],
      subdismode: [''],
      vajan: [''],
      tapalrate: [''],
    });
    this.dispatchissueForm = formBuilder.group({
      deliveryModes: [''],
      distributionRepresentatives: [''],
      distributionModes: [''],
      deliverySubModes: [''],
    });

    this.generateform = formBuilder.group({
      publisheddate: [''],
      start: [''],
      end: [''],
      title: [''],
      subname: [''],
      subtype: [''],
      countryname: [''],
      statename: [''],
      districtname: [''],
      talukaname: [''],
      pincode: [''],
      rep: [''],
      officerep: [''],
      delivery_mode_name: [''],
      issue_date: [''],
      issueCatregoryId: [''],
      distributionRepresentativeId: [''],
      distributionMode: [''],
      deliverySubModeId: [''],
      deliveryModeId: [''],
    });
  }

  mainexpId: any;
  mainexpName: any;
  subExpData: any[];
  subexpense: boolean = false;

  mainExpData = [
    {
      id: 35,
      exp_name: 'देणगी',
      source: 'Income'
    }
  ];

  userprofileDateRangeStartDate = '';
  userprofileDateRangeEndDate = '';
  userprofileDateRange() {
    if (
      this.userprofileForm.get('start').value != null &&
      this.userprofileForm.get('end').value != null
    ) {
      this.userprofileDateRangeStartDate = formatDate(
        this.userprofileForm.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.userprofileDateRangeEndDate = formatDate(
        this.userprofileForm.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitEndDate);
    }
  }

  userprofileDateRange1() {
    if (
      this.issueselForm.get('vstart_date').value != null &&
      this.issueselForm.get('vend_date').value != null
    ) {
      this.userprofileDateRangeStartDate = formatDate(
        this.issueselForm.get('vstart_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.userprofileDateRangeEndDate = formatDate(
        this.issueselForm.get('vend_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      this.issueselForm.patchValue({
        vstart_date: this.userprofileDateRangeStartDate,
        vend_date: this.userprofileDateRangeEndDate
      })
      // console.log(this.creditdebitEndDate);
    }
  }

  entryDateRangeStartDate = '';
  entryDateRangeEndDate = '';
  entryDateRange() {
    if (
      this.entryForm.get('start').value != null &&
      this.entryForm.get('end').value != null
    ) {
      this.entryDateRangeStartDate = formatDate(
        this.entryForm.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.entryDateRangeEndDate = formatDate(
        this.entryForm.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitEndDate);
    }
  }

  entryDateRange1() {
    if (
      this.issueselForm.get('eend_date').value != null &&
      this.issueselForm.get('estart_date').value != null
    ) {
      this.entryDateRangeStartDate = formatDate(
        this.issueselForm.get('estart_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.entryDateRangeEndDate = formatDate(
        this.issueselForm.get('eend_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      this.issueselForm.patchValue({
        estart_date: this.entryDateRangeStartDate,
        eend_date: this.entryDateRangeEndDate
      })
      // console.log(this.creditdebitEndDate);
    }
  }


  showSelectedItems2: any
  filterOptions(value: string) {
    const filterValue = (value || '').toLowerCase();
    this.filteredOptions2 = this.issueSellerNames2.filter(option =>
      option.toLowerCase().includes(filterValue)
    );

    // Optional: if "All" was previously selected, update selectedItems2 to match filtered options
    if (this.allSelected) {
      this.selectedItems2.setValue([...this.filteredOptions2]);
    }
  }

  public demo1BtnClick1(tabCount: any) {

    this.demo1TabIndex = Number(tabCount);

  }

  delivery_mode: any
  distributorList: any[] = [];
  distributionModeList1: any;
  filteredDistributorList: any[] = [];
  distributorList1: any[] = [];
  filteredDistributorList1: any[] = [];
  ngOnInit(): void {

    const start = sessionStorage.getItem('startDate'); // e.g. "2025-04-01"
    const end = sessionStorage.getItem('endDate');     // e.g. "2026-03-31"

    this.financialYearMin = start ? new Date(start) : new Date('1900-01-01');
    this.financialYearMax = end ? new Date(end) : new Date('2099-12-31');
    this.getOffRep();
    this.getPrasiddhiPatrakNamesData();

    this.advtCreditNoteform
      .get('date')
      .setValue(formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530'));

    this.assignoffwithtype()
    this.get_assign_office_representatives()
    this.demo1BtnClick1(localStorage.getItem("tab"))

    let today = new Date();
    let billNo = `${today.getMonth() + 1}/${today.getFullYear()}`;
    console.log('Toady month', new Date().getMonth());

    this.service.getIssuesellersname().subscribe((data) => {

      this.issue_seller_name = data;

      // Assuming this.issue_seller_name is an array of objects with a 'name' property
      this.issueSellerNames2 = this.issue_seller_name.map(item => item.name);
      this.filteredOptions2 = this.issueSellerNames2;

      console.log('issue_seller_name', this.issue_seller_name);
    });
    debugger
    this.service.getIssueWiseRep().subscribe((data) => {
      // console.log(data);
      this.issuewisereplist = data;
    });

    // Read All Contries
    // this.service.getAllContries().subscribe((data) => {
    //   console.log(data);

    //   this.countries = data;
    // });
    this.service.getAllContries1().subscribe((data) => {
      console.log("Countries=" + data);

      this.countries1 = data;
    });


    this.service.getCountry().subscribe((data) => {
      this.countries = data;
    });

    this.service.getsubdistmodeissue(this.dis_mode).subscribe((data: any[]) => {
      this.distributionModeList = data;
    });
    this.service.getAdvtCategory().subscribe((data) => {
      // console.log('Database data', data);
      this.advtCategorylist = data;
    });
    this.service.getDeliveryMode().subscribe((data) => {
      // console.log('getDeliveryMode', data);
      this.delivery_mode = data;
    });



    this.service.getsubdistmodeissue(this.dis_mode).subscribe((data) => {
      // console.log(data);
      this.FilteredsubDistributionModeData = data;
    });

    this.service.getDistributorDataForIssueSeller().subscribe((data) => {
      // console.log(data);
      this.distributorList = data;
    });

    this.service.getDistributorModeDataForIssueSeller().subscribe((data) => {
      // console.log(data);
      this.distributionModeList = data;
    });

    this.service.getdistmode().subscribe((data) => {
      console.log('new dis_mode data', data);
      this.newdismode = data;
    });


    this.service.getIssueSellerName().subscribe((data) => {
      this.issueSellerName = data;
      console.log('issueSellerName ', this.issueSellerName['issueSellerName']);
    });

    if (sessionStorage.getItem('mobile') == null) {
      this.router.navigate(['/']);
    }

  this.getNewAdvtName();


    this.issuesellerentryForm = this.formBuilder.group({
      issuesellername: [''],
      englishIssueSellerName: [''],
      engname: [''],
      // fname: [''],
      // mname: [''],
      address1: [''],
      address2: [''],
      address3: [''],
      pincode: [
        '',
        [Validators.maxLength(6), Validators.pattern('^[1-9][0-9]{5}$')],
      ],
      country: ['', [Validators.minLength(2)]],
      state: ['', [Validators.minLength(2)]],
      taluka: ['', [Validators.minLength(2)]],
      district: ['', [Validators.minLength(2)]],
      edistricts: [''],
      mnumber: [
        '',
        [
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern('^[7-9][0-9]{9}$'),
        ],
      ],
      email: [
        '',
        [Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[a-z]{2,3}$')],
      ],
      landline_no: ['', Validators.pattern('^[0-9]\\d{2,4}-\\d{6,8}$')],
      dob: [],
      gstno: ['', [Validators.minLength(15), Validators.maxLength(15)]],
      panno: ['', [Validators.minLength(10), Validators.maxLength(10)]],
      depositamt: [],
      option: [''],
      bookingdate: [],
      issuerate: [''],
      issuecopies: [''],
      grossamt: [''],
      discount: [''],
      amount: [''],
      netamount: [''],
      complementrycopies: [''],
      subscriptioncopies: [''],
      distributedtype: [''],
      subtype: [''],
      details: [''],
      opening_bal: [''],
    });


    this.publicationsaleForm = this.formBuilder.group({
      cdate: ['', Validators.required],
      challanno: ['', Validators.required],
      issuegrath: [''],
      issueDates: [[]],
      issuename: [''],

      // Representative details
      distributionRepresentativeId: ['', Validators.required],
      distributionMode: [''],
      deliverySubModeId: [''],
      address: [''],
      state: [''],
      pincode: [''],
      mobile_no: [''],

      // Totals
      totalCopies: [''],
      totalAmount: ['']
    });

    this.publicationpaymententriesForm = this.formBuilder.group({
      issuegranth: [''],
      issuedates: [],
      billno: [''],
      date: [],
      issuesellername: [''],
      monthdate: [],
    });


    this.issueForm = this.formBuilder.group({
      bookingDate: [''],
      bookingNumber: [''],
      issueSellerId: [''],
      representativeId: [''],
      officeRepresentativeId: [''],
      issueCatregoryId: [''],
      issueNameId: [''],
      issueSellerDate: [''],
      issueSellerPrice: [''],
      issueSellerCopies: [''],
      complementaryCopies: [''],
      discount_per: [''],
      discount_amt: [''],
      amount: [''],
      amount_child: [''],
      totalAmount: [''],
      discountPercentage: [''],
      discountAmount: [''],
      netAmount: [''],
      issueRemark: [''],
      issueSellerGstType: ['NO_GST'],
      gstPercentage: [''],
      gstAmount: [''],
      withoutGstAmount: [''],
      withGstAmount: [''],
      deliveryModeId: [''],
      deliverySubModeId: [''],
      distributionRepresentativeId: [''],
      distributionMode: [''],
      afterdistamt: ['']

    });

    this.issueForm.get('issueSellerPrice')?.valueChanges.subscribe(() => this.updateAfterDiscount());
    this.issueForm.get('discount_amt')?.valueChanges.subscribe(() => this.updateAfterDiscount());

    this.advtpymtrecptform = this.formBuilder.group({
      date: [''],
      crdtvno: [''],
      recptdate: [''],
      repname: [''],
      recptno: [''],
      crdtvamt: [''],
      seamt: [''],
      balamt: [''],
      advtname: [''],
      advtnamesearch: [''],
      newordeleted: [''],
    });

    this.OutStandingForm = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
      repname: new FormControl(),
      offrepname: new FormControl(),
      issuecate: new FormControl(),
      advtname: new FormControl(),
      name: new FormControl(),
      issuename: new FormControl(),
      issueDates: new FormControl(),
    });

    this.CreditNoteForm = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
      rep_name: new FormControl(),
      off_rep_name: new FormControl(),
      issuename: new FormControl(),
      issueDates: new FormControl(),
      newordeleted: new FormControl(''),

    });

    this.issueselForm = new FormGroup({
      vstart_date: new FormControl(''),
      vend_date: new FormControl(''),
      estart_date: new FormControl(''),
      eend_date: new FormControl(''),
      rep_name: new FormControl(''),
      advtName: new FormControl(''),
    });

    this.entryForm = new FormGroup({
      start: new FormControl(''),
      end: new FormControl(''),

    });

    this.userprofileForm = new FormGroup({
      start: new FormControl(''),
      end: new FormControl(''),

    });

    this.RegistrationreportRange = this.formBuilder.group({
      start: new FormControl(),
      end: new FormControl(),
      repname: new FormControl(),
      offrepname: new FormControl(),
      issuename: new FormControl(),
      issuedate: new FormControl(),
    });
    this.issueSellerbillForm = this.formBuilder.group({
      billno: [''],
      date: [''],
      issuename: [''],
      issuedate: [''],
      issue_seller_name: [''],
      newordeleted: [''],
    });
    this.issueSellerFormsecond = this.formBuilder.group({
      start: [''],
      end: [''],
    });
    this.contractDetailsForm = this.formBuilder.group({
      start: [''],
      end: [''],
      rep_name: [''],
      off_rep_name: [''],
      advt_name: [''],
    });
    this.issueSellerbillFormsecond = this.formBuilder.group({
      start: [''],
      end: [''],
    });

    this.issueSellerchallanFormsecond = this.formBuilder.group({
      start: [''],
      end: [''],
    });
    this.filteredOptions = this.issuesellerentryForm
      .get('issuesellername')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) =>
          name ? this._filter(name) : this.issue_seller_name.slice()
        )
      );



    this.filteredOptions1 = this.issuesellerentryForm
      .get('mnumber')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.mob_no)),
        map((mob_no) =>
          mob_no ? this._filter1(mob_no) : this.issue_seller_name.slice()
        )
      );

    this.filteredOptions4 = this.issueForm.get('representativeId').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) =>
        name ? this._filter4(name) : this.issue_seller_name.slice()
      )
    );




    this.offfilteroption = this.issueForm
      .get('representativeId')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.issue_seller_representative)),
        map((issue_seller_representative) =>
          issue_seller_representative ? this._filterrep(issue_seller_representative) : this.contractData11.slice()
        )
      );

    this.offfilteroption3 = this.OutStandingForm
      .get('repname')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.repname)),
        map((repname) =>
          repname ? this._filterrep(repname) : this.contractData1.slice()
        )
      );

    this.offfilteroption22 = this.issueForm
      .get('officeRepresentativeId')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.office_representative)),
        map((office_representative) =>
          office_representative ? this._filterofrep(office_representative) : this.contractData3.slice()
        )
      );

    this.offfilteroption2 = this.OutStandingForm
      .get('offrepname')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.offrepname)),
        map((offrepname) =>
          offrepname ? this._filterofrep(offrepname) : this.contractData3.slice()
        )
      );



    this.PaymentReceiptRegister = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
      rep_name: new FormControl(),
      off_rep_name: new FormControl(),
      issuename: new FormControl(),
      issueDates: new FormControl(),
      advtname: new FormControl(),
    });

    this.issueinvoiceForm = new FormGroup({
      start: new FormControl(''),
      end: new FormControl(''),
      issuename: new FormControl(''),
      issuedate: new FormControl(''),
    });


    this.Sendreminderform = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
      Repname: new FormControl(),
      Advtname: new FormControl(),
      endDate: new FormControl(),
      startDate: new FormControl()
    })

    this.Sendreminderissueform = new FormGroup({
        startDate: new FormControl(),
        endDate: new FormControl(),
        repname: new FormControl(),
        advtname: new FormControl(),
    
      });

    this.PersonalNoteform = new FormGroup({
      start: new FormControl(''),
      end: new FormControl(''),
      advtname: new FormControl(''),
    });


    this.GSTFullReportForm = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    });

    this.RNIFullReportForm = new FormGroup({
      start: new FormControl(),
      end: new FormControl(),
    });

    this.issuesellerentryForm.get('issuesellername').valueChanges.subscribe((value) => {
      const match = this.issuesellerList.find((seller) => seller.name === value);
      if (match) {
        this.isExistingSeller = true;
        this.issueid = match.id;
      } else {
        this.isExistingSeller = false;
        this.issueid = 0; // reset
      }
    });



    // this.offfilteroption2 = this.issueForm
    //   .get('officeRepresentativeId')
    //   .valueChanges.pipe(
    //     startWith(''),
    //     map((value) => (typeof value === 'string' ? value : value.office_rep_name)),
    //     map((office_rep_name) =>
    //       office_rep_name ? this._filterofcrep(office_rep_name) : this.contractData2.slice()
    //     )
    //   );


    this.issueSellerNames = this.issueSellerbillForm
      .get('issue_seller_name')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) =>
          name ? this._filterissueSeller(name) : this.issue_seller_name.slice()
        )
      );

    this.publicationpaymententriesForm.get('billno').setValue(billNo);
    this.getAdvtMagDetails();
    this.getAllVouchers();
    this.rep_List();
    this.getIssueSellerData();


    // this.getIssueSellerList();
    // this.getOfficeRepresentatives();
  }
  automno: any
getallVouchersData: any[] = [];
allVouchersData: any[] = [];

getAllVouchers() {

  /* ===============================
     1️⃣ Get Financial Year Dates
  =============================== */
  const start = sessionStorage.getItem('startDate'); // "2025-04-01"
  const end = sessionStorage.getItem('endDate');     // "2026-03-31"

  this.financialYearMin = start ? new Date(start) : new Date('1900-01-01');
  this.financialYearMax = end ? new Date(end) : new Date('2099-12-31');

  /* ===============================
     2️⃣ API Call + Financial Year Filter
  =============================== */
  this.service.getvoucherbyIssueSale().subscribe((data: any[]) => {

    // 🔹 Store original list safely
    this.allVouchersData = data;

    // 🔹 Filter using voucher_date
    this.getallVouchersData = this.allVouchersData.filter(item => {

      if (!item.voucher_date) {
        return false;
      }

      const voucherDate = new Date(item.voucher_date);

      return (
        voucherDate >= this.financialYearMin &&
        voucherDate <= this.financialYearMax
      );
    });

    console.log(
      'Filtered Voucher List (Financial Year):',
      this.getallVouchersData
    );
  });
}

  issueBookingSellerList: any
  getIssueSellerList() {
    const issuesellerbooking = {
      "issueSellerName": this.issueForm.value.issueSellerId
    }
    this.service.getIssueSellerList(issuesellerbooking).subscribe((data) => {
      this.issueBookingSellerList = data;
      console.log(this.issueBookingSellerList);
    });
  }


  splitDates(dates: string): string[] {
    const dateArray = dates.split(',').map(d => d.trim());
    const result: string[] = [];

    for (let i = 0; i < dateArray.length; i += 2) {
      const first = dateArray[i];
      const second = dateArray[i + 1] || '';
      result.push(second ? `${first}, ${second}` : `${first}`);
    }

    return result;
  }



  rep_List() {
    let filterdData: string[];
    this.service.get_AllRepresentative_List().subscribe((data) => {
      this.data1 = data;
      //console.log("Data from PHP : ", this.data1);
      //console.log(this.data1.filter(item => { return item['name'] != "office" }))

      this.data1 = this.data1.filter((item) => {
        return item['name'] != 'office';
      });

      //Object.values(this.data1).filter(key => !this.data1.includes)
      for (let index = 0; index < Object.keys(this.data1).length; ++index) {
        if (parseInt(this.data1[index]['id']) > 50) {
          this.tableData.push({
            id: this.data1[index]['id'],
            name: this.data1[index]['name'],
            mobile: this.data1[index]['mobile'],
          });
          continue;
        }
      }

      if (Object.keys(this.tableData).length == 0) {
        this.dataLoaded = false;
      } else {
        this.dataLoaded = true;
      }
    });
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.issue_seller_name.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter1(mob_no: string): any[] {
    const filterValue = mob_no.toLowerCase();

    return this.issue_seller_name.filter((option) =>
      option.mob_no.toLowerCase().includes(filterValue)
    );
  }

  private _filterrep(value: string): any[] {
    const filterValue = (value || '').toLowerCase();
    return this.contractData11.filter(option =>
      option.issue_seller_representative?.toLowerCase().includes(filterValue)
    );
  }



  private _filterofrep(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.contractData3.filter(option =>
      option.office_representative.toLowerCase().includes(filterValue)
    );
  }
  // private _filterofcrep(value: string): any[] {
  //   const filterValue = value.toLowerCase();
  //   return this.contractData2.filter(option =>
  //     option.office_rep_name.toLowerCase().includes(filterValue)
  //   );
  // }

  private _filterissueSeller(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.issue_seller_name.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
  }


  selected_name(option: any) {
    if (!option || !option.id) {
      return;
    }

    this.issueid = option.id;
    this.isExistingSeller = true;

    this.service.getIssuesellersentry(parseInt(option.id)).subscribe((data) => {
      if (data.length > 0) {
        const seller = data[0];

        this.issuesellerentryForm.patchValue({
          issuesellername: seller.name,
          englishIssueSellerName: seller.eng_issueSellerName,
          address1: seller.address,
          pincode: seller.pincode,
          country: seller.country,
          state: seller.state,
          district: seller.district,
          edistricts: seller.eng_districts,
          taluka: seller.taluka,
          mnumber: seller.mobile_no,
          email: seller.email,
          landline_no: seller.landline_no,
          dob: seller.dateofbirth,
          gstno: seller.gst_no,
          panno: seller.pan_no,
          depositamt: seller.deposit_amt,
          opening_bal: seller.opening_bal,
          option: seller.issueSellerType,
        });

        this.selectedCity = seller.district;
        this.selectedState = seller.state;
        this.selectedTaluka = seller.taluka;

        this.select(seller.issueSellerType);
        this.getcountryforupdate(seller.country, seller.district);
      }
    });
  }


  action(row: any) {
    if (row.operation === 'updated') {
      //this.update(row); // This is your update call to API
      this.yourMessage.push('success', 'updated successfully'); // Show update success notification
      this.yourMessage = []; // make sure you empty it
    }

    if (row.operation === 'deleted') {
      //this.delete(row.id); // This is your delete call to API
      this.yourMessage.push('success', 'deleted successfully'); // Show delete success notification
      this.yourMessage = []; // make sure you empty it
    }
  }
  getcountryforupdate(id: any, districtId: any) {
    let country = this.countries.find((a) => a.country_name == id);
    if (country != undefined) {
      this.service.getState(country['country_code']).subscribe((data) => {
        this.states = data;
        this.getStateForUpdate(this.selectedState, districtId)
      });

    } else {
    }
  }
  getStateForUpdate(id: any, districtId: any) {
    let state = this.states.find((a) => a.state_name == id);
    if (state != undefined) {
      if (state.state_name != 'Maharashtra' || state.state_name != 'महाराष्ट्र') {
        this.showigst = true;
      } else {
        this.showigst = false;
      }

      this.service.getDistrict(parseInt(state['state_id'])).subscribe((data) => {
        this.cities = data;
        // this.selectedCity = this.cities['district_name'];
        this.getDistrictsForUpdate(districtId);
      });
    }
  }

  getRepNames(event: any) {
    if (event.target.value != "") {
      this.filterrep = this.GetOffRep.filter((data: any) =>
        data.rep_name.toLowerCase().includes(event.target.value.toLowerCase())
      )
    } else {
      this.filterrep = this.GetOffRep
    }
  }


  getDistrictsForUpdate(id: any) {
    console.log(id);
    let district = this.cities.find((a) => a.district_name == id);
    if (district != undefined) {
      const req = {
        "district_id": [district['district_id']]
      }
      this.service.getTaluka1(req).subscribe((data) => {
        this.talukas = data;
        // this.selectedTaluka = this.talukas['taluka_name'];
        console.log("T=" + this.talukas)
        console.log("C=" + this.cities)
      });
    }
  }
  displayItemId(advt: any) {
    this.demo1TabIndex = 5 % 12;
    this.demo1BtnClick();

    this.pendingAdvtData = advt;

    const req = { date: advt.voucher_date };

    this.service.getReceiptnumber1(req).subscribe((data: any) => {
      this.autogeneratedno = data;
      console.log("Autogenerated No from backend:", this.autogeneratedno);

      if (this.autogeneratedno && Array.isArray(this.autogeneratedno) && this.autogeneratedno.length > 0) {
        const rcpt_no = this.autogeneratedno[0].receipt_no;

        const today1 = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN');

        this.advtpymtrecptform.patchValue({
          crdtvno: advt.voucher_no,
          date: today1,
          repname: advt.rep_name,
          advtname: advt.advtName,
          crdtvamt: advt.remaining_amt,
          cheque_no: advt.cheque_no,
          chequeDate: advt.chequeDate,
          branch_name: advt.branch_name,
          recptno: rcpt_no,
          recptdate: advt.voucher_date,
          seamt: advt.seamt,
          balamt: advt.balamt
        });

        console.log("Final Receipt No (from backend):", rcpt_no);
      } else {
        console.error("No valid receipt number returned from backend.");
      }
    });
  }

  // demo1BtnClick() {
  //   throw new Error('Method not implemented.');
  // }

  onDeliveryModeChange(selectedModes: string[] | string) {
    // Convert single value to array for consistency
    if (!Array.isArray(selectedModes)) {
      selectedModes = selectedModes ? [selectedModes] : [];
    }

    // 1️⃣ Filter Distributor List
    if (!selectedModes || selectedModes.length === 0) {
      this.filteredDistributorList = [];
    } else if (selectedModes.includes('all')) {
      this.filteredDistributorList = this.distributorList.slice(); // all distributors
    } else {
      this.filteredDistributorList = this.distributorList.filter(rep =>
        selectedModes.includes(rep.delivery_mode)
      );
    }

    // Reset the distributor input so autocomplete reloads
    const distributorControl = this.issueForm.get('distributionRepresentativeId');
    if (distributorControl) {
      distributorControl.reset();

      // Re-bind distributor autocomplete options
      this.filteredOptions6 = distributorControl.valueChanges.pipe(
        startWith(distributorControl.value || ''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => (name ? this._filter11(name) : this.filteredDistributorList.slice()))
      );
    }

    // 2️⃣ Re-bind Distribution Mode autocomplete options
    const distModeControl = this.issueForm.get('distributionMode');
    if (distModeControl) {
      distModeControl.reset();

      this.filteredOptions7 = distModeControl.valueChanges.pipe(
        startWith(distModeControl.value || ''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => (name ? this._filter22(name) : this.distributionModeList.slice()))
      );
    }
  }
  onDeliveryModeChange1(selectedModes: string[] | string) {
    // Convert single value to array for consistency
    if (!Array.isArray(selectedModes)) {
      selectedModes = selectedModes ? [selectedModes] : [];
    }

    // 1️⃣ Filter Distributor List
    if (!selectedModes || selectedModes.length === 0) {
      this.filteredDistributorList = [];
    } else if (selectedModes.includes('all')) {
      this.filteredDistributorList = this.distributorList.slice(); // all distributors
    } else {
      this.filteredDistributorList = this.distributorList.filter(rep =>
        selectedModes.includes(rep.delivery_mode)
      );
    }

    // Reset the distributor input so autocomplete reloads
    const distributorControl = this.issueForm.get('distributionRepresentativeId');
    if (distributorControl) {
      distributorControl.reset();

      // Re-bind distributor autocomplete options
      this.filteredOptions6 = distributorControl.valueChanges.pipe(
        startWith(distributorControl.value || ''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => (name ? this._filter11(name) : this.filteredDistributorList.slice()))
      );
    }

    // 2️⃣ Re-bind Distribution Mode autocomplete options
    const distModeControl = this.issueForm.get('distributionMode');
    if (distModeControl) {
      distModeControl.reset();

      this.filteredOptions7 = distModeControl.valueChanges.pipe(
        startWith(distModeControl.value || ''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => (name ? this._filter22(name) : this.distributionModeList.slice()))
      );
    }
  }


  selectedDeliveryModes: string[] = [];

  toggleAllSelectionde() {
    this.allSelected = !this.allSelected;

    if (this.allSelected) {
      // Select all delivery modes from backend
      this.selectedDeliveryModes = this.delivery_mode.map(rep => rep.delivery_mode);
    } else {
      // Clear all
      this.selectedDeliveryModes = [];
    }

    // Update form control
    this.issueForm.get('deliveryModeId')?.setValue(this.selectedDeliveryModes);

    // Call your filter logic again
    this.applyFilter();
  }

  onDeliveryModeChange2(selectedModes: string[]) {
    this.selectedDeliveryModes = selectedModes;

    // Check if all options are selected manually
    this.allSelected = this.selectedDeliveryModes.length === this.delivery_mode.length;

    this.applyFilter();
  }

  isSelected1(mode: string): boolean {
    return this.selectedDeliveryModes.includes(mode);
  }

  // Your existing filter logic (common function)
  applyFilter() {
    this.filteredDistributorList = this.distributorList.filter(rep =>
      this.selectedDeliveryModes.includes(rep.delivery_mode)
    );

    this.filteredOptions6 = this.issueForm.get('distributionRepresentativeId').valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value?.name)),
      map(name => (name ? this._filter11(name) : this.filteredDistributorList.slice()))
    );

    this.filteredOptions7 = this.issueForm.get('distributionMode').valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value?.name)),
      map(name => name ? this._filter22(name) : this.distributionModeList.slice())
    );
  }

  // onDeliveryModeChange1(selectedModes: string[] | string) {
  //   // Convert single value to array for consistency
  //   if (!Array.isArray(selectedModes)) {
  //     selectedModes = selectedModes ? [selectedModes] : [];
  //   }

  //   // 1️⃣ Filter Distributor List
  //   if (!selectedModes || selectedModes.length === 0) {
  //     this.filteredDistributorList = [];
  //   } else if (selectedModes.includes('all')) {
  //     this.filteredDistributorList = this.distributorList.slice(); // all distributors
  //   } else {
  //     this.filteredDistributorList = this.distributorList.filter(rep =>
  //       selectedModes.includes(rep.delivery_mode)
  //     );
  //   }

  //   // Reset the distributor input so autocomplete reloads
  //   const distributorControl = this.issueForm.get('distributionRepresentativeId');
  //   if (distributorControl) {
  //     distributorControl.reset();

  //     // Re-bind distributor autocomplete options
  //     this.filteredOptions6 = distributorControl.valueChanges.pipe(
  //       startWith(distributorControl.value || ''),
  //       map(value => (typeof value === 'string' ? value : value?.name)),
  //       map(name => (name ? this._filter11(name) : this.filteredDistributorList.slice()))
  //     );
  //   }

  //   // 2️⃣ Re-bind Distribution Mode autocomplete options
  //   const distModeControl = this.issueForm.get('distributionMode');
  //   if (distModeControl) {
  //     distModeControl.reset();

  //     this.filteredOptions7 = distModeControl.valueChanges.pipe(
  //       startWith(distModeControl.value || ''),
  //       map(value => (typeof value === 'string' ? value : value?.name)),
  //       map(name => (name ? this._filter22(name) : this.distributionModeList.slice()))
  //     );
  //   }
  // }
  selectedModes2: string[] = [];
  toggleAllSelectiondpl(event: Event) {
    event.stopPropagation(); // prevent selectionChange from firing

    this.filteredOptions7.subscribe((options: any[]) => {
      if (this.selectedModes2.length === options.length) {
        this.selectedModes2 = [];
      } else {
        this.selectedModes2 = options.map(x => x.name); // ✅ corrected
      }

      this.issueForm.get('distributionModes')?.setValue(this.selectedModes2);
      this.onDeliveryModeChange3(this.selectedModes2);
    });
  }

  resetDistributionModeModes1() {
    this.selectedModes2 = [];
    this.issueForm.get('distributionModes')?.reset();
    this.FilteredsubDistributionModeData = [];
  }

  onDeliveryModeChange3(selectedModes: string[]) {
    debugger
    if (!selectedModes) return;

    // If "All" is selected → replace with full backend list
    if (selectedModes.includes('all')) {
      selectedModes = this.distributionModeList.map(m => m.name);
    }

    // Call backend with selected modes
    this.service.getsubdistmodeissueseller(selectedModes).subscribe((data) => {
      this.FilteredsubDistributionModeData = data;

      // Update autocomplete for sub modes
      this.filteredOptions28 = this.issueForm.get('deliverySubModeId')!.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name =>
          name
            ? this._filterSubModes(name, this.FilteredsubDistributionModeData)
            : this.FilteredsubDistributionModeData.slice()
        )
      );
    });
  }

  onDeliveryModeChanged(selectedModes: string[]) {
    debugger;

    // If "All" is selected → replace with full backend list
    if (selectedModes.includes('all')) {
      selectedModes = this.distributionModeList.map(m => m.name);
    }

    // Call backend with selected modes (array)
    this.service.getsubdistmodeissue(selectedModes).subscribe((data) => {
      this.FilteredsubDistributionModeData = data;

      // Update autocomplete with received sub modes
      this.filteredOptions28 = this.issueForm.get('deliverySubModeId')!.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name =>
          name
            ? this._filterSubModes(name, this.FilteredsubDistributionModeData)
            : this.FilteredsubDistributionModeData.slice()
        )
      );
    });
  }


  // Filter method
  private _filter11(name: any): any[] {
    const filterValue = name.toLowerCase();
    return this.filteredDistributorList.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  private _filterSubModes(name: string, list: any[]): any[] {
    const filterValue = name.toLowerCase();
    return list.filter(option => option.name.toLowerCase().includes(filterValue));
  }


  // Filter method
  private _filter22(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.distributionModeList.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
  }


  private _filter4(name: string): any[] {
    const filterValue = name;
    return this.issue_seller_name.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter28(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.FilteredsubDistributionModeData.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );

  }



  resetDistributionMode() {
    this.issueForm.get('distributionMode')?.reset();
    this.issueForm.get('deliverySubModeId')?.reset();
    this.FilteredsubDistributionModeData = [];
    this.filteredOptions28 = of([]); // Clear submode options
  }

  searchbookselname() {
    this.bookselnamedata1 = [];  // Clear the previous data
    const request = {
      "req1": this.issueselForm.value
    }

    this.service.getissueSelSpecificData(request).subscribe((data) => {
      this.getallVouchersData = data;  // Assign the new data
      this.priceTotal = 0
      this.commissionTotal = 0
      this.remainingTotal = 0
      for (let data1 of this.getallVouchersData) {
        this.priceTotal += parseInt(data1.price) || 0;
        this.commissionTotal += parseInt(data1.commission) || 0;
        // this.remainingTotal += parseInt(data1.remaining_amt) || 0;

      }
    },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  newval: any = 0;
  addadvtpymtrcpt() {
    let data = {
      date: this.advtpymtrecptform.get('date').value,
      crdtvno: this.advtpymtrecptform.get('crdtvno').value,
      recptdate: this.advtpymtrecptform.get('recptdate').value,
      repname: this.advtpymtrecptform.get('repname').value,
      recptno: this.advtpymtrecptform.get('recptno').value,
      crdtvamt: this.advtpymtrecptform.get('crdtvamt').value,
      seamt: this.advtpymtrecptform.get('seamt').value,
      advtname: this.advtpymtrecptform.get('advtname').value,
      balamt: this.advtpymtrecptform.get('balamt').value,
      // booking_no : book.booking_no,
      // billno: this.booksellernamedata[0]['invoice_no'],
      // value: this.val1,

    };
    console.log(data, "Seamt new")
    // let newval = this.advtpymtrecptform.get('seamt').value;

    console.log(this.advtInvoicePymtRcptData, " this.advtInvoicePymtRcptData")
    this.dialog.open(IssueSellerInvoicePaymentReceiptComponent, {

      data: {
        data: data,
        pendingAdvtData: this.pendingAdvtData,
        advtInvoicePymtRcptData: this.advtInvoicePymtRcptData,
        advtInvoicePricePerIssue: this.advtInvoicePricePerIssue,
        advtname: this.advtpymtrecptform.get('advtnamesearch').value,
        // billno: this.booksellernamedata[0]['invoice_no'],
        val: data['seamt'],
        newval: this.newval,
        invoicenumberlist: this.arraynew

      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
    debugger;
    console.log(data, "new valuw is")
    // this.dialog.closeAll();
  }


  // repnames = '';
  // getrep(event) {
  //   // console.log(event.value.length);
  //   if (event.value.length <= 1) {
  //     this.person_name = event.value[0];
  //     // console.log(this.person_name);
  //   } else {
  //     this.person_name = 'प्रतिनिधीनुसार';
  //   }
  //   this.repnames = event.value;
  //   // this.filteredLabelDispatchData();
  // }


  reset_repnames() {
    this.repnames = '';
    this.generateform.get('rep').reset();
    this.filteredLabelDispatchData();
  }
  reset_taluka_names() {
    this.taluka_names = '';
    this.generateform.get('talukaname').reset();
    this.filteredLabelDispatchData();
  }

  reset_district_names() {
    this.district_names = '';
    this.generateform.get('districtname').reset();
    this.filteredLabelDispatchData();
  }

  reset_state_names() {
    this.state_names = '';
    this.generateform.get('statename').reset();
    this.filteredLabelDispatchData();
  }

  reset_country_names() {
    this.country_names = '';
    this.generateform.get('countryname').reset();
    this.filteredLabelDispatchData();
  }

  // reset_sub_types() {
  //   this.sub_types = '';
  //   this.generateform.get('subtype').reset();
  //   if (this.sub_types == '') {
  //     this.FilteredlabelsforDispatch = this.labelsforDispatch;
  //   }
  // }

  reset_sub_names() {
    this.sub_names = '';
    this.generateform.get('subname').reset();
    this.filteredLabelDispatchData();
  }

  reset_pincodes() {
    this.pincodes = '';
    this.generateform.get('talukaname').reset();
    this.filteredLabelDispatchData();
  }

  // repnames = '';
  getrep(event) {
    // console.log(event.value.length);
    if (event.value.length <= 1) {
      this.person_name = event.value[0];
      // console.log(this.person_name);
    } else {
      this.person_name = 'प्रतिनिधीनुसार';
    }
    this.repnames = event.value;
    // this.filteredLabelDispatchData();
  }


  subdismode = '';
  getsubdismode(event) {

    // console.log('LabelsSubDisModes', this.LabelsSubDisModes);
    this.subdismode = event.value;
    this.sub_mode = this.subdismode;
    // for (
    //   let index = 0;
    //   index < Object.keys(this.LabelsSubDisModes).length;
    //   index++
    // ) {
    //   if (this.subdismode == this.LabelsSubDisModes[index]['sub_dis_mode']) {
    //     this.sub_mode = this.LabelsSubDisModes[index]['sub_dis_mode'];
    //     this.dismode1 = this.LabelsSubDisModes[index]['dis_mode'];
    //   }
    // }
    if (this.subdismode != '' && this.dismode1 != '') {
      this.FilteredlabelsforPostStatement = this.labelsforDispatch.filter(
        (a) =>
          a['dis_sub_mode'] == this.subdismode && a['dis_mode'] == this.dismode1
      );
      this.getFilteredlabelslistfordispatch();
      // console.log(
      //   'FilteredlabelsforPostStatement',
      //   this.FilteredlabelsforPostStatement
      // );
    }
    if (event.value == "जी.पी.ओ") {
      let obj = this.subdistmode.find((x: any) => x.dis_sub_mode === event.value);


      this.distributionForm.patchValue({
        vajan: obj.vajan,
        tapalrate: obj.rate,
      })
    } else {
      this.distributionForm.patchValue({
        vajan: "",
        tapalrate: "",
      })
    }

  }

  disrepnames = '';
  // getdistributionrep(event) {

  //   this.dist_rep_name = event.value
  //   // console.log(event.value.length);
  //   if (event.value.length <= 1) {
  //     this.person_name = event.value[0];
  //     // console.log(this.person_name);
  //   } else {
  //     this.person_name = 'प्रतिनिधीनुसार';
  //   }
  //   this.disrepnames = event.value;
  //   if (this.disrepnames != '') {
  //     this.FilteredlabelsforDispatch = this.labelsforDispatch.filter((a) => {
  //       return (
  //         this.disrepnames.includes(a['distribution_rep']) &&
  //         a['delivery_mode'] === 'हस्ते'
  //       );
  //     });
  //     this.getFilteredlabelslistfordispatch();
  //   }
  // }

  getbookrcptStartDate = '';
  getbookrcptEndDate = '';
  getBookReceiptDateRange() {
    if (
      this.generateform.get('start').value != null &&
      this.generateform.get('end').value != null
    ) {
      this.getbookrcptStartDate = formatDate(
        new Date(this.generateform.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.getbookrcptEndDate = formatDate(
        new Date(this.generateform.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      // this.filteredLabelDispatchData();
    }
  }


  title1 = '';
  get_titles(event) {
    this.title1 = event.value;
    // console.log(sub_name);
    // this.filteredLabelDispatchData();
  }

  district_names = '';
  getdistrictname(event) {
    this.district_names = event.value;

  }

  country_names = '';
  getcountryname(event) {
    this.country_names = event.value;
    console.log(this.country_names);
    // this.filteredLabelDispatchData();
  }

  officerepnames = '';
  getofficerep(event) {
    this.officerepnames = event.value;
    // this.filteredLabelDispatchData();
  }

  // sub_types = '';
  // getsubtypes(event) {
  //   this.sub_types = event.value;
  //   if (this.sub_types != '') {
  //     this.FilteredlabelsforDispatch = this.labelsforDispatch.filter((a) => {
  //       return this.sub_types.includes(a['Subscription_Type']);
  //     });
  //   }
  // }

  sub_names = '';
  getsubnames(event) {
    this.sub_names = event.value;
    // console.log(sub_name);
    // this.filteredLabelDispatchData();
  }




  taluka_names = '';
  gettalukaname(event) {
    if (event.value != "ALL") {
      this.pindcodelist = []
    }



    this.taluka_names = event.value;
    this.filteredLabelDispatchData();
    this.service.pincodebttaluka(this.taluka_names).subscribe((data) => {
      this.pindcodelist = data
    });
  }
  filteredLabelDispatchData(): void {
    debugger;
    this.FilteredlabelsforDispatch = [...this.labelsforDispatch];

    this.FilteredlabelsforDispatch = this.FilteredlabelsforDispatch.filter(
      (item, index, self) =>
        index === self.findIndex(t => t.subno === item.subno)
    );

    console.log('FilteredlabelsforDispatch:', this.FilteredlabelsforDispatch);
  }




  reset_office_rep_names() {
    this.officerepnames = '';
    this.generateform.get('officerep').reset();
    this.filteredLabelDispatchData();
  }

  mode_names = '';
  getmode_name(event) {
    this.mode_names = event.value;
    // this.filteredLabelDispatchData();
  }
  reset_delivery_mode_names() {
    this.mode_names = '';
    this.generateform.get('delivery_mode_name').reset();
    this.filteredData();
  }
  filteredData() {
    if (
      (this.getbookrcptStartDate != '' && this.getbookrcptEndDate != '') ||
      // this.title1 != '' ||
      this.state_names != '' ||
      this.sub_names != '' ||
      // this.sub_types != '' ||
      this.country_names != '' ||
      this.district_names != '' ||
      this.taluka_names != '' ||
      this.pincodes != '' ||
      this.repnames != '' ||
      this.officerepnames != '' ||
      this.mode_names != ''
    ) {
      this.FilteredlabelsforDispatch = this.labelsforDispatch.filter((a) => {
        let dateCondition = true;

        if (this.getbookrcptStartDate != '' && this.getbookrcptEndDate != '') {
          dateCondition =
            new Date(a['entry_date']) >= new Date(this.getbookrcptStartDate) &&
            new Date(a['entry_date']) <= new Date(this.getbookrcptEndDate);
        }

        let titleCondition = true;
        if (this.title1 != '') {
          titleCondition = this.title1.includes(a['title']);
        }

        let stateCondition = true;
        if (this.state_names != '') {
          stateCondition = this.state_names.includes(a['state']);
        }

        let subCondition = true;
        if (this.sub_names != '') {
          subCondition = this.sub_names.includes(a['sub']);
        }

        // let subTypeCondition = true;
        // if (this.sub_types != '') {
        //   subTypeCondition = this.sub_types.includes(a['Subscription_Type']);
        // }

        let countryCondition = true;
        if (this.country_names != '') {
          countryCondition = this.country_names.includes(a['country']);
        }

        let distCondition = true;
        if (this.district_names != '') {
          distCondition = this.district_names.includes(a['district']);
        }

        let talukaCondition = true;
        if (this.taluka_names != '') {
          talukaCondition = this.taluka_names.includes(a['taluka']);
        }

        let pincodesCondition = true;
        if (this.pincodes != '') {
          pincodesCondition = this.pincodes.includes(a['pincode']);
        }

        let repnamesCondition = true;
        if (this.repnames != '') {
          repnamesCondition = this.repnames.includes(a['rep_name']);
        }

        let officerepnamesCondition = true;
        if (this.officerepnames != '') {
          officerepnamesCondition = this.officerepnames.includes(a['office_rep_name']);
        }

        let modetypeCondition = true;
        if (this.mode_names != '') {
          modetypeCondition = this.mode_names.includes(a['delivery_mode']);
          // this.mode_names.includes(a['delivery_mode'])
        }

        // Add more conditions for other fields as needed

        return (
          dateCondition &&
          titleCondition &&
          stateCondition &&
          subCondition &&
          // subTypeCondition &&
          countryCondition &&
          distCondition &&
          talukaCondition &&
          pincodesCondition &&
          repnamesCondition &&
          officerepnamesCondition &&
          modetypeCondition
          // Add more conditions here
        );
        // Add more conditions here
      });
    } else {
      // Handle other cases where no specific filters are applied
      this.FilteredlabelsforDispatch = this.labelsforDispatch;
    }
    console.log('FilteredlabelsforDispatch', this.FilteredlabelsforDispatch);
  }

  // reset_titles() {
  //   this.title1 = '';
  //   this.generateform.get('title').reset();
  //   this.filteredLabelDispatchData();
  // }

  show_mob_no = '';
  show_mob_no_hide = false;
  getmob_no(event) {
    // console.log(event.value);
    this.show_mob_no = event.value;
    if (this.show_mob_no == 'yes') {
      this.show_mob_no_hide = true;
    } else if (this.show_mob_no == 'no') {
      this.show_mob_no_hide = false;
    }
  }


  getIsCustomer(e: any) {
    this.iscustomer = e.value
  }

  pincodes = '';
  getpincode(event) {
    this.pincodes = event.value;
    // this.filteredLabelDispatchData();
  }


  // myFilter = (d: Date | null): boolean => {
  //   const day = (d || new Date()).getDay();
  //   // Prevent Saturday and Sunday from being selected.
  //   return (
  //     day !== 1 && day !== 2 && day !== 3 && day !== 4 && day !== 5 && day !== 6
  //   );
  // };

  state_names = '';
  getstatename(event) {
    console.log(event.value);

    this.state_names = event.value;
    let state = this.states.find((a) =>
      this.state_names.includes(a.state_name)
    );
    console.log(state);

    this.service.getDistrict(parseInt(state['state_id'])).subscribe((data) => {
      this.cities = data;
      // this.selectedCity = this.cities['district_name'];
      // console.log('cities', this.cities);
    });


  }
  getLabelforDispatch() {
    // let date = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    let date = new Date();
    let weekfirstday = date.getDate() - date.getDay();
    let prevfirestday = date.getDate() - date.getDay();
    // console.log(
    //   formatDate(date.setDate(weekfirstday), 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
    // );

    // console.log(
    //   formatDate(
    //     date.setDate(weekfirstday - 7),
    //     'yyyy-MM-dd',
    //     'en-IN',
    //     'GMT+0530'
    //   )
    // );

    // this.service
    //   .getlabelsforDispatch(
    //     formatDate(
    //       date.setDate(weekfirstday),
    //       'yyyy-MM-dd',
    //       'en-IN',
    //       'GMT+0530'
    //     ),
    //     formatDate(
    //       date.setDate(weekfirstday - 7),
    //       'yyyy-MM-dd',
    //       'en-IN',
    //       'GMT+0530'
    //     )
    //   )
    //   .subscribe((data) => {
    //     console.log(data);
    //     this.labelsforDispatch = data;
    //     this.FilteredlabelsforDispatch = this.labelsforDispatch;
    //     this.getDatafromLabelsDispatch();
    //   });

    this.getLabelforDispatchData(
      //   formatDate(date.setDate(weekfirstday), 'yyyy-MM-dd', 'en-IN', 'GMT+0530'),
      //   formatDate(
      //     date.setDate(prevfirestday - 7),
      //     'yyyy-MM-dd',
      //     'en-IN',
      //     'GMT+0530'
      //   )
    );
  }

  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    return (
      day !== 1 && day !== 2 && day !== 3 && day !== 4 && day !== 5 && day !== 6
    );
  };


  issuedate = '';
  issuedate_registration = '';
  weekfirstday_registration = '';
  getIssueDate(event) {
    console.log(event.value.toString());

    // Extract and filter issue selection
    this.getDates = event.value;
    this.getDates = this.getDates.filter((a) => a !== 'all');
    this.stringdates = this.getDates.toString();

    // Extract details from the first selected issue
    const firstIssue = this.getDates[0].toString().split(',');
    const issueDate = firstIssue[0];
    this.issueName1 = firstIssue[1];
    this.issueNameIds = firstIssue[2];
    this.issuePrice = firstIssue[3];

    // Set form values
    this.issueForm.patchValue({
      issueSellerDate: issueDate,
      issueSellerPrice: this.issuePrice
    });

    // Save for later use
    this.issuedate = issueDate;
    this.issuedate_registration = issueDate;

    // Filter labels for dispatch using issueDate only
    this.FilteredgetSubDetailsData = this.labelsforDispatch.filter((a) => {
      return new Date(a['entry_date']) === new Date(this.issuedate);
    });

    this.calculatesubdetailstotal();
  }


  getLabelforDispatchData(): void {
    const formValues = this.generateform.value;

    const filterPayload = {
      country: Array.isArray(formValues.countryname) ? formValues.countryname[0] : formValues.countryname || '',
      state: Array.isArray(formValues.statename) ? formValues.statename[0] : formValues.statename || '',
      district: Array.isArray(formValues.districtname) ? formValues.districtname.join(',') : formValues.districtname || '',
      taluka: Array.isArray(formValues.talukaname) ? formValues.talukaname[0] : formValues.talukaname || '',
      rep_name: Array.isArray(formValues.rep_name) ? formValues.rep_name[0] : formValues.rep_name || '',
      office_rep_name: Array.isArray(formValues.off_rep_name) ? formValues.off_rep_name[0] : formValues.off_rep_name || '',
      delivery_mode: formValues.deliveryModeId || '',
      category: Array.isArray(formValues.issueCatregoryId) ? formValues.issueCatregoryId[0] : formValues.issueCatregoryId || ''
    };

    console.log("Filter Payload: ", filterPayload);

    this.service.getlabelsforIssueSellerDispatch(filterPayload).subscribe((data) => {
      // Set the full list
      this.labelsforDispatch = data;

      // Filter duplicates based on subno
      this.FilteredlabelsforDispatch = this.labelsforDispatch.filter(
        (item, index, self) =>
          index === self.findIndex(t => t.subno === item.subno)
      );

      // Optional: set other lists from filtered data
      this.FilteredlabelsforPostStatement = [...this.FilteredlabelsforDispatch];

      // Log the filtered data
      console.log('FilteredlabelsforDispatch:', this.FilteredlabelsforDispatch);

      // Proceed with dependent methods
      this.getDatafromLabelsDispatch();
      this.getFilteredlabelslistfordispatch();
      this.openAddressLabelDialog();
    });

    this.databyfilter();
  }





  FilteredLabelsListForDispatch = [];
  getFilteredlabelslistfordispatch() {
    if (
      this.disrepnames != '' &&
      this.subdismode != '' &&
      this.dismode1 != ''
    ) {
      this.FilteredLabelsListForDispatch = this.labelsforDispatch.filter(
        (a) => {
          return (
            this.disrepnames.includes(a['distribution_rep']) &&
            a['dis_sub_mode'] == this.subdismode &&
            a['dis_mode'] == this.dismode1 &&
            a['delivery_mode'] === 'हस्ते'
          );
        }
      );
      // console.log(this.FilteredLabelsListForDispatch);
    } else if (
      this.disrepnames != '' &&
      this.dismode1 != '' &&
      this.subdismode == ''
    ) {
      this.FilteredLabelsListForDispatch = this.labelsforDispatch.filter(
        (a) => {
          return (
            this.disrepnames.includes(a['distribution_rep']) &&
            a['dis_mode'] == this.dismode1 &&
            a['delivery_mode'] === 'हस्ते'
          );
        }
      );
      // console.log(this.FilteredLabelsListForDispatch);
    } else if (
      this.disrepnames != '' &&
      this.dismode1 == '' &&
      this.subdismode == ''
    ) {
      this.FilteredLabelsListForDispatch = this.labelsforDispatch.filter(
        (a) => {
          return (
            this.disrepnames.includes(a['distribution_rep']) &&
            a['delivery_mode'] === 'हस्ते'
          );
        }
      );
      // console.log(this.FilteredLabelsListForDispatch);
    } else {
      this.FilteredLabelsListForDispatch = this.labelsforDispatch.filter(
        (a) => {
          return a['delivery_mode'] === 'हस्ते';
        }
      );
      // console.log(this.FilteredLabelsListForDispatch);
    }
  }

  databyfilter() {
    const req1: any = {
      // "preweekfirstday": this.issuedate,
      "dist_type": this.dis_mode,
      "sub_dist_type": this.sub_mode,
      "dist_rep": this.dist_rep_name,
      "dis_country": this.country_names,
      "dis_state": this.state_names,
      "rep_name": this.repnames,
      "off_rep_name": this.officerepnames,
      "district": this.district_names,
      "dis_tal": this.taluka_names,
      "delivery_mode": this.dev_mode,
      "dis_pin": this.pincodes,
      // "title": this.title1,
      // "subtype": this.sub_types,
    }

    this.service
      .getissuenewapi1(this.issuedate)
      .subscribe((res) => {
        this.disRepData = res;
        console.log(this.disRepData, "this. repdata");
      });
  }

  total_no_data = 0;
  calculatesubdetailstotal() {
    // this.dataSource = new MatTableDataSource(this.FilteredgetSubDetailsData);
    // this.dataSource.paginator = this.paginator;
    this.totalamountofsub = 0;
    this.totaldiscountofsub = 0;
    this.totalnetamtofsub = 0;
    this.totalrepcomofsub = 0;
    this.total_no_data = Object.keys(this.FilteredgetSubDetailsData).length;
    for (
      let index = 0;
      index < Object.keys(this.FilteredgetSubDetailsData).length;
      index++
    ) {
      this.totalamountofsub =
        this.totalamountofsub +
        parseInt(this.FilteredgetSubDetailsData[index]['total_amt']);
      this.totaldiscountofsub =
        this.totaldiscountofsub +
        parseInt(this.FilteredgetSubDetailsData[index]['discount']);
      this.totalnetamtofsub =
        this.totalnetamtofsub +
        parseInt(this.FilteredgetSubDetailsData[index]['net_amt']);
      this.totalrepcomofsub =
        this.totalrepcomofsub +
        parseInt(this.FilteredgetSubDetailsData[index]['rep_com_amt']);
    }
  }

  getOffRep() {

    this.service.getOffRepSub().subscribe((data: any) => {
      debugger
      console.log("represntive name", data);
      this.GetOffRep = (data as any);
      this.filterrep = (data as any);
    });
  }

  public demo1TabIndex = 0;
  public demo1BtnClick() {
    console.log("demo1BtnClick function triggered"); // Add this to verify
    const tabCount = 16;
    this.demo1TabIndex = (this.demo1TabIndex) % tabCount;
  }


  getentrybyrepname1() {
    this.service.getentrybyrepname1(this.repname).subscribe((res) => {
      this.getentrybyrepnamelist = res;
      console.log(res, "getentrybyrepnamelist");
    });
  }

  convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('-');
    return `${year}-${month}-${day}`;
  }

  // advtrcptsetvalue() {
  //   const dateString = this.pendingAdvtData['voucher_date'];
  //   const dateParts = dateString.split('-');
  //   const formattedDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
  //   const today = this.datePipe.transform(formattedDate, 'MM');

  //   let newg = 1;
  //   if (this.autogeneratedno && Array.isArray(this.autogeneratedno) && this.autogeneratedno.length > 0) {
  //     newg = this.autogeneratedno[0].rcpt_no + 1;
  //   }

  //   let rcpt_no = `ISR${today}000${newg}/${(formattedDate.getMonth() + 1 < 4
  //     ? (formattedDate.getFullYear() - 1).toString().slice(-2) +
  //     '-' +
  //     formattedDate.getFullYear().toString().slice(-2)
  //     : formattedDate.getFullYear().toString().slice(-2) +
  //     '-' +
  //     (formattedDate.getFullYear() + 1).toString().slice(-2))
  //     }`;

  //   this.advtpymtrecptform.get('recptno').setValue(rcpt_no);
  // }

  advtrcptsetvalue() {
    debugger;
    console.log("Setdata value:", this.pendingAdvtData);

    // Convert voucher date to required format
    let recdate = this.convertDateFormat(this.voucherdate);

    const req = {
      date: recdate
    };

    // Fetch receipt number from backend
    this.service.getIssueReceiptnumber(req).subscribe((data: any) => {
      this.autogeneratedno = data;
      console.log("Received data from backend:", this.autogeneratedno);

      // Check if a valid receipt number is returned
      if (this.autogeneratedno?.length > 0 && this.autogeneratedno[0].receipt_no) {
        const rcpt_no = this.autogeneratedno[0].receipt_no;
        console.log("Using receipt number from backend:", rcpt_no);

        // Set values in the receipt form
        const form = this.advtpymtrecptform;

        form.get('recptno')?.setValue(rcpt_no);

        const todayFormatted = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
        form.get('date')?.setValue(todayFormatted);

        form.get('crdtvno')?.setValue(this.pendingAdvtData.voucher_no);
        form.get('recptdate')?.setValue(this.pendingAdvtData.voucher_date);
        form.get('advtname')?.setValue(this.pendingAdvtData.advtName);
        form.get('crdtvamt')?.setValue(this.pendingAdvtData.remaining_amt);
        form.get('repname')?.setValue(this.pendingAdvtData.rep_name);

      } else {
        console.error("No valid receipt number received from backend");
      }
    });
  }


  advtInvoiceListData;
  advtInvoiceListData1;
  searchAdvtName0() {
    const req: any = {
      "name": this.advtpymtrecptform.value.advtnamesearch,

    }
    this.advtInvoiceListData1 = [];
    this.service.getAllIssueInvoicesForPymt(this.advtpymtrecptform.value.advtnamesearch).subscribe((res) => {

      // console.log(res);
      this.advtInvoiceListData1 = res;
      console.log(this.advtInvoiceListData1, "nan value")
    });

    setTimeout(() => {
      this.advtInvoiceListData = [];
      this.advtInvoiceListData = this.advtInvoiceListData1.filter(
        (a) => a.advt_name === this.name
      );
      // console.log(this.advtInvoiceListData);
    }, 700);
  }
searchAdvtName1() {
  this.getentrybyrepnamelist = [];

  const req: any = {
    name: this.advtpymtrecptform.value.advtnamesearch,
  };

  this.advtInvoiceListData1 = [];

  this.service.getAllIssueInvoicesForPymt(this.advtpymtrecptform.value.advtnamesearch)
    .subscribe((res: any[]) => {  // ✅ ensure 'res' is treated as an array
      const dataList = Array.isArray(res) ? res : [];

      this.getentrybyrepnamelist = dataList;

      console.log(this.getentrybyrepnamelist, "Invoice list");
    });

  // ✅ Your existing timeout logic remains
  setTimeout(() => {
    this.advtInvoiceListData = [];
    this.advtInvoiceListData = this.advtInvoiceListData1.filter(
      (a) => a.advt_name === this.name
    );
  }, 700);
}


  validmobile = false;
  validemail = false;
  validdob = false;
  validateMobile(event) {
    if (this.issuesellerentryForm.get('mnumber').valid) {
      this.validmobile = true;
    } else {
      this.validmobile = false;
    }
  }

  validateEmail(event) {
    if (this.issuesellerentryForm.get('email').valid) {
      this.validemail = true;
    } else {
      this.validemail = false;
    }
  }

  validatedob(event) {
    // console.log('event.target.value', event.target.value);
    // this.issuesellerentryForm
    //   .get('dob')
    //   .setValue(
    //     formatDate(
    //       new Date(event.target.value),
    //       'yyyy-MM-dd',
    //       'en-IN',
    //       'GMT+0530'
    //     )
    //   );
    if (this.issuesellerentryForm.get('dob').valid) {
      this.validdob = true;
    } else {
      this.validdob = false;
    }
  }

  getDates;
  stringdates;
  issueSellerDate: any
  issueName1: any
  issueNameIds: any
  issuePrice: any
  getAdvtDates(e) {
    console.log(e.value.toString());
    this.getDates = e.value;
    this.getDates = this.getDates.filter((a) => a != 'all');
    this.stringdates = this.getDates.toString();

    this.issueName1 = e.value.toString().split(",")[1];
    this.issueNameIds = e.value.toString().split(",")[2];
    this.issuePrice = e.value.toString().split(",")[3];
    this.issueForm.patchValue({
      issueSellerDate: e.value.toString().split(",")[0],
      issueSellerPrice: this.issuePrice
    })
    console.log(this.issueName1);
  }
  getAdvtDates1(e: any) {
    // Filter out 'ALL'
    let selectedDates = e.value.filter(item => item !== 'ALL');

    // If only one date is needed
    const firstDate = selectedDates.length ? selectedDates[0] : '';

    // Patch the form
    this.OutStandingForm.patchValue({
      issueDates: firstDate // now only the first date string
    });

    console.log('Selected Date for payload:', firstDate);
  }

  // Payload when submitting
  submitForm() {
    const formValue = this.OutStandingForm.value;

    const payload = {
      issue_name: formValue.issuename,
      issue_date: formValue.issueDates // this will now be a string like "2024-07-21"
    };

    console.log('Payload:', payload);
  }



  updateAfterDiscount(): void {
    const price = Number(this.issueForm.get('issueSellerPrice')?.value) || 0;
    const discount = Number(this.issueForm.get('discount_amt')?.value) || 0;
    const afterDiscount = price - discount;

    this.issueForm.patchValue({
      afterdistamt: afterDiscount
    }, { emitEvent: false });
  }

  getContractRepNames(event) {

    this.Advtremainingamt.patchValue({
      rep_name: event.source.value
    })

    this.contractReportRepName = event.source.value

  }



  getData;
  stringdata;
  getISN(e: any) {
    console.log(e.value.toString());
    this.getData = e.value;
    this.getData = this.getData.filter((a) => a != 'all');
    this.stringdata = this.getData.toString();
  }

  // addAdvt() {
  //   this.AdvtDetails.push({
  //     issue: this.issueName,
  //     issueSellerDate: this.issueForm.get('issueSellerDate').value,
  //     issueSellerPrice: this.issueForm.get('issueSellerPrice').value,
  //     issueSellerCopies: this.issueForm.get('issueSellerCopies').value,
  //     complementaryCopies: this.issueForm.get('complementaryCopies').value,
  //   });

  //   let percentage = this.advtCategorylist.find(issue => issue.category === this.issueName).percentage;
  //   this.issueForm.patchValue({
  //     gstPercentage: percentage

  //   })
  //   this.calculation(this.AdvtDetails);

  // }
  selectedItems1: any[] = [];
  selectAll1: boolean = false;

  isSelected(item: any): boolean {
    return this.selectedItems1.includes(item);
  }

  toggleItemSelection(item: any): void {
    const index = this.selectedItems1.indexOf(item);
    if (index > -1) {
      this.selectedItems1.splice(index, 1);
    } else {
      this.selectedItems1.push(item);
    }
    this.updateSelectAllState();
  }

  toggleSelectAll1(event: any): void {
    this.selectAll1 = event.target.checked;
    this.selectedItems1 = this.selectAll1 ? [...this.AdvtDetails] : [];
  }

  updateSelectAllState(): void {
    this.selectAll1 = this.selectedItems1.length === this.AdvtDetails.length;
  }

  deleteSelected(): void {
    this.AdvtDetails = this.AdvtDetails.filter(item => !this.selectedItems1.includes(item));
    this.selectedItems1 = [];
    this.selectAll1 = false;
  }



  discountAmt1: number = 0
  sumNetAmt: any
  amountV: any
  afterdiscount: Number = 0

  // addAdvt() {
  //   this.discountAmt1 = 0;
  //   this.issueCopies = 0;
  //   this.complementaryCopies1 = 0;
  //   this.sumNetAmt = 0;
  //   this.amountV = 0;

  //   const issueSellerDates = this.issueForm.get('issueNameId').value || [];
  //   const datesArray = Array.isArray(issueSellerDates) ? issueSellerDates : [issueSellerDates];

  //   datesArray.forEach(date => {
  //     const firstDate = date.split(',')[0].trim();
  //     const firstIssueName = date.split(',')[1].trim();

  //     let amount = 0;
  //     let disAmt = 0;
  //     this.issueSellerPrice1 = 0;

  //     const price = Number(this.issueForm.get('issueSellerPrice').value);
  //     const copies = Number(this.issueForm.get('issueSellerCopies').value);

  //     if (this.issueName === "विशेषांक") {
  //       let issuePrice = Number(this.issueForm.get('issueSellerPrice').value) - Number(this.issueForm.get('discount_amt').value);
  //       amount = Number(issuePrice) * Number(this.issueForm.get('issueSellerCopies').value);
  //       this.discountAmt1 = 0;
  //       this.amountV += amount;
  //       this.issueSellerPrice1 += amount;
  //       this.sumNetAmt += amount;

  //     } else {
  //       amount = price * copies;
  //       disAmt = amount * (Number(this.issueForm.get('discountPercentage').value) / 100);
  //       this.discountAmt1 += disAmt;
  //       this.amountV += amount;
  //       this.issueSellerPrice1 += amount;
  //       this.sumNetAmt += amount - disAmt;
  //     }

  //     this.issueCopies += copies;
  //     this.complementaryCopies1 += Number(this.issueForm.get('complementaryCopies').value);

  //     this.AdvtDetails.push({
  //       issue: this.issueName,
  //       issueSellerDate: `${firstDate} ${firstIssueName}`,
  //       issueSellerPrice: price,
  //       issueSellerCopies: copies,
  //       complementaryCopies: this.issueForm.get('complementaryCopies').value,
  //       discountPercentage: this.issueForm.get('discountPercentage').value,
  //       discount_amt: disAmt,
  //       amount_child: amount
  //     });
  //   });

  //   let percentage = this.advtCategorylist.find(issue => issue.category === this.issueName)?.percentage;

  //   const commonAmount = this.issueName === "विशेषांक" ? this.amountV : this.sumNetAmt;

  //   this.issueForm.patchValue({
  //     gstPercentage: percentage,
  //     discountAmount: this.discountAmt1,
  //     netAmount: commonAmount,
  //     totalAmount: commonAmount,
  //     amount: this.amountV
  //   });
  // }


  // calculation(data: any) {
  //   console.log("Issue Name", data[0].issue)
  //   let amount = 0;
  //   data.forEach((element: any) => {
  //     amount = Number(amount) + (Number(element.issueSellerPrice) * Number(element.issueSellerCopies));

  //   });
  //   this.issueForm.patchValue({
  //     amount: amount,
  //     // netAmount: amount,

  //   })
  // }
  addAdvt() {
    this.issueCopies = 0;
    this.complementaryCopies1 = 0;

    const issueSellerDates = this.issueForm.get('issueNameId').value || [];
    const datesArray = Array.isArray(issueSellerDates) ? issueSellerDates : [issueSellerDates];

    datesArray.forEach(date => {
      const firstDate = date[0];  // directly access array elements
      const firstIssueName = date[1]

      const price = Number(this.issueForm.get('issueSellerPrice').value);
      const copies = Number(this.issueForm.get('issueSellerCopies').value);
      const discountAmt = Number(this.issueForm.get('discount_amt').value);  // per copy
      const complementaryCopies = Number(this.issueForm.get('complementaryCopies').value);

      const issuePrice = price - discountAmt;
      const totalAmount = price * copies;                    // Total Amount
      const totalDiscount = discountAmt * copies;            // Total Discount
      const netAmount = totalAmount - totalDiscount;         // Net Amount

      this.afterdiscount = issuePrice;
      this.discountAmt1 = totalDiscount;

      this.issueCopies += copies;
      this.complementaryCopies1 += complementaryCopies;

      this.AdvtDetails.push({
        issue: this.issueName,
        issueSellerDate: `${firstDate} ${firstIssueName}`,
        issueSellerPrice: price,
        issueSellerCopies: copies,
        complementaryCopies: complementaryCopies,
        discountPercentage: 0,
        discount_amt: discountAmt,
        amount_child: totalAmount,
        afterdistamt: netAmount,
      });
    });

    // Calculate totals
    let totalAmountV = 0;         // Total gross amount
    let totalNetAmount = 0;       // Total after discount
    let totalDiscountAmt = 0;

    this.AdvtDetails.forEach(item => {
      totalAmountV += item.amount_child;
      totalDiscountAmt += item.discount_amt;
      totalNetAmount += item.afterdistamt;
    });

    const percentage = this.advtCategorylist.find(issue => issue.category === this.issueName)?.percentage;

    this.issueForm.patchValue({
      gstPercentage: percentage,
      discountAmount: totalDiscountAmt,
      amount: totalAmountV,         // Gross
      netAmount: totalNetAmount,    // Net
      totalAmount: totalNetAmount   // If GST not included
    });
  }




  calculation(data: any) {
    let amountV = 0;
    let netamount1 = 0;

    const discountAmt = Number(this.issueForm.get('discount_amt')?.value) || 0;

    data.forEach((element: any) => {
      const price = Number(element.issueSellerPrice);
      const copies = Number(element.issueSellerCopies);

      const issuePrice = price - discountAmt;
      amountV += price * copies;
      netamount1 += issuePrice * copies;
    });

    const discountAmount = 0;
    const netAmount = netamount1;
    const totalAmount = netamount1;

    this.issueForm.patchValue({
      amount: amountV,
      discountAmount: discountAmount,
      netAmount: netamount1,
      totalAmount: netamount1
    });
  }




  // discountCalculation() {
  //   // console.log(Number(this.issueForm.value.discountPercentage))
  //   let discountAmount = 0;
  //   if (this.issueForm.value.discountPercentage != '') {
  //     discountAmount = Number(discountAmount) + Number(this.issueForm.value.amount) * ((Number(this.issueForm.value.discountPercentage) / 100))
  //     let netAmount = Number(this.issueForm.value.amount) - Number(discountAmount);
  //     this.issueForm.patchValue({
  //       discountAmount: discountAmount,
  //       netAmount: netAmount,
  //       totalAmount: netAmount,

  //     })
  //   }
  // }
  gstCalculation() {
    if (this.issueForm.value.issueSellerGstType === 'INCLUDING') {
      let actualAmount = parseFloat((this.issueForm.value.netAmount / (1 + this.issueForm.value.gstPercentage / 100)).toFixed(4));
      let gstAmount = parseFloat((this.issueForm.value.netAmount - actualAmount).toFixed(4));

      this.issueForm.patchValue({
        gstAmount: gstAmount,
        withGstAmount: this.issueForm.value.netAmount,
        withoutGstAmount: actualAmount,
        totalAmount: this.issueForm.value.netAmount
      })
    } else if (this.issueForm.value.issueSellerGstType === 'EXCLUDING') {
      let gstAmount = Number(this.issueForm.value.netAmount) * (Number(this.issueForm.value.gstPercentage) / 100)
      let totalAmount = Number(this.issueForm.value.netAmount) + Number(gstAmount);
      this.issueForm.patchValue({
        gstAmount: gstAmount,
        withGstAmount: totalAmount,
        withoutGstAmount: this.issueForm.value.netAmount,
        totalAmount: totalAmount
      })
    } else {

      this.issueForm.patchValue({
        gstAmount: 0,
        withGstAmount: 0,
        withoutGstAmount: 0,
        totalAmount: this.issueForm.value.netAmount
      })
    }

  }
  deleteAdvt(i) {
    if (window.confirm('Do you really want to remove ?')) {
      this.AdvtDetails.splice(i, 1);
      this.calculation(this.AdvtDetails);
    }
  }
  update(item) {
    this.dialog.open(UpdateOfficeRepresentativeComponent, {
      data: {
        item: item,
        type: 'issue',
      },
    });
    this.service.getIssueWiseRep().subscribe((data) => {
      // console.log(data);
      this.issuewisereplist = data;
    });
  }

  option = false;
  select(val) {
    // console.log(event.value);
    if (val == 'agent') {
      this.option = true;
    } else {
      this.option = false;
    }
  }

  allSelected = false;
  @ViewChild('mySel') skillSel: MatSelect;

  toggleAllSelection() {
    this.allSelected = !this.allSelected; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelected) {
      this.skillSel.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel.close();
  }


  @ViewChild('mySel1') skillSel1: MatSelect;
  toggleAllSelection1() {
    this.allSelected = !this.allSelected; // to control select-unselect
    console.log(this.skillSel1.options);
    if (this.allSelected) {
      this.skillSel1.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel1.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel.close();
  }

  @ViewChild('isn') skillSel2: MatSelect;
  toggleAllSelectionISN() {
    this.allSelected = !this.allSelected; // to control select-unselect
    // console.log(this.skillSel2.options);
    if (this.allSelected) {
      this.skillSel2.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel2.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel.close();
  }

  getAdvtMagDetails() {
    this.advt_mag_name_details = [];
    // this.stateGroups = [];
    let abc;
    this.service.getAdvtMagNames().subscribe((data) => {
      console.log(data);
      for (let index = 0; index < Object.keys(data).length; index++) {
        console.log(data[index]);
        this.advt_mag_name_details.push({
          id: data[index]['id'],
          is_active: data[index]['is_active'],
          issue_name: data[index]['issue_name'],
          category: data[index]['category'],
          publishing_date: data[index]['publishing_date'].split(','),
        });

        if (index == 0) {
          console.log(
            data.filter((a) => a.category == data[index]['category'])
          );
        }

        // if (
        //   this.stateGroups.find((a) => a.category == data[index]['category']) ==
        //   undefined
        // ) {
        //   let mags = data.filter((a) => a.category == data[index]['category']);
        //   let mag_to_list = [];
        //   for (let index = 0; index < Object.keys(mags).length; index++) {
        //     mag_to_list.push(mags[index]['issue_name']);
        //   }
        //   this.stateGroups.push({
        //     category: data[index]['category'],
        //     details: mag_to_list,
        //   });
        // }
      }

      // console.log('Issue/Grantha || stategroup', this.stateGroups);
      //this.advt_mag_name_details = data
    });
  } //end of getAdvtMagDetails

  issueName;
  bookingdate;
  advtsizebyCategory;
  getFilterMagPublishDates = ['10-10-2021', ''];
  getMagIssueDatesandNames;
  discountAmtHideShow: boolean = false;
  discount_amt;
  // Add these at the top of the component


  getIssues(e: any) {
    console.log(e);
    this.issueName = e.value;
    this.selectedCategory = e.value;
    this.discountAmtHideShow = this.issueName === 'विशेषांक';

    // Optional discount logic
    if (this.discount_amt && this.issueSellerPrice) {
      this.issueSellerPrice = Number(this.issueSellerPrice) - Number(this.discount_amt);
    }

    // Load digital issue info (optional)
    this.service.getDigiIssueByCategory(e.value).subscribe((data) => {
      this.advtsizebyCategory = data;
    });

    // Load issue names and backup full list
    this.service.getAdvtDatesAndNames(e.value).subscribe((data) => {
      this.getMagIssueDatesandNames = data;
      this.allIssueDates = [...data];  // backup full list for filtering
      this.filteredIssueDates = [...data];  // initially show all
      console.log('Issue Dates and Names:', this.getMagIssueDatesandNames);
    });
  }

  onYearInputChange(input: string) {
    const years = input
      .split(',')
      .map((year) => year.trim())
      .filter((year) => /^\d{4}$/.test(year)); // Keep only valid 4-digit years

    if (years.length === 0) {
      this.filteredIssueDates = [...this.allIssueDates]; // Show all if no valid year
      return;
    }

    if (this.selectedCategory) {
      // 🔍 API-based filter
      this.service
        .filterIssuesByCategoryAndYears({ category: this.selectedCategory, years })
        .subscribe(
          (data) => {
            this.filteredIssueDates = data;
          },
          (error) => {
            console.error('Error fetching filtered issue dates:', error);
            this.filteredIssueDates = [];
          }
        );
    } else {
      // 🔍 Optional: Local filter if no API available
      this.filteredIssueDates = this.allIssueDates.filter((issue) => {
        const issueYear = new Date(issue.issueDate).getFullYear().toString();
        return years.includes(issueYear);
      });
    }
  }


  1(e) {
    console.log(e);
    this.issueName = e;
    this.service.getAdvtSizeByCategory(e).subscribe((data) => {
      this.advtsizebyCategory = data;
    });
    console.log(
      'advt_mag_name_details',
      this.advt_mag_name_details.filter((a) => a.issue_name == this.issueName)
    );
    this.service.getAdvtDatesAndNames(e).subscribe((data) => {
      this.getMagIssueDatesandNames = data;
      console.log('Issue Dates and Names:', this.getMagIssueDatesandNames);
    });
  }



  onGranthaChange(category: string) {
    this.selectedCategory = category;

    // Load all issues for the selected category
    this.service.getDigiIssueByCategory(category).subscribe((data) => {
      this.allIssueDates = data;
      this.filteredIssueDates = [...data]; // show all by default
    });
  }

  // onYearInputChange(input: string) {
  //   const years = input
  //     .split(',')
  //     .map((year) => year.trim())
  //     .filter((year) => /^\d{4}$/.test(year)); // ensure valid 4-digit years

  //   if (years.length === 0) {
  //     this.filteredIssueDates = [...this.allIssueDates]; // fallback to all
  //     return;
  //   }

  //   if (this.selectedCategory) {
  //     this.service
  //       .filterIssuesByCategoryAndYears({ category: this.selectedCategory, years })
  //       .subscribe((data) => {
  //         this.filteredIssueDates = data;
  //       });
  //   }
  // }

  // issueid;
  // save_issuesellerentry() {
  //   console.log(this.issuesellerentryForm.value)
  //   let issueseller = {
  //     issuesellername: this.issuesellerentryForm.get('issuesellername').value,
  //     address1: this.issuesellerentryForm.get('address1').value,
  //     pincode: this.issuesellerentryForm.get('pincode').value,
  //     country: this.issuesellerentryForm.get('country').value,
  //     state: this.issuesellerentryForm.get('state').value['state_name'],
  //     taluka: this.issuesellerentryForm.get('taluka').value,
  //     district: this.issuesellerentryForm.get('district').value['name'],
  //     mnumber: this.issuesellerentryForm.get('mnumber').value,
  //     landline_no: this.issuesellerentryForm.get('landline_no').value
  //       ? null
  //       : '',
  //     email: this.issuesellerentryForm.get('email').value,
  //     dob: this.issuesellerentryForm.get('dob').value,
  //     gstno: this.issuesellerentryForm.get('gstno').value,
  //     panno: this.issuesellerentryForm.get('panno').value,
  //     depositamt: this.issuesellerentryForm.get('depositamt').value,
  //     option: this.issuesellerentryForm.get('option').value,
  //   };
  //   // console.log(' Issue seller entry', issueseller);

  //   this.service.addIssueSellerEntry(issueseller).subscribe((data) => {
  //     // console.log(' Issue seller entry id', data);
  //     this.issueid = data['id'];

  //     let issueselleragent = {
  //       id: this.issueid,
  //       issuerate: this.issuesellerentryForm.get('issuerate').value,
  //       issuecopies: this.issuesellerentryForm.get('issuecopies').value,
  //       grossamt: this.issuesellerentryForm.get('grossamt').value,
  //       discount: this.issuesellerentryForm.get('discount').value,
  //       amount: this.issuesellerentryForm.get('amount').value,
  //       netamount: this.issuesellerentryForm.get('netamount').value,
  //       complementrycopies:
  //         this.issuesellerentryForm.get('complementrycopies').value,
  //       subscriptioncopies:
  //         this.issuesellerentryForm.get('subscriptioncopies').value,
  //       distributedtype: this.issuesellerentryForm.get('distributedtype').value,
  //       subtype: this.issuesellerentryForm.get('subtype').value,
  //       details: this.issuesellerentryForm.get('details').value,
  //     };

  //     if (this.issuesellerentryForm.get('option').value == 'agent') {
  //       this.service
  //         .addIssueSellerAgent(issueselleragent)
  //         .subscribe((data1) => {
  //           // console.log('id', data1);
  //           for (
  //             let index = 0;
  //             index < Object.keys(this.AdvtDetails).length;
  //             index++
  //           ) {
  //             let newadvtdtl = {
  //               issueName: this.AdvtDetails[index]['issue'],
  //               advt_dates: this.AdvtDetails[index]['advtdates'],
  //               booking_date: this.AdvtDetails[index]['bookingdate'],
  //               id: data1['id'],
  //             };
  //             this.service
  //               .insertIssueSellerAgentAdvtDetails(newadvtdtl)
  //               .subscribe((details) => {
  //                 // console.log('id1', details['id']);
  //                 for (
  //                   let index = 0;
  //                   index < Object.keys(this.AdvtDetails).length;
  //                   index++
  //                 ) {
  //                   this.AdvtDetails.pop();
  //                 }
  //               });
  //           }
  //         });
  //     }
  //    // window.alert('Issue Seller Added Successfully...');
  //     setTimeout(() => {
  //       this.issuesellerentryForm.reset();
  //     }, 2000);
  //   });
  //   // console.log(' Issue seller entry', issueseller);
  // }


  isExistingSeller: boolean = false;

  // When user selects an option from autocomplete list
  // selected_name(option: any): void {
  //   if (option && option.source && option.source.selected) {
  //     const selectedSeller = this.issue_seller_name.find(seller => seller.name === option.source.value);

  //     if (selectedSeller) {
  //       this.isExistingSeller = true;
  //       this.issueid = selectedSeller.id;

  //       // Patch form fields with existing seller data
  //       this.issuesellerentryForm.patchValue({
  //         englishissuesellername: selectedSeller.englishissuesellername || '',
  //         address1: selectedSeller.address1 || '',
  //         pincode: selectedSeller.pincode || '',
  //         country: selectedSeller.country || '',
  //         state: selectedSeller.state || '',
  //         district: selectedSeller.district || '',
  //         taluka: selectedSeller.taluka || '',
  //         edistricts: selectedSeller.edistricts || '',
  //         mnumber: selectedSeller.mnumber || '',
  //         landline_no: selectedSeller.landline_no || '',
  //         email: selectedSeller.email || '',
  //         dob: selectedSeller.dob || '',
  //         gstno: selectedSeller.gstno || '',
  //         panno: selectedSeller.panno || '',
  //         depositamt: selectedSeller.depositamt || '',
  //         option: selectedSeller.option || '',
  //         opening_bal: selectedSeller.opening_bal || '',
  //       });
  //     }
  //   }
  // }


  issueid: number;

  saveOrUpdateIssueSellerEntry() {
    console.log(this.issuesellerentryForm.value);

    let issueseller = {
      id: this.issueid,
      issuesellername: this.issuesellerentryForm.get('issuesellername').value,
      englishissuesellername: this.issuesellerentryForm.get('englishIssueSellerName').value,
      address1: this.issuesellerentryForm.get('address1').value,
      pincode: this.issuesellerentryForm.get('pincode').value,
      country: this.issuesellerentryForm.get('country').value,
      state: this.issuesellerentryForm.get('state').value,
      taluka: this.issuesellerentryForm.get('taluka').value,
      district: this.issuesellerentryForm.get('district').value,
      edistricts: this.issuesellerentryForm.get('edistricts').value,
      mnumber: this.issuesellerentryForm.get('mnumber').value,
      landline_no: this.issuesellerentryForm.get('landline_no').value,
      email: this.issuesellerentryForm.get('email').value,
      dob: this.issuesellerentryForm.get('dob').value,
      gstno: this.issuesellerentryForm.get('gstno').value,
      panno: this.issuesellerentryForm.get('panno').value,
      depositamt: this.issuesellerentryForm.get('depositamt').value,
      option: this.issuesellerentryForm.get('option').value,
      opening_bal: this.issuesellerentryForm.get('opening_bal').value,
    };

    if (this.issueid && this.issueid > 0) {
      console.log('Updating Issue Seller with ID:', this.issueid);
      this.service.updateIssueSellerEntry(issueseller).subscribe((data) => {
        alert('Issue Seller Updated Successfully!');
        this.issuesellerentryForm.reset();
        this.isExistingSeller = false;
        this.issueid = 0;
      });
    } else {
      console.log('Saving new Issue Seller');
      this.service.addIssueSellerEntry(issueseller).subscribe((data) => {
        this.issueid = data['id'];

        let issueselleragent = {
          id: this.issueid,
          issuerate: this.issuesellerentryForm.get('issuerate').value,
          issuecopies: this.issuesellerentryForm.get('issuecopies').value,
          grossamt: this.issuesellerentryForm.get('grossamt').value,
          discount: this.issuesellerentryForm.get('discount').value,
          amount: this.issuesellerentryForm.get('amount').value,
          netamount: this.issuesellerentryForm.get('netamount').value,
          complementrycopies: this.issuesellerentryForm.get('complementrycopies').value,
          subscriptioncopies: this.issuesellerentryForm.get('subscriptioncopies').value,
          distributedtype: this.issuesellerentryForm.get('distributedtype').value,
          subtype: this.issuesellerentryForm.get('subtype').value,
          details: this.issuesellerentryForm.get('details').value,
          opening_bal: this.issuesellerentryForm.get('opening_bal').value,
        };

        if (this.issuesellerentryForm.get('option').value === 'agent') {
          this.service.addIssueSellerAgent(issueselleragent).subscribe((data1) => {
            for (let index = 0; index < this.AdvtDetails.length; index++) {
              let newadvtdtl = {
                issueName: this.AdvtDetails[index]['issue'],
                advt_dates: this.AdvtDetails[index]['advtdates'],
                booking_date: this.AdvtDetails[index]['bookingdate'],
                id: data1['id'],
              };
              this.service.insertIssueSellerAgentAdvtDetails(newadvtdtl).subscribe(() => {
                this.AdvtDetails = [];
              });
            }
          });
        }

        alert('Issue Seller Added Successfully!');
        setTimeout(() => {
          this.issuesellerentryForm.reset();
          this.isExistingSeller = false;
          this.issueid = 0;
        }, 100);
      });
    }
  }




  // save_agentissueentry() {
  //   let agentissue = {
  //     repagent: this.agentissueentryForm.get('repagent').value,
  //     pname: this.agentissueentryForm.get('pname').value,
  //     edate: this.agentissueentryForm.get('edate').value,
  //     dissueper: this.agentissueentryForm.get('dissueper').value,
  //     psaleper: this.agentissueentryForm.get('psaleper').value,
  //     giftper: this.agentissueentryForm.get('giftper').value,
  //     prate: this.agentissueentryForm.get('prate').value,
  //     bpercentage: this.agentissueentryForm.get('bpercentage').value,
  //     bperissue: this.agentissueentryForm.get('bperissue').value,
  //     details: this.agentissueentryForm.get('details').value,
  //     alloctcode: this.agentissueentryForm.get('alloctcode').value,
  //     deptcode: this.agentissueentryForm.get('deptcode').value,
  //   };

  //   console.log('Agent Issue entry', agentissue);
  //   alert('Data not stored yet');
  //   setTimeout(() => {
  //     this.agentissueentryForm.reset();
  //   }, 2000);
  // }


  showigst = false;
  getState(event) {
    // console.log(event);
    // console.log(event.value);
    // this.selectedState = this.states['state_id'];
    let state = this.states.find((a) => a.state_name == event.value);
    // console.log(state);
    // console.log(this.states);
    if (state != undefined) {
      if (
        state.state_name != 'Maharashtra' ||
        state.state_name != 'महाराष्ट्र'
      ) {
        this.showigst = true;
      } else {
        this.showigst = false;
      }

      this.service
        .getDistrict(parseInt(state['state_id']))
        .subscribe((data) => {
          this.cities = data;
          this.selectedCity = this.cities['district_name'];
          // console.log(this.cities);
        });
    } else {
    }
  } //get state

  getDistricts(event) {
    console.log(event.value);
    this.selectedCity = this.cities['district_id'];
    let district = this.cities.find((a) => a.district_name == event.value);
    if (district != undefined) {

      const req = {
        "district_id": [district['district_id']]
      }
      this.service.getTaluka1(req).subscribe((data) => {
        this.talukas = data;
        this.selectedTaluka = this.talukas['taluka_name'];
      });
    }
  }

  getStateforupdate(id) {
    // console.log(event);
    // console.log(event.value);
    // this.selectedState = this.states['state_id'];
    let state = this.states.find((a) => a.state_name == id);
    // console.log(state);
    // console.log(this.states);
    if (state != undefined) {
      if (
        state.state_name != 'Maharashtra' ||
        state.state_name != 'महाराष्ट्र'
      ) {
        this.showigst = true;
      } else {
        this.showigst = false;
      }

      this.service
        .getDistrict(parseInt(state['state_id']))
        .subscribe((data) => {
          this.cities = data;
          this.selectedCity = this.cities['district_name'];
          // console.log(this.cities);
        });
    } else {
    }
  }


  getPincode(event) {
    if (this.issuesellerentryForm.get('pincode').valid) {
      console.log(this.issuesellerentryForm.get('pincode').value);
      this.service
        .getPincodeDetails(
          parseInt(this.issuesellerentryForm.get('pincode').value)
        )
        .subscribe((data) => {
          console.log('pincode deatils', data);
          this.issuesellerentryForm
            .get('taluka')
            .setValue(data[0]['PostOffice'][0]['Block']);
          // this.getCountry({ value: data[0]['PostOffice'][0]['Country'] });
          this.getCountry({ value: data[0]['country_name'] });
          this.issuesellerentryForm
            .get('district')
            .setValue({ name: data[0]['PostOffice'][0]['District'] });
          this.issuesellerentryForm
            .get('state')
            .setValue({ state_name: data[0]['PostOffice'][0]['State'] });
          this.issuesellerentryForm
            .get('country')
            .setValue(data[0]['PostOffice'][0]['Country']);
          this.selectedCity = data[0]['PostOffice'][0]['District'];
          this.selectedState = data[0]['PostOffice'][0]['State'];

          console.log(this.selectedCity, this.selectedState);
        });
    }
  } //getPincode

  // getPincode1(event) {
  //   if (this.addform.get('pincode').valid) {
  //     console.log(this.addform.get('pincode').value);
  //     this.service
  //       .getPincodeDetails(parseInt(this.addform.get('pincode').value))
  //       .subscribe((data) => {
  //         console.log('pincode deatils', data);
  //         this.addform
  //           .get('taluka')
  //           .setValue(data[0]['PostOffice'][0]['Block']);
  //         this.getCountry({ value: data[0]['PostOffice'][0]['Country'] });
  //         this.addform
  //           .get('district')
  //           .setValue({ name: data[0]['PostOffice'][0]['District'] });
  //         this.addform
  //           .get('state')
  //           .setValue({ state_name: data[0]['PostOffice'][0]['State'] });
  //         this.addform
  //           .get('country')
  //           .setValue(data[0]['PostOffice'][0]['Country']);
  //         this.selectedCity = data[0]['PostOffice'][0]['District'];
  //         this.selectedState = data[0]['PostOffice'][0]['State'];

  //         console.log(this.selectedCity, this.selectedState);
  //       });
  //   }
  // } //getPincode

  // getCountry(event) {
  //   debugger
  //   // console.log(event);
  //   console.log(event.value);
  //   let country = this.countries1.find((a) => a.name == event.value);
  //   if (country != undefined) {
  //     debugger
  //     this.service
  //       .getstates1((country['country_code']))
  //       .subscribe((data) => {
  //         this.states = data;
  //         console.log(this.states);
  //       });
  //   } else {
  //   }
  // } //

  save_publicationsale() {
    let publicationsalecurrency = {
      challandate: this.publicationsaleForm.get('cdate').value,
      challanno: this.publicationsaleForm.get('challanno').value,
      issuesellername: this.publicationsaleForm.get('issuesellername').value,
      psalescopy: this.publicationsaleForm.get('psalescopy').value,
      complementarycopies: this.publicationsaleForm.get('complementarycopies')
        .value,
      subscriptioncopies:
        this.publicationsaleForm.get('subscriptioncopies').value,
      issuerate: this.publicationsaleForm.get('issuerate').value,
      discountamt: this.publicationsaleForm.get('discountamt').value,
      saleamt: this.publicationsaleForm.get('saleamt').value,
      salesdiscount: this.publicationsaleForm.get('salesdiscount').value,
      netamt: this.publicationsaleForm.get('netamt').value,
      distributiontype: this.publicationsaleForm.get('distributiontype').value,
      subtype: this.publicationsaleForm.get('subtype').value,
      details: this.publicationsaleForm.get('details').value,
    };

    console.log(' Publication Sales Currency', publicationsalecurrency);
    alert('Data not stored yet');
    setTimeout(() => {
      this.publicationsaleForm.reset();
    }, 2000);
  }

  save_publicationpaymententries() {
    let publicationpayment = {
      issuegranth: this.issueName,
      issuedates: this.getDates,
      billno: this.publicationpaymententriesForm.get('billno').value,
      date: this.publicationpaymententriesForm.get('date').value,
      issuesellername:
        this.publicationpaymententriesForm.get('issuesellername').value,
      monthdate: this.publicationpaymententriesForm.get('monthdate').value,
    };

    console.log(' Publication Payment Entries', publicationpayment);
    alert('Data not stored yet');
    setTimeout(() => {
      this.publicationpaymententriesForm.reset();
    }, 2000);
  }
  onTabClick(event: any) {
    console.log(event)
    localStorage.setItem("tab", event.index)
  }

  issueSellerDataList: any
  getIssueSellerData() {
    this.service.getIssuesellersname().subscribe((res) => {
      this.issueSellerDataList = res;
    });
  }

  addIssueSellerEntry() {
    let issuesellerbooking = {
      issuesellername: this.issuesellerentryForm.get('issuesellername').value,
      address1: this.issuesellerentryForm.get('address1').value,
      pincode: this.issuesellerentryForm.get('pincode').value,
      country: this.issuesellerentryForm.get('country').value,
      state: this.issuesellerentryForm.get('state').value['state_name'],
      taluka: this.issuesellerentryForm.get('taluka').value,
      district: this.issuesellerentryForm.get('district').value['name'],
      mnumber: this.issuesellerentryForm.get('mnumber').value,
      landline_no: this.issuesellerentryForm.get('landline_no').value
        ? null
        : '',
      email: this.issuesellerentryForm.get('email').value,
      dob: this.issuesellerentryForm.get('dob').value,
      gstno: this.issuesellerentryForm.get('gstno').value,
      panno: this.issuesellerentryForm.get('panno').value,
      depositamt: this.issuesellerentryForm.get('depositamt').value,
      option: this.issuesellerentryForm.get('option').value,
      opening_bal: this.issuesellerentryForm.get('opening_bal').value,
    };
    // console.log(' Issue seller entry', issueseller);

    this.service.saveIssueSellerBookingEntry(issuesellerbooking).subscribe((data) => {
      // console.log(' Issue seller entry id', data);
      this.issueid = data['id'];

      let issueselleragent = {
        id: this.issueid,
        issuerate: this.issuesellerentryForm.get('issuerate').value,
        issuecopies: this.issuesellerentryForm.get('issuecopies').value,
        grossamt: this.issuesellerentryForm.get('grossamt').value,
        discount: this.issuesellerentryForm.get('discount').value,
        amount: this.issuesellerentryForm.get('amount').value,
        netamount: this.issuesellerentryForm.get('netamount').value,
        complementrycopies:
          this.issuesellerentryForm.get('complementrycopies').value,
        subscriptioncopies:
          this.issuesellerentryForm.get('subscriptioncopies').value,
        distributedtype: this.issuesellerentryForm.get('distributedtype').value,
        subtype: this.issuesellerentryForm.get('subtype').value,
        details: this.issuesellerentryForm.get('details').value,
      };

      if (this.issuesellerentryForm.get('option').value == 'agent') {
        this.service.saveIssueSellerBookingEntry(issueselleragent).subscribe((data1) => {
          for (
            let index = 0;
            index < Object.keys(this.AdvtDetails).length;
            index++
          ) {
            let newadvtdtl = {
              issueName: this.AdvtDetails[index]['issue'],
              advt_dates: this.AdvtDetails[index]['advtdates'],
              booking_date: this.AdvtDetails[index]['bookingdate'],
              id: data1['id'],
            };
            this.service
              .insertIssueSellerAgentAdvtDetails(newadvtdtl)
              .subscribe((details) => {
                // console.log('id1', details['id']);
                for (
                  let index = 0;
                  index < Object.keys(this.AdvtDetails).length;
                  index++
                ) {
                  this.AdvtDetails.pop();
                }
              });
          }
        });
      }
      // window.alert('Issue Seller Added Successfully...');
      setTimeout(() => {
        this.issuesellerentryForm.reset();
      }, 2000);
    });
    // console.log(' Issue seller entry', issueseller);
  }
  // filteredOptions2: any
  filteredOptions4: any
  filteredOptions5: any
  filteredOptions6: any
  filteredOptions7: any
  filteredOptions28: any



  booking_date: any
  bookingdateChange(event) {
    this.booking_date = formatDate(
      event.target.value,
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

    // Send the full date (YYYY-MM-DD) to getBookingNo
    this.getBookingNo(this.booking_date);
  }

  bookingdateChange1(event: any) {

    console.log(event);
    this.booking_date = formatDate(
      event,
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );
    // console.log(this.booking_date);
    this.getBookingNo(
      formatDate(event, 'MM', 'en-IN', 'GMT+0530')
    );
  }
  // booking_no: any
  // booking_no1: any
  // currentDate: Date;
  booking_no: string;
  currentDate: Date = new Date();

  getBookingNo(selectedDateString: string) {
    const selectedDate = new Date(selectedDateString);

    // Format month to 2 digits
    const month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
    const year = selectedDate.getFullYear();

    // Calculate Financial Year (April to March)
    let fyStart = year;
    let fyEnd = year + 1;
    if (selectedDate.getMonth() + 1 < 4) {  // January to March
      fyStart = year - 1;
      fyEnd = year;
    }

    const financialYear = `${fyStart.toString().slice(-2)}-${fyEnd.toString().slice(-2)}`;

    // API call to get the last booking number
    this.service.getIssueSellerBookingNo(selectedDateString).subscribe(
      (res: any[]) => {
        let nextNumber = 1;

        if (res && res.length > 0 && res[0]['booking_number'] !== 'NO_NUMBER') {
          const lastBookingNo = res[0]['booking_number'];  // Example: "IBN07/24-25/21"

          let lastSerial = '0';
          if (typeof lastBookingNo === 'string' && lastBookingNo.includes('/')) {
            lastSerial = lastBookingNo.split('/').pop() ?? '0';
          }

          const parsedSerial = parseInt(lastSerial, 10);
          nextNumber = isNaN(parsedSerial) ? 1 : parsedSerial + 1;
        }

        const bookingNo = `IBN${month}/${financialYear}/${nextNumber.toString().padStart(2, '0')}`;
        this.booking_no = bookingNo;
        this.issueForm.get('bookingNumber')?.setValue(bookingNo);
      },
      error => {
        console.error('Error fetching booking number:', error);
        const bookingNo = `IBN${month}/${financialYear}/01`;
        this.booking_no = bookingNo;
        this.issueForm.get('bookingNumber')?.setValue(bookingNo);
      }
    );
  }




  advt_names: any
  getAdvtNames(event) {
    if (event.target.value.length > 2) {
      this.service.getIssuesellerNames(event.target.value).subscribe((res) => {
        this.advt_names = res;
        // console.log(res);
      });
    }
  }


  contractData = []
  getallcontarctdetails() {
    this.service.getAllContractDetails().subscribe((res) => {
      // console.log(res);
      this.contractData = res;
      this.getContractDetails();
      console.log(res, "off rep");
    });
  }
  // contractRepName = [];
  // contractOffRepName = [];
  contractAdvtName = [];
  getContractDetails() {
    debugger
    for (
      let index = 0;
      index < Object.keys(this.contractData1).length;
      index++
    ) {
      this.contractRepName.push({
        name: this.contractData1[index]['issue_seller_representative'],
      });
      this.contractOffRepName.push({
        name: this.contractData1[index]['office_rep_name'],
      });
    }

    this.contractRepName = this.uniqueid(this.contractRepName, (a) => a.name);
    this.contractOffRepName = this.uniqueid(
      this.contractOffRepName,
      (a) => a.name
    );
    this.contractAdvtName = this.uniqueid(this.contractAdvtName, (a) => a.name);
  }

  advtInvoiceReportType;
  getAdvtInvoiceReportType(e) {
    this.advtInvoiceReportType = e.value;
  }
  openAdvtInvoiceRegister() {

    // this.issuedatelist = this.advtinvoiceForm.value.issuedate.split(',')[0];
    this.dialog.open(IssueSellerInvoiceRegisterComponent, {
      data: {
        startDate: this.advtInvoiceStartDate,
        endDate: this.advtInvoiceEndDate,
        issueName: this.issueinvoiceForm.value.issuename,
        issueDates: this.issueinvoiceForm.value.issuedate,
        reportType: this.advtInvoiceReportType,

      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }


  getDispatchlisteportStatement(updateStatus: boolean) {
    const payload = {
      delivery_mode_id: this.dispatchissueForm.get('deliveryModes')?.value,
      distribution_representative_id: this.dispatchissueForm.get('distributionRepresentatives')?.value,
      distribution_mode: this.dispatchissueForm.get('distributionModes')?.value,
      delevery_sub_mode_id: this.dispatchissueForm.get('deliverySubModes')?.value,
      issueCatregoryId: this.generateform.get('issueCatregoryId')?.value,
      issue_date: this.generateform.get('issue_date')?.value
        ? this.generateform.get('issue_date').value.toString().split(',')[0]
        : ''
    };

    console.log('Payload:', payload);

    this.service.getIssueSellerDispatchData(payload).subscribe(res => {
      this.filteredIssueSellerList = res.data;
      this.dialog.open(IssuesellerdispatchreportlistComponent, {
        data: {
          sellerData: this.filteredIssueSellerList,
          updateStatus: updateStatus
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    });
  }

  getofficelisteportStatement(updateStatus: boolean) {
    const payload = {
      delivery_mode_id: this.dispatchissueForm.get('deliveryModes')?.value,
      distribution_representative_id: this.dispatchissueForm.get('distributionRepresentatives')?.value,
      distribution_mode: this.dispatchissueForm.get('distributionModes')?.value,
      delevery_sub_mode_id: this.dispatchissueForm.get('deliverySubModes')?.value,
      issueCatregoryId: this.generateform.get('issueCatregoryId')?.value
    };

    console.log('Payload:', payload);

    this.service.getIssueSellerofficerepData(payload).subscribe(res => {
      console.log('API Response:', res); // <-- Check here
      this.filteredIssueSellerList = res; // not res.data if PHP returns array
      this.dialog.open(IssueSellerpostingOfficerepreportComponent, {
        data: {
          sellerData: this.filteredIssueSellerList,
          updateStatus: updateStatus
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    });

  }
  //Issue seller posting label and statement

  getDistrictwiseStatement(districtwiseStatementUpdateStatus: boolean) {
    this.filteredLabelDispatchData()
    this.dialog.open(IssueSellerDistrictwiseStatementComponentComponent, {
      data: {
        sundaydate: this.sundayDate,
        dispatchdate: this.dispatchdate,
        data: this.FilteredlabelsforDispatch,
        type: this.mode_names,
        state: this.state_names,
        district: this.district_names,
        updateStatus: districtwiseStatementUpdateStatus,
        issueDate: this.issuedate
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

  getStatewiseStatement(stateWiseStatementUpdateStatus: boolean) {

    this.dialog.open(IssueSellerStatewisestatementComponent, {
      data: {
        sundaydate: this.sundayDate,
        dispatchdate: this.dispatchdate,
        data: this.FilteredlabelsforDispatch,
        type: this.mode_names,
        state: this.state_names,
        issuedate: this.issuedate,
        country_names: this.country_names,
        district: this.district_names,
        updateStatus: stateWiseStatementUpdateStatus,
        delivery_mode: this.mode_names,

      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

  getPincodewiseStatement(updateStatus: boolean) {

    this.filteredLabelDispatchData()
    this.dialog.open(IssueSellerPincodewiseStatementComponent, {
      data: {
        sundaydate: this.issuedate,
        dispatchdate: this.dispatchdate,
        data: this.FilteredlabelsforDispatch,
        updateStatus: updateStatus,
        state: this.state_names,
        district: this.district_names,
        issueDate: this.issuedate
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

  getOtherStatePincodewiseStatement(updateStatus: boolean) {
    this.filteredLabelDispatchData()
    this.dialog.open(IssueSellerOtherStatePincodewiseStatementComponent, {
      data: {
        sundaydate: this.issuedate,
        dispatchdate: this.dispatchdate,
        // data: this.FilteredlabelsforDispatch,
        data: this.FilteredlabelsforDispatch,
        updateStatus: updateStatus,
        deleveryMode: this.mode_names,
        issuedate: this.issuedate,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

handDeliveryLabelList() {

  const formValues = this.generateform.value;

  // Category (Issue/grantha) - same extraction pattern as getLabelforDispatchData()
  const category = Array.isArray(formValues.issueCatregoryId)
    ? formValues.issueCatregoryId[0]
    : formValues.issueCatregoryId || '';

  // Issue date - keep full array since each option carries [issueDate, issueName, id, price]
  // const issue_date = Array.isArray(formValues.issue_date)
  //   ? formValues.issue_date[0]
  //   : formValues.issue_date || '';
  this.dialog.open(IssueSellerHanddeliverylabelslistComponent, {
    data: {
      data: this.disRepData,
      dis_mode: this.dis_mode,
      mode: this.sub_mode,
      vitarandate: this.dispatchdate,
      dist_rep_name: this.dist_rep_name,
      category: category,
      // issue_date: issue_date,
      start_date: this.getbookrcptStartDate,
      end_date: this.getbookrcptEndDate,
      // title: this.title1,
      sub_name: this.sub_names,
      // sub_type: this.sub_types,
      country_name: this.country_names,
      state_name: this.state_names,
      dist_name: this.district_names,
      taluka_name: this.taluka_names,
      pincode: this.pincodes,
      offrep_name: this.officerepnames,
      rep_name: this.repnames,
      del_mode: this.mode_names,
    },
    width: '1300px',
    height: '1300px',
    maxWidth: '100%',
  });
}


  person_name = 'प्रतिनिधीनुसार';
  handDeliveryData;
  handDelivery(updateStatus: boolean) {
    debugger
    const req1: any = {
      "issue_date": this.issuedate,
      "dist_type": this.dis_mode,
      "sub_dist_type": this.sub_mode,
      "dist_rep": this.dist_rep_name,
      "country": this.country_names,
      "state": this.state_names,
      "rep_name": this.repnames,
      "off_rep_name": this.officerepnames,
      "district": this.district_names,
      "taluka": this.taluka_names,
      "dev_mode": this.dev_mode,
      "pincode": this.pincodes,
      // "title": this.title1,
      // "subtype": this.sub_types,
    }

    this.service
      .getissuenewapi1(req1)
      .subscribe((res) => {
        this.disRepData1 = res;
        // console.log(this.disRepData);

        // if(confi)

        this.service.getIssuesaleSbhetdata(this.issuedate).subscribe((res) => {
          this.labeldata = res;
          console.log(this.labeldata, "this. label");
          let data = this.dialog.open(IssueSellerHandDeliveryComponentComponent, {
            data: {

              data: this.labeldata,
              data1: this.disRepData1,
              name: this.distributionForm.value.disrep,
              isuuedate: this.issuedate,
              dist_name: this.dist_rep_name,
              dis_mode: this.distributionForm.value.dismode,
              dis_sub_mode: this.distributionForm.value.subdismode,
              sundaydate: this.issuedate,
              dispatchdate: this.dispatchdate,
              updateStatus: updateStatus,
              deleveryMode: this.mode_names,
              state: this.generateform.value.statename,
              taluka: this.generateform.value.talukaname,
              pincode: this.generateform.value.pincode,
            },
            width: '1200px',
            height: '1300px',
            maxWidth: '100%',
          });

          data.afterClosed().subscribe((result) => {
            if (result['data'] == 'refresh') {
              this.handDeliveryData = result['val'];
              // if (localStorage.getItem('goto') == 'delivery_mode') {
              // this.demo1BtnClick1();
              //   localStorage.removeItem('goto');
              // }
            }
          });
        });

      });

    console.log(this.labeldata, "compare data 1")
    console.log(this.disRepData1, "compare data 2")
  }


  sub_mode = '';
  postStatement(updateStatus: any) {
    if (this.subdismode === 'जी.पी.ओ' && this.dismode1 === 'टपाल') {
      // this.postStatementTapal(updateStatus);
    } else {

      const req1: any = {
        "issue_date": this.issuedate,
        "dist_type": this.dis_mode,
        "sub_dist_type": this.sub_mode,
        "dist_rep": this.dist_rep_name,
        "country": this.country_names,
        "state": this.state_names,
        "rep_name": this.repnames,
        "off_rep_name": this.officerepnames,
        "district": this.district_names,
        "taluka": this.taluka_names,
        "dev_mode": this.dev_mode,
        "pincode": this.pincodes,
        // "title": this.title1,
        // "subtype": this.sub_types,
      }

      this.service
        .getissuenewapi1(req1)
        .subscribe((res) => {
          this.disRepData1 = res;


          this.dialog.open(IssueSellerPostStatementComponentComponent, {
            data: {
              data: this.labeldata,
              data1: this.disRepData1,
              mode: this.sub_mode,
              prakashandate: this.issuedate,
              vitarandate: this.dispatchdate,
              dist_name: this.dist_rep_name,
              dis_mode: this.dismode1,
              dis_sub_mode: this.subdismode,
              updateStatus: updateStatus,
              deleveryMode: this.mode_names,
              state: this.generateform.value.statename,
              taluka: this.generateform.value.talukaname,
              pincode: this.generateform.value.pincode,
            },
            width: '1200px',
            height: '1300px',
            maxWidth: '100%',
          });
        });

    }
  }

 handDeliveryLabel(updateStatus: any) {
  debugger;
  const req1: any = {
    "issue_date": this.issuedate,
    "dist_type": this.dis_mode,
    "sub_dist_type": this.sub_mode,
    "dist_rep": this.dist_rep_name,
    "country": this.country_names,
    "state": this.state_names,
    "rep_name": this.repnames,
    "off_rep_name": this.officerepnames,
    "district": this.district_names,
    "taluka": this.taluka_names,
    "dev_mode": this.dev_mode,
    "pincode": this.pincodes,
    "issueName": this.issueName,
    "category": this.generateform.value.issueCatregoryId
    // "title": this.title1,
    // "subtype": this.sub_types
  };

  this.service.getissuenewapi1(req1).subscribe((res) => {
    this.disRepData1 = res;

    this.service.getSbhetdata(this.issuedate).subscribe((res) => {
      this.labeldata = res;
      console.log(this.labeldata, "this. label");

      let data = this.dialog.open(IssueSellerLabelsOfHandDeliveryComponent, {
        data: {
          data1: this.labeldata,
          data2: this.disRepData1,
          name: this.person_name,
          isuuedate: this.issuedate,
          dispatchdate: this.dispatchdate,
          dist_name: this.dist_rep_name,
          dis_mode: this.dismode1,
          dis_sub_mode: this.subdismode,
          updateStatus: updateStatus,
          deleveryMode: this.mode_names,
          state: this.generateform.value.statename,
          taluka: this.generateform.value.talukaname,
          pincode: this.generateform.value.pincode,
          issueName: this.generateform.value.issueName,
          category: this.generateform.value.issueCatregoryId
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

      data.afterClosed().subscribe((result) => {
        if (result['data'] == 'refresh') {
          this.handDeliveryData = result['val'];
        }
      });
    });
  });

  console.log(this.labeldata, "compare data 1");
  console.log(this.disRepData1, "compare data 2");
}

  prantwiseReport() {
     const formValues = this.generateform.value;

  // Category (Issue/Granth) — single value from issueCatregoryId
  const category = Array.isArray(formValues.issueCatregoryId)
    ? formValues.issueCatregoryId[0]
    : formValues.issueCatregoryId || '';

  // Issue date — control name is "issue_date" (multi-select), NOT "issueDate"
  // Each selected option is a comma-joined string: "issueDate,issueName,id,price"
  const rawIssueDate = Array.isArray(formValues.issue_date)
    ? formValues.issue_date[0]
    : formValues.issue_date || '';

  const [issueDate, issueName] = rawIssueDate
    ? rawIssueDate.split(',')
    : ['', ''];

    this.dialog.open(IssueSellerPrantwiseVarganidarReportComponent, {
      data: {
      issue_date: issueDate,   // the actual selected issue date
      category: category,     // the selected Issue/Granth category
      issueName: issueName,   // if you also need the issue's own name, from the date selection
      data: this.FilteredlabelsforDispatch,
    },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

  distVSubReport() {
    this.dialog.open(IssueSellerDistrictwiseVarganidarSubscriptionReportComponent, {
      data: {
        issuedate: this.issuedate,
        data: this.FilteredlabelsforDispatch,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

 distSubReport() {
  const formValues = this.generateform.value;

  // Category (Issue/Granth) — single value from issueCatregoryId
  const category = Array.isArray(formValues.issueCatregoryId)
    ? formValues.issueCatregoryId[0]
    : formValues.issueCatregoryId || '';

  // Issue date — control name is "issue_date" (multi-select), NOT "issueDate"
  // Each selected option is a comma-joined string: "issueDate,issueName,id,price"
  const rawIssueDate = Array.isArray(formValues.issue_date)
    ? formValues.issue_date[0]
    : formValues.issue_date || '';

  const [issueDate, issueName] = rawIssueDate
    ? rawIssueDate.split(',')
    : ['', ''];

  this.dialog.open(IssueSellerDistrictwiseSubscriptionReportComponent, {
    data: {
      issue_date: issueDate,   // the actual selected issue date
      category: category,     // the selected Issue/Granth category
      issueName: issueName,   // if you also need the issue's own name, from the date selection
      data: this.FilteredlabelsforDispatch,
    },
    width: '1200px',
    height: '1300px',
    maxWidth: '100%',
  });
}

  openBarcodeDialog(saveStatus: any): void {

    this.filteredLabelDispatchData()
    this.dialog.open(IssueSellerBarcodeDialogComponent, {
      width: '600px', // or whatever size you need
      data: {
        addresslabels: this.FilteredlabelsforDispatch,
        iscustomer: this.iscustomer,
        saveStatus: saveStatus,
        issue_date: this.issuedate,
        stateName: this.generateform.value.statename[0],
        districtName: this.generateform.value.districtname,
        talukaName: this.generateform.value.talukaname,
        pincode: this.generateform.value.pincode,
      },
    });
  }

  postingLabelBriefReport(): void {
    console.log('FilteredlabelsforDispatch', this.FilteredlabelsforDispatch);

    this.dialog.open(IssueSellerPostingLabelBriefComponentComponent, {
      data: {
        delivery_mode: this.mode_names,
        rep_names: this.repnames,
        state_name: this.state_names,
        district_name: this.district_names,
        taluka_name: this.taluka_names,
        addresslabels: this.FilteredlabelsforDispatch,
        country: this.country_names,
        office_rep_name: this.officerepnames,
        rep_name: this.repnames,
        name: this.sub_names,
        pincode: this.pincodes,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
  }


  getAddressLabelswithMobileNo() {
    this.filteredLabelDispatchData()
    console.log('FilteredlabelsforDispatch', this.FilteredlabelsforDispatch);
    this.dialog.open(IssueSellerAddressLabelsMobileNoComponent, {
      data: {
        addresslabels: this.FilteredlabelsforDispatch,
        iscustomer: this.iscustomer,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }


  handleAddressLabelClick() {
    const curweekfirstday = this.curweekfirstday;  // or pass the values from where you need
    const preweekfirstday = this.preweekfirstday;

    this.getLabelforDispatchData();
  }


  openAddressLabelDialog() {
    console.log('Opening dialog with:', this.FilteredlabelsforDispatch);

    this.dialog.open(IssueSellerAddressLabelsComponent, {
      data: {
        delivery_mode: this.mode_names,
        rep_names: this.repnames,
        state_name: this.state_names,
        district_name: this.district_names,
        taluka_name: this.taluka_names,
        addresslabels: this.FilteredlabelsforDispatch,
        iscustomer: this.iscustomer,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
  }




  printJavak() {
debugger
    this.dialog.open(IssueSellerPrintJavakComponentComponent, {
      data: {
        issuedate: this.issuedate,
        data: this.FilteredlabelsforDispatch,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

  updatePrintOrder(data: any) {

    console.log(data);
    this.dialog.open(IssueSellerUpdatePrintOrderComponentComponent, {
      data: {
        data: data,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

  viewPrintOrder(data: any) {
    // console.log(data);
    this.dialog.open(IssueSellerViewPrintOrderComponentComponent, {
      data: {
        data: data,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
  cancelPrintOrder(id: number) {
    // console.log(id);

    const req: any = {
      "order_id": id
    }
    if (window.confirm('Are you sure want to delete?')) {
      this.service.IssueSellercancelPrintOrder(req).subscribe((res) => {

        console.log(res)
      });
    }
  }


  printOrder() {
    // console.log(this.issuedate);
    debugger

    let data = this.dialog.open(IssueSellerPrintOrderStatementComponentComponent, {
      data: {
        issuedate: this.issuedate,
         issueName: this.issueName1,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });

    data.afterClosed().subscribe((_a) => {
      this.getAllPrintOrderData();
    });
  }
  printOrderData;
  getAllPrintOrderData() {
    this.service.getAllissuePrintOrderData().subscribe((res) => {
      // console.log(res);
      this.printOrderData = res;
    });
  }

  //  disrepnames = '';
  getdistributionrep(event) {
    debugger

    this.dist_rep_name = event.value
    // console.log(event.value.length);
    if (event.value.length <= 1) {
      this.person_name = event.value[0];
      // console.log(this.person_name);
    } else {
      this.person_name = 'प्रतिनिधीनुसार';
    }
    this.disrepnames = event.value;
    if (this.disrepnames != '') {
      this.FilteredlabelsforDispatch = this.labelsforDispatch.filter((a) => {
        return (
          this.disrepnames.includes(a['distribution_rep']) &&
          a['delivery_mode'] === 'हस्ते'
        );
      });
      this.getFilteredlabelslistfordispatch();
    }
  }

  getPostingLabelswithMobileNoReport() {
    this.filteredLabelDispatchData()
    console.log('FilteredlabelsforDispatch', this.FilteredlabelsforDispatch);
    this.dialog.open(IssueSellerPostingLabelBriefComponent, {
      data: {
        addresslabels: this.FilteredlabelsforDispatch,
        iscustomer: this.iscustomer,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }


  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }

  allSelectedc2 = false;
  @ViewChild('mySelc2') skillSelc2: MatSelect;
  toggleAllSelectionc2() {
    this.allSelectedc2 = !this.allSelectedc2; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelectedc2) {
      this.skillSelc2.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSelc2.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSelc2.close();
  }
  allSelectedc1 = false;
  @ViewChild('mySelc1') skillSelc1: MatSelect;
  toggleAllSelectionc1() {
    this.allSelectedc1 = !this.allSelectedc1; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelectedc1) {
      this.skillSelc1.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSelc1.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSelc1.close();
  }


  dismode1 = '';
  dis_mode: any
  subdistmode: any
  // getdismode(event: any) {
  //   this.issueForm.patchValue({ deliverySubModeId: '' });

  //   this.service.getsubdistmodeissue(this.dis_mode).subscribe((data) => {
  //     this.subdistmode = data;
  //   });
  // }

  getdismode(event: any) {

    this.dismode1 = event.value;
    this.dis_mode = this.dismode1
    this.service.getsubdistmode(this.dis_mode).subscribe((data) => {
      // console.log('pkgBookingData', data);
      this.subdistmode = data;
    });
    // if (this.dismode1 != '') {
    //   this.FilteredLabelsSubDisModes = this.LabelsSubDisModes.filter(
    //     (a) => a['dis_mode'] == this.dismode1
    //   );
    //   console.log(this.FilteredLabelsSubDisModes);
    //   // console.log(this.labelsforDispatch);

    //   this.FilteredlabelsforPostStatement = this.labelsforDispatch.filter(
    //     (a) => a['dis_mode'] == this.dismode1
    //   );
    //   this.getFilteredlabelslistfordispatch();
    //   // console.log(this.FilteredlabelsforPostStatement);
    // }
  }






  reset_distribution_rep_names() {

    this.disrepnames = '';
    this.dist_rep_name = '';
    this.distributionForm.get('disrep').reset();
    if (this.disrepnames == '') {
      this.FilteredlabelsforDispatch = this.labelsforDispatch;
      this.getFilteredlabelslistfordispatch();
    }
  }
  getdismode1(event: any) {
    this.issueForm.patchValue({
      deliverySubModeId: ''
    })
    this.deliverySubModeId = undefined
    this.dismode1 = event;
    this.dis_mode = this.dismode1
    this.service.getsubdistmode(this.dis_mode).subscribe((data) => {
      // console.log('pkgBookingData', data);
      this.subdistmode = data;
    });

  }

  dispatchdate = '';
  sundayDate = '';
  getDispatchDate(event) {
    this.dispatchdate = formatDate(
      event.value,
      'dd/MM/yyyy',
      'en-IN',
      'GMT+0530'
    );
    // console.log(this.dispatchdate);

    let date = event.value;
    const weekfirstday = date.getDate() - date.getDay();
    this.sundayDate = formatDate(
      date.setDate(weekfirstday + 7),
      'dd/MM/yyyy',
      'en-IN',
      'GMT+0530'
    );
    // console.log(this.sundayDate);
  }

  deliverySubModeId: any
  getSubDeliveryData() {

    this.deliverySubModeId = this.issueForm.value.deliverySubModeId
  }
  // reset_subdismode() {
  //   this.issueForm.get('deliverySubModeId').reset();

  // }

  reset_subdismode() {
    this.subdismode = '';
    this.issueForm.get('deliverySubModeId').reset();
    this.distributionForm.get('subdismode').reset();
    if (this.subdismode == '') {
      this.FilteredlabelsforPostStatement = this.labelsforDispatch;
      this.getFilteredlabelslistfordispatch();
    }
  }


  reset_dismode() {
    this.dismode1 = '';
    this.distributionForm.get('dismode').reset();
    if (this.dismode1 == '') {
      this.FilteredlabelsforPostStatement = this.labelsforDispatch;
      this.getFilteredlabelslistfordispatch();
    }
  }

  filterIssueSellerName(event: any) {
    // this.filteredOptions=[]
    this.filteredOptions = this.issue_seller_name
      .filter(x =>
        x.name.includes(event.target.value) || x.mob_no.includes(event.target.value)
      );
    //  console.log(this.issue_seller_name+this.issue_seller_name.name+this.issue_seller_name.mob_no);
  }
  issueSellerIds: any
  selected_name1(event: any, data: any) {
    this.issueSellerIds = data.id

    this.issueForm.patchValue({
      issueSellerId: data.name
    })
    this.issuesellerentryForm.patchValue({
      issuesellername: data.name
    })
    this.issueid = data.id
    this.selected_name(data)
  }

 selected_namebooking(event: any, data: any) {
  if (!event.isUserInput) {
    return;
  }

  /* ===============================
     1️⃣ Get Financial Year Dates
  =============================== */
  const start = sessionStorage.getItem('startDate'); // "2025-04-01"
  const end = sessionStorage.getItem('endDate');     // "2026-03-31"

  this.financialYearMin = start ? new Date(start) : new Date('1900-01-01');
  this.financialYearMax = end ? new Date(end) : new Date('2099-12-31');

  /* ===============================
     2️⃣ Keep Existing Assignments
  =============================== */
  this.issueSellerIds = data.id;
  this.issueid = data.id;

  this.issueForm.patchValue({
    issueSellerId: data.name
  });

  this.issuesellerentryForm.patchValue({
    issuesellername: data.name
  });

  this.selected_name(data);

  /* ===============================
     3️⃣ API Payload (Seller Name)
  =============================== */
  const issuesellerbooking = {
    issueSellerId: data.name
  };

  /* ===============================
     4️⃣ API Call + Financial Year Filter
  =============================== */
  this.service.getIssueSellerList({ issuesellerbooking })
    .subscribe((res: any[]) => {

      // 🔹 Store full list (optional but safe)
      this.allIssueBookingSellerList = res;

      // 🔹 Filter by Financial Year
      this.issueBookingSellerList = this.allIssueBookingSellerList.filter(item => {
        const bookingDate = new Date(item.booking_date);

        return (
          bookingDate >= this.financialYearMin &&
          bookingDate <= this.financialYearMax
        );
      });

      console.log(
        'Filtered List (Seller + Financial Year):',
        this.issueBookingSellerList
      );
    });
}



  repIds: any
  selected_rep_name(event: any, data: any) {
    this.repIds = data.id
    debugger
    this.issueForm.patchValue({
      representativeId: data.issue_seller_representative
    })

  }

  selected_rep_name1(event: any, option: any): void {
    debugger
    if (event.isUserInput) {
      let data = this.issuewisereplist.filter(
        a => a['rep_name'] === option['issue_seller_representative']
      );

      if (data.length > 0) {
        this.issueForm.get('repmobno1')?.setValue(data[0]['rep_mob_no']);
        this.issueForm.get('officeRepresentativeId')?.setValue(data[0]['off_rep_name']);
      }
    }
  }


  offrepIds: any
  selected_off_rep_name(event: any, data: any) {
    this.offrepIds = data.id
    debugger
    this.issueForm.patchValue({
      officeRepresentativeId: data.office_representative
    })

  }

  isuueSellerIds: any
  selected_issue_seller_name(event: any, data: any) {
    this.isuueSellerIds = data.id

    this.issueSellerbillForm.patchValue({
      issuename: data.name
    })

  }
  saveIssueSellerBookingDetails() {
    let obj = this.issueForm.value.issueNameId[0];

    console.log(this.issueForm.value.bookingDate)
    const issuesellerbooking = {
      bookingDate: this.issueForm.value.bookingDate,
      bookingNumber: this.issueForm.get('bookingNumber').value,
      issueSellerId: this.issueForm.get('issueSellerId').value,
      representativeId: this.issueForm.get('representativeId').value,
      officeRepresentativeId: this.issueForm.get('officeRepresentativeId').value,
      issueCatregoryId: this.issueForm.get('issueCatregoryId').value,
      issueNameId: obj[1],
      issueSellerDate: this.issueForm.get('issueSellerDate').value,
      issueSellerPrice: this.issueForm.get('issueSellerPrice').value,
      issueSellerCopies: this.issueCopies,
      complementaryCopies: this.complementaryCopies1,
      amount: this.issueForm.get('amount').value,
      discountPercentage: this.issueForm.get('discountPercentage').value,
      discountAmount: this.issueCopies * (Number(this.issueForm.get('discount_amt').value) || 0),
      netAmount: this.issueForm.get('netAmount').value,
      issueRemark: this.issueForm.get('issueRemark').value,
      issueSellerGstType: this.issueForm.get('issueSellerGstType').value,
      gstPercentage: this.issueForm.get('gstPercentage').value,
      gstAmount: this.issueForm.get('gstAmount').value,
      withoutGstAmount: this.issueForm.get('withoutGstAmount').value,
      withGstAmount: this.issueForm.get('withGstAmount').value,
      deliveryModeId: this.issueForm.get('deliveryModeId').value,
      deliverySubModeId: this.issueForm.get('deliverySubModeId').value,
      distributionRepresentativeId: this.issueForm.get('distributionRepresentativeId').value,
      totalAmount: this.issueForm.get('totalAmount').value,
      afterdistamt: this.issueForm.get('afterdistamt').value,
      distributionMode: this.issueForm.get('distributionMode').value,
      issueSellerIds: this.issueSellerIds,
      issueNameIds: this.issueNameIds,
      Child_Array: this.AdvtDetails,
    };
    const request = {
      "issuesellerbooking": issuesellerbooking
    }

    this.service.saveIssueSellerBookingEntry(issuesellerbooking).subscribe((data) => {
      this.getIssueSellerList();
      window.alert('Issue Seller Added Successfully...');
      this.issueid = data['id']
      this.issueForm.reset();
      this.AdvtDetails = [];


    });
    // console.log(' Issue seller entry', issueseller);
  }
  id: any = null;

  getIssueSellerBookingById(item1: any) {
    debugger;
    this.id = item1.id;

    // Booking Date (this is usually ISO format so we can safely use Date)
    this.issueForm.get('bookingDate')?.setValue(new Date(item1['booking_date']));

    this.issueForm.get('bookingNumber')?.setValue(item1['booking_number']);
    this.issueForm.get('representativeId')?.setValue([item1['representative_id']]);
    this.issueForm.get('officeRepresentativeId')?.setValue([item1['office_representation_id']]);
    this.issueForm.get('issueCatregoryId')?.setValue(item1['issue_category_id']);
    this.issueForm.get('issueSellerDate')?.setValue(item1['issue_date']);
    this.issueForm.get('issueNameId')?.setValue([item1['issue_name_id']]);

    // ✅ Safely handle issue_date_
    this.issueForm.get('issueSellerPrice')?.setValue(item1['issue_seller_price']);
    this.issueForm.get('issueSellerCopies')?.setValue(item1['issue_copies']);
    this.issueForm.get('complementaryCopies')?.setValue(item1['complimentry_copies']);
    this.issueForm.get('amount')?.setValue(item1['issue_selling_amount']);
    this.issueForm.get('discountPercentage')?.setValue(item1['issue_selling_discount_per']);
    this.issueForm.get('netAmount')?.setValue(item1['net_amount']);
    this.issueForm.get('issueSellerGstType')?.setValue(item1['issue_seller_gst_type']);
    this.issueForm.get('gstPercentage')?.setValue(5);
    this.issueForm.get('gstAmount')?.setValue(item1['with_gst_amount']);
    this.issueForm.get('withGstAmount')?.setValue(item1['with_gst_amount']);
    this.issueForm.get('withoutGstAmount')?.setValue(item1['without_gst_amount']);
    this.issueForm.get('deliveryModeId')?.setValue([item1['delivery_mode_id']]);
    this.issueForm.get('deliverySubModeId')?.setValue([item1['delevery_sub_mode_id']]);
    this.issueForm.get('distributionRepresentativeId')?.setValue(item1['distribution_representative_id']);
    this.issueForm.get('issueRemark')?.setValue(item1['issue_seller_remark']);
    this.issueForm.get('totalAmount')?.setValue(item1['total_amount']);
    this.issueForm.get('distributionMode')?.setValue([item1['distribution_mode']]);
    this.issueForm.get('afterdistamt')?.setValue(item1['afterdisamt']);
    this.issueForm.get('discountAmount')?.setValue(item1['issue_selling_discount_amt']);

    // Load child data by booking id
    this.service.getIssuebookingchildlist(item1['id']).subscribe((data: any[]) => {
      console.log('✅ Full child data:', data);
      this.AdvtDetails = data;
      if (data.length > 0) {
        this.issueForm.patchValue({
          discount_amt: data[0].discount_amt
        });
      }
    });
  }


  allSelected11 = false;
  @ViewChild('mySel11') skillsel11: MatSelect;
  toggleAllSelection11() {
    this.allSelected11 = !this.allSelected11;
    if (this.allSelected11) {
      this.skillsel11.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillsel11.options.forEach((item: MatOption) => item.deselect());
      this.title1 = '';
    }
    this.skillsel11.close();
  }

  getIssues1(id: any, item1: any) {
    console.log(id);
    this.issueName = id;

    this.discountAmtHideShow = this.issueName === 'विशेषांक';

    // Calculate issueSellerPrice if discount_amt exists and issueSellerPrice is already set
    if (this.discount_amt && this.issueSellerPrice) {
      this.issueSellerPrice = Number(this.issueSellerPrice) - Number(this.discount_amt);
    }

    this.service.getAdvtSizeByCategory(id).subscribe((data) => {
      this.advtsizebyCategory = data;
    });

    console.log(
      'advt_mag_name_details',
      this.advt_mag_name_details.filter((a) => a.issue_name == this.issueName)
    );

    this.service.getAdvtDatesAndNames(id).subscribe((data) => {
      this.getMagIssueDatesandNames = data;
      console.log('Issue Dates and Names:', this.getMagIssueDatesandNames);
      this.addAdvt1(item1.children);
    });

  }
  addAdvt1(children: any) {
    this.AdvtDetails = []
    this.discountAmt1 = 0
    this.afterdiscount = 0
    this.issueCopies = 0
    this.complementaryCopies1 = 0
    this.issueSellerPrice1 = 0
    this.sumNetAmt = 0
    debugger
    const issueSellerDates = this.issueForm.get('issueNameId').value || [];
    const datesArray = Array.isArray(issueSellerDates) ? issueSellerDates : [issueSellerDates];

    children.forEach(item => {
      //       this.skillSel.options.forEach((item: MatOption) => {
      //         console.log(item.value)
      //   // if (selectedValues.includes(item.value)) {
      //   //   item.select();
      //   // }
      // });
      //      this.skillSel.options.forEach((item: MatOption) => item.select());
      //      item['issueDate'], item['issueName'], item['id'],item['price']
      // Filter records where issueDate + issueName matches item.issue_dates
      const filteredRecords = this.getMagIssueDatesandNames.filter(item1 =>
        (item1.issueDate + ' ' + item1.issueName) === item.issue_dates
      );

      // If we have filtered records, select only those in skillSel
      if (filteredRecords.length) {
        // First, deselect all (optional)
        this.skillSel.options.forEach((option: MatOption) => option.deselect());

        // Now select only those matching the filteredRecords
        filteredRecords.forEach(filteredItem => {
          const valueToSelect = filteredItem.issueName; // assuming mat-option value is issueName
          this.skillSel.options.forEach((option: MatOption) => {
            if (option.value === valueToSelect) {
              option.select();
            }
          });
        });
      }

      // Close the select after selection
      this.skillSel.close();


      this.AdvtDetails.push({
        issue: item.issue_name,
        issueSellerDate: item.issue_dates,
        issueSellerPrice: item.price,
        issueSellerCopies: item.copies,
        complementaryCopies: item.complimentary_copies,
        discountPercentage: item.discount_per,
        discount_amt: item.discount_amt,
        amount_child: item.amount,
        afterdistamt: item.afterdicount,
      });

    });
  }


  updateIssueRegistration() {
    // Extract values properly
    const issueSellerDate = this.issueForm.get('issueSellerDate')?.value;
    const issueNameId = this.issueForm.get('issueNameId')?.value;

    const issuesellerbooking = {
      id: this.id,
      bookingDate: this.issueForm.get('bookingDate')?.value,
      bookingNumber: this.issueForm.get('bookingNumber')?.value,
      issueSellerId: this.issueForm.get('issueSellerId')?.value,
      representativeId: this.issueForm.get('representativeId')?.value,
      officeRepresentativeId: this.issueForm.get('officeRepresentativeId')?.value,
      issueCatregoryId: this.issueForm.get('issueCatregoryId')?.value,
      issueSellerDate: this.issueForm.get('issueSellerDate')?.value,
      issueNameId: this.issueForm.get('issueNameId')?.value,
      issueSellerPrice: this.issueForm.get('issueSellerPrice')?.value,
      issueSellerCopies: this.issueForm.get('issueSellerCopies')?.value,
      complementaryCopies: this.issueForm.get('complementaryCopies')?.value,
      amount: this.issueForm.get('amount')?.value,
      discountPercentage: this.issueForm.get('discountPercentage')?.value,
      discountAmount: this.issueForm.get('discountAmount')?.value,
      netAmount: this.issueForm.get('netAmount')?.value,
      issueRemark: this.issueForm.get('issueRemark')?.value,
      issueSellerGstType: this.issueForm.get('issueSellerGstType')?.value,
      gstPercentage: this.issueForm.get('gstPercentage')?.value,
      gstAmount: this.issueForm.get('gstAmount')?.value,
      withoutGstAmount: this.issueForm.get('withoutGstAmount')?.value,
      withGstAmount: this.issueForm.get('withGstAmount')?.value,
      deliveryModeId: this.issueForm.get('deliveryModeId')?.value,
      deliverySubModeId: this.issueForm.get('deliverySubModeId')?.value,
      distributionRepresentativeId: this.issueForm.get('distributionRepresentativeId')?.value,
      totalAmount: this.issueForm.get('totalAmount')?.value,
      distributionMode: this.issueForm.get('distributionMode')?.value,
    };

    this.service.updateRecordIssueRegistration(issuesellerbooking).subscribe((data) => {
      this.getIssueSellerList();
      window.alert('✅ Issue Seller Updated Successfully...');
      this.issueid = data['id'];
      this.issueForm.reset();
      this.id = null;
      this.AdvtDetails = [];
    });
  }


  deleteRecordIssueSellerBooking(item: any) {
    if (confirm("Are you sure you want to delete booking details?")) {
      const issuesellerbooking = { id: item.id };

      this.service.deleteIssueRegistration(issuesellerbooking).subscribe((data) => {
        this.getIssueSellerList();
        window.alert('Issue Seller Delete Successfully...');
        this.issueid = data['id'];
        this.issueForm.reset();
        this.id = null;
      });
    }
  }



  cust_mobile_filter_report = '';
  issueGranthName = '';
  issueDates = '';
  getAdvtDetailsReport = [];
  selectedReportType;
  startDate_registrationReport = '';
  enddate_registrationReport = '';
  offrepregreport = '';
  offrepname = '';
  repregreport = '';
  newissuedatepp: any;
  showindetail: boolean = false;
  showbrfly: any = false;
  repwiseindetail: any = false
  getAdvtRegistrationReport(e: any) {


    let repregreport: any = []
    if (this.repregreport[0] == 'ALL') {
      repregreport.push(this.repregreport[0])
    } else {
      repregreport = this.repregreport
    }
    let offrepregreport: any = []
    if (this.offrepregreport[0] == 'ALL') {
      offrepregreport.push(this.offrepregreport[0])
    } else {
      offrepregreport = this.offrepregreport
    }
    // Indetails  report 
    if (this.showindetail) {
      this.dialog.open(IssueSellerRegistrationReportComponentComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: this.RegistrationreportRange.value.repname,
          off_rep_name: this.RegistrationreportRange.value.offrepname,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    }
    //briefly
    else if (this.showbrfly) {
      this.dialog.open(BookSellerRegistrationBriflyReortComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: this.RegistrationreportRange.value.repname,
          off_rep_name: this.RegistrationreportRange.value.offrepname,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    }
    //indetail representative

    else if (this.showindetailrepwise) {
      this.dialog.open(IssueSellerRegistrationRepwiseIndetailReportComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: this.RegistrationreportRange.value.repname,
          off_rep_name: this.RegistrationreportRange.value.offrepname,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    }
    //Indetails office representative

    else if (this.showoffrepwiseindetail) {
      this.dialog.open(IssueSellerOffwiseIndetailRepgistrationReportComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: this.RegistrationreportRange.value.repname,
          off_rep_name: this.RegistrationreportRange.value.offrepname,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    }

    // briefly office representative 

    else if (this.showoffwisebrifly) {
      this.dialog.open(IssueSellerRegistationOffwiseBriflyReportComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: this.RegistrationreportRange.value.repname,
          off_rep_name: this.RegistrationreportRange.value.offrepname,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    }

    else if (this.condistionValue) {
      debugger
      this.dialog.open(VeryBriflyDatewiseComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: this.RegistrationreportRange.value.repname,
          off_rep_name: this.RegistrationreportRange.value.offrepname,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    }

    // brifly datewise 

    else if (this.condistionValue1) {
      debugger
      this.dialog.open(IssueBriflyDatewiseComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: this.RegistrationreportRange.value.repname,
          off_rep_name: this.RegistrationreportRange.value.offrepname,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    }

    //Indetails datewise 

    else if (this.condistionValue2) {
      debugger
      this.dialog.open(IndetailDatewiseRptComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: this.RegistrationreportRange.value.repname,
          off_rep_name: this.RegistrationreportRange.value.offrepname,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    }

    // very brifly off representative

    else if (this.condistionValue3) {
      debugger
      this.dialog.open(VeryBrifOffRepresantativeComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: this.RegistrationreportRange.value.repname,
          off_rep_name: this.RegistrationreportRange.value.offrepname,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    }

    //very briefly representative 

    else if (this.condistionValue4) {
      debugger
      this.dialog.open(IssueVeryBrifRepresentativeComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: this.RegistrationreportRange.value.repname,
          off_rep_name: this.RegistrationreportRange.value.offrepname,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    }

    // 4th Brif Representative
    else if (this.condistionValue5) {
      debugger
      this.dialog.open(BrifRepresentativeReportComponent, {
        data: {
          type: this.selectedReportType,
          start_date: this.startDate_registrationReport,
          end_date: this.enddate_registrationReport,
          rep_name: repregreport == "" ? "ALL" : repregreport,
          off_rep_name: offrepregreport == "" ? "ALL" : offrepregreport,
          issue_cat: this.issueName == "" ? "ALL" : this.issueName,
          issueDates: this.getDates == "" ? "ALL" : this.getDates,
          newissuedatepp: this.newissuedatepp == "" ? "ALL" : this.newissuedatepp
        },
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });

    } else {
      alert("Please select Report Type")
    }


  }

  advtInvoicePymtRcptData = [];
  // advtInvoiceListData;

  selectedItem(advtInvoice) {

    console.log(advtInvoice, "selected dsata");
    console.log(this.advtInvoicePymtRcptData);
    this.calculateRcptAmt(advtInvoice);
    console.log(this.advtInvoicePymtRcptData);


  }



  // updateIssueAnk() {
  //     console.log( this.advtInvoicePricePerIssue);
  //       const dialogdata = this.dialog.open(UpdateIssueSellerPerPriceComponentComponent, {
  //         height: '85vh',
  //         width: '95vw',
  //         maxWidth: '100%',
  //       }); 

  //   }
  updateIssueAnk(advtInvoice) {
    console.log(advtInvoice, this.advtInvoicePricePerIssue);
    // let data = this.advtInvoicePricePerIssue.find(
    //   (a) => a.id == advtInvoice.id
    // );
    // if (data) {
    const dialogdata = this.dialog.open(UpdateIssueSellerPerPriceComponentComponent, {
      data: {
        advtInvoice: advtInvoice,
        crdtAmt: parseFloat(this.advtpymtrecptform.get('crdtvamt').value),
        seAmt: parseFloat(this.advtpymtrecptform.get('seamt').value),
        balAmt: parseFloat(this.advtpymtrecptform.get('balamt').value),
      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });
    debugger
    dialogdata.afterClosed().subscribe((res) => {

      this.advtInvoiceListData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });
      this.advtInvoicePymtRcptData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });
      debugger;
      this.advtpymtrecptform.get('seamt').setValue(res.selecetdAmt);
      this.advtpymtrecptform.get('balamt').setValue(res.balanceAmt);
      // console.log(this.advtInvoicePricePerIssue);

      this.advtInvoicePricePerIssue.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a = res.advtInvoiceData;
        }
      });
      // console.log(this.advtInvoicePricePerIssue);
    });
    // }
    //  else {
    //   window.alert('First select the receipt');
    // }
  }


  showindetaildatewise: boolean = false;
  showoffdatewise: boolean = false;
  showdatewisevrybrfly: boolean = false;
  showoffrepvrybrfly: boolean = false;
  showindetailoffrep: boolean = false;
  showindetailrepwise: boolean = false;
  showoffrepwiseindetail: boolean = false;
  showoffwisebrifly: boolean = false;
  condistionValue: boolean = false;
  condistionValue1: boolean = false;
  condistionValue2: boolean = false;
  condistionValue3: boolean = false;
  condistionValue4: boolean = false;
  condistionValue5: boolean = false;

  checkReportType(event) {
    // console.log(event.value);
    this.selectedReportType = event.value;
    let indetail: boolean = false;
    let brfly: boolean = false;
    let verybrfly: boolean = false;
    let datewise: boolean = false;
    let offrepwise: boolean = false;
    let repwiseindetail: boolean = false;
    let condistionValue5: boolean = false;
    let condistionValue4: boolean = false;
    let condistionValue: boolean = false;
    let offrepwiseindetail: boolean = false;
    let offeisebrifly: boolean = false;
    this.showindetail = false;
    this.showbrfly = false;
    this.condistionValue = false;
    this.condistionValue1 = false;
    this.condistionValue2 = false;
    this.condistionValue3 = false;
    this.condistionValue4 = false;
    this.condistionValue5 = false;

    this.showoffwisebrifly = false;
    // this.selectedReportType.forEach((type) => {
    if (event.value === 'InDetail') {  //1
      this.showindetail = true;
      indetail = true;
      if (this.offrepregreport != '') {
        offrepwise = true;
      }
    } else if (event.value === 'Briefly') { //2
      this.showbrfly = true;
      brfly = true;
    } else if (event.value === 'Represantative Indetails') { //3
      this.showindetailrepwise = true;
      repwiseindetail = true

    } else if (event.value === 'Represantative Briefly') { //4
      this.condistionValue5 = true;
      condistionValue5 = true

    }
    else if (event.value === 'datewise_very_briefly') {  //11
      this.condistionValue = true;
      condistionValue = true;

    }
    else if (event.value === 'Represantative very Briefly') { //5
      this.condistionValue4 = true;
      condistionValue4 = true;

    } else if (event.value === 'Off_Represantative Indetails') { //6
      this.showoffrepwiseindetail = true;
      offrepwiseindetail = true

    } else if (event.value === 'Off_Represantative Briefly') { //7
      this.showoffwisebrifly = true;
      offeisebrifly = true

    } else if (event.value === 'Very Briefly') {
      verybrfly = true;
      if (this.offrepregreport != '') {
        offrepwise = true;
      }
    } else if (event.value === 'Datewise') {
      datewise = true;
    }
    else if (event.value === 'datewise_very_briefly') {  //11
      this.condistionValue = true;

    } else if (event.value === 'Datewise Briefly') {  //10
      this.condistionValue1 = true;
    }
    else if (event.value === 'Datewise Indetails') { //9
      this.condistionValue2 = true;
    }
    else if (event.value === 'Off_Represantative very Briefly') { //8
      this.condistionValue3 = true;
    }
    // else if (event.value === 'Represantative very Briefly') { //5
    //   this.condistionValue4 = true;
    // }
    // else if (event.value === 'Represantative Briefly') { //4
    //   this.condistionValue5 = true;
    //      condistionValue5 = true;

    // }
    // });

    if (indetail && datewise) {
      this.showindetaildatewise = true;
      this.showindetail = false;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showdatewisevrybrfly = false;
      this.showindetailoffrep = false;
      this.showindetailrepwise = false;
      this.showoffrepwiseindetail = false;
      this.showoffwisebrifly = false;
      this.inDetailsDatewise();
    }

    else if (brfly) {
      this.showindetaildatewise = false;
      this.showindetail = false;
      this.showbrfly = true;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showdatewisevrybrfly = false;
      this.showindetailoffrep = false;
      this.showindetailrepwise = false;
      this.showoffrepwiseindetail = false;
      this.showoffwisebrifly = false;
      this.briflyDatewise();
    }

    else if (repwiseindetail) {
      this.showindetaildatewise = false;
      this.showindetail = false;
      this.showbrfly = false;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showdatewisevrybrfly = false;
      this.showindetailoffrep = false;
      this.showindetailrepwise = true;
      this.showoffrepwiseindetail = false;
      this.showoffwisebrifly = false;
      this.repwiseindetailDatewise();
    }

    else if (offrepwiseindetail) {
      this.showindetaildatewise = false;
      this.showindetail = false;
      this.showbrfly = false;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showdatewisevrybrfly = false;
      this.showindetailoffrep = false;
      this.showindetailrepwise = false;
      this.showoffrepwiseindetail = true;
      this.showoffwisebrifly = false;
      this.offwiseindetailDatewise();
    }

    else if (offeisebrifly) {
      this.showindetaildatewise = false;
      this.showindetail = false;
      this.showbrfly = false;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showdatewisevrybrfly = false;
      this.showindetailoffrep = false;
      this.showindetailrepwise = false;
      this.showoffrepwiseindetail = false;
      this.showoffwisebrifly = true;
      this.offwisebriflyDatewise();
    }
    else if (offeisebrifly) {
      this.showindetaildatewise = false;
      this.showindetail = false;
      this.showbrfly = false;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showdatewisevrybrfly = false;
      this.showindetailoffrep = false;
      this.showindetailrepwise = false;
      this.showoffrepwiseindetail = false;
      this.showoffwisebrifly = true;
      this.offwisebriflyDatewise();
    }
    else if (condistionValue5) {
      this.showindetaildatewise = false;
      this.showindetail = false;
      this.showbrfly = false;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showdatewisevrybrfly = false;
      this.showindetailoffrep = false;
      this.showindetailrepwise = false;
      this.showoffrepwiseindetail = false;
      this.showoffwisebrifly = false;
      this.condistionValue5 = true
      this.briflyconditionValue5Datewise();
    }

    else if (condistionValue4) {
      this.showindetaildatewise = false;
      this.showindetail = false;
      this.showbrfly = false;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showdatewisevrybrfly = false;
      this.showindetailoffrep = false;
      this.showindetailrepwise = false;
      this.showoffrepwiseindetail = false;
      this.showoffwisebrifly = false;
      this.condistionValue5 = false;
      this.condistionValue4 = true
      this.verybriflyconditionValue5Datewise();
    }

    else if (condistionValue) {
      this.showindetaildatewise = false;
      this.showindetail = false;
      this.showbrfly = false;
      this.showoffdatewise = false;
      this.showoffrepvrybrfly = false;
      this.showdatewisevrybrfly = false;
      this.showindetailoffrep = false;
      this.showindetailrepwise = false;
      this.showoffrepwiseindetail = false;
      this.showoffwisebrifly = false;
      this.condistionValue5 = false;
      this.condistionValue4 = false;
      this.condistionValue = true
      this.verybriflyconditionValueDatewise();
    }



    // else if (datewise && verybrfly) {
    //   this.showdatewisevrybrfly = true;
    //   this.showoffrepvrybrfly = false;
    //   this.showindetaildatewise = false;
    //   this.showindetail = false;
    //   this.showoffdatewise = false;
    //   this.showindetailoffrep = false;
    //   this.datewiseBriefly();
    //   // this.datewiseBriefly();
    // } else if (indetail && !datewise && !offrepwise) {
    //   this.showindetail = true;
    //   this.showindetaildatewise = false;
    //   this.showoffdatewise = false;
    //   this.showoffrepvrybrfly = false;
    //   this.showindetailoffrep = false;
    //   this.showdatewisevrybrfly = false;
    //   this.getRegReportData();
    // } else if (offrepwise && verybrfly) {
    //   this.showoffrepvrybrfly = true;
    //   this.showindetail = false;
    //   this.showindetaildatewise = false;
    //   this.showoffdatewise = false;
    //   this.showindetailoffrep = false;
    //   this.showdatewisevrybrfly = false;
    //   this.offrepVeryBriefly();
    // } else if (indetail && offrepwise) {
    //   this.showindetailoffrep = true;
    //   this.showoffrepvrybrfly = false;
    //   this.showindetail = false;
    //   this.showindetaildatewise = false;
    //   this.showoffdatewise = false;
    //   this.showdatewisevrybrfly = false;
    //   this.inDetailsOffRep();
    // }
  }



  allSelected2 = false;
  @ViewChild('mySel3') skillSel3: MatSelect;
  toggleAllSelection2() {
    this.allSelected2 = !this.allSelected2; // to control select-unselect
    // console.log(this.skillSel2.options);
    if (this.allSelected2) {
      this.skillSel3.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel3.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel3.close();
  }

  pp_advt_names = [];
  // pp_off_rep_names = [];
  pp_rep_names = [];
  getPrasiddhiPatrakNamesData() {
    this.pp_advt_names = [];
    this.pp_off_rep_names = [];
    this.pp_rep_names = [];
    this.service.getPrasiddhiPatrakOff_Rep_and_advt_name().subscribe((res) => {
      // console.log(res);
      for (let index = 0; index < res.length; index++) {
        this.pp_advt_names.push({
          advt_name: res[index]['name'],
        });

        this.pp_off_rep_names.push({
          off_rep_name: res[index]['off_rep_name'],
        });

        this.pp_rep_names.push({
          rep_name: res[index]['rep_name'],
        });
      }

      this.pp_advt_names = this.uniqueid(
        this.pp_advt_names,
        (a) => a.advt_name
      );

      this.pp_off_rep_names = this.uniqueid(
        this.pp_off_rep_names,
        (a) => a.off_rep_name
      );

      this.pp_rep_names = this.uniqueid(this.pp_rep_names, (a) => a.rep_name);
    });
  }


  allSelectedr1 = false;
  @ViewChild('mySelr1') skillSelr1: MatSelect;
  toggleAllSelectionr1() {
    this.allSelectedr1 = !this.allSelectedr1; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelectedr1) {
      this.skillSelr1.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSelr1.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSelr1.close();
  }

  offrepregreport1 = '';
  getOfficeRep(event) {
    this.offrepregreport1 = event.value;
    this.checkReportType({ value: this.selectedReportType });
  }

  offrepname1 = '';
  getOfficeRep1(event) {
    this.offrepname1 = event.value;
  }

  repregreport1 = '';
  getRepName1(event) {
    this.repregreport1 = event.value;
    // console.log(event.value);
  }

  repname = '';
  getRepName2(event) {
    this.repname = event.value;
  }

  offrepNamesOfRegReport = [];
  repNamesOfRegReport = [];
  getRepAndOffNames() {
    this.service.getOffRepAndRepForRegReport().subscribe((data) => {
      // console.log(data);
      for (let index = 0; index < data.length; index++) {
        this.offrepNamesOfRegReport.push({
          off_rep_name: data[index]['off_rep_name'],
        });
        this.repNamesOfRegReport.push({
          rep_name: data[index]['rep_name'],
        });
      }

      this.offrepNamesOfRegReport = this.uniqueid(
        this.offrepNamesOfRegReport,
        (a) => a.off_rep_name
      );

      this.repNamesOfRegReport = this.uniqueid(
        this.repNamesOfRegReport,
        (a) => a.rep_name
      );
    });
  }

  allSelectedr2 = false;
  @ViewChild('mySelr2') skillSelr2: MatSelect;
  toggleAllSelectionr2() {
    this.allSelectedr2 = !this.allSelectedr2; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelectedr2) {
      this.skillSelr2.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSelr2.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSelr2.close();
  }

  dateIsEnableReport = false;
  startDate_registration = '';
  enddate_registration = '';
  dateIsEnable = false;
  getChangedDateRegistrationReport() {

    this.selectedReportType = "",
      this.startDate_registrationReport = "",
      this.enddate_registrationReport = "",
      this.issueName = ""
    this.getDates = ""
    this.newissuedatepp
    this.issueGranthName = '';
    this.issueDates = '';
    if (
      this.RegistrationreportRange.get('start').value != null &&
      this.RegistrationreportRange.get('end').value != null
    ) {
      console.log(this.RegistrationreportRange.value);
      this.dateIsEnable = true;
      // console.log(
      //   formatDate(
      //     new Date(this.RegistrationreportRange.get('start').value),
      //     'yyyy-MM-dd',
      //     'en-IN',
      //     'GMT+0530'
      //   )
      // );
      // console.log(
      //   formatDate(
      //     new Date(this.RegistrationreportRange.get('end').value),
      //     'dd-MM-yyyy',
      //     'en-IN',
      //     'GMT+0530'
      //   )
      // );
      this.startDate_registrationReport = formatDate(
        new Date(this.RegistrationreportRange.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_registrationReport = formatDate(
        new Date(this.RegistrationreportRange.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      // this.startDate_registrationReport = startdate;
      // this.enddate_registrationReport = endDate;
    } else {
      this.dateIsEnableReport = false;
    }
  }
  inDetailsDatewise() {
    this.getRegReportData();
    // setTimeout(() => {
    //   this.getReportDatewise();
    // }, 200);
  }
  inDetailsRegReport: any
  getRegReportData() {
    const issuesellerbooking = {
      "representativeId": this.RegistrationreportRange.value.repname,
      "startDate": this.RegistrationreportRange.value.start,
      "endDate": this.RegistrationreportRange.value.end,
      "officeRepresentativeId": this.RegistrationreportRange.value.offrepname,
      "issueNameId": this.RegistrationreportRange.value.issuename,
      "issueSellerDate": this.RegistrationreportRange.value.issuedate
    }
    this.service.getIssueSellerRegDetailsReportList(issuesellerbooking).subscribe((data) => {
      this.inDetailsRegReport = data;
      console.log(this.inDetailsRegReport);
      // this.addFilters();

    });
  }

  verybriflyconditionValue5Datewise() {
    this.verybriflyconditionValue5RegReport();
    // setTimeout(() => {
    //   this.getReportDatewise();
    // }, 200);
  }
  verybriflyconditionValue5RegReport: any
  getverybriflyconditionValue5RegReportData() {
    const issuesellerbooking = {
      "representativeId": this.RegistrationreportRange.value.repname,
      "startDate": this.RegistrationreportRange.value.start,
      "endDate": this.RegistrationreportRange.value.end,
      "officeRepresentativeId": this.RegistrationreportRange.value.offrepname,
      "issueNameId": this.RegistrationreportRange.value.issuename,
      "issueSellerDate": this.RegistrationreportRange.value.issuedate
    }
    this.service.getRegReportverybriflyrep(issuesellerbooking).subscribe((data) => {
      this.verybriflyconditionValue5RegReport = data;
      console.log(this.verybriflyconditionValue5RegReport);
      // this.addFilters();

    });
  }

  verybriflyconditionValueDatewise() {
    this.verybriflyconditionValueRegReport();
    // setTimeout(() => {
    //   this.getReportDatewise();
    // }, 200);
  }
  verybriflyconditionValueRegReport: any
  getverybriflyconditionValueRegReportData() {
    const req1 = {
      "representativeId": this.RegistrationreportRange.value.repname,
      "startDate": this.RegistrationreportRange.value.start,
      "endDate": this.RegistrationreportRange.value.end,
      "officeRepresentativeId": this.RegistrationreportRange.value.offrepname,
      "issueNameId": this.RegistrationreportRange.value.issuename,
      "issueSellerDate": this.RegistrationreportRange.value.issuedate
    }
    this.service.getissueRegReportInDetailsdatewise(req1).subscribe((data) => {
      this.verybriflyconditionValueRegReport = data;
      console.log(this.verybriflyconditionValueRegReport);
      // this.addFilters();

    });
  }




  briflyconditionValue5Datewise() {
    this.briflyconditionValue5RegReport();
    // setTimeout(() => {
    //   this.getReportDatewise();
    // }, 200);
  }
  briflyconditionValue5RegReport: any
  getbriflyconditionValue5RegReportData() {
    const issuesellerbooking = {
      "representativeId": this.RegistrationreportRange.value.repname,
      "startDate": this.RegistrationreportRange.value.start,
      "endDate": this.RegistrationreportRange.value.end,
      "officeRepresentativeId": this.RegistrationreportRange.value.offrepname,
      "issueNameId": this.RegistrationreportRange.value.issuename,
      "issueSellerDate": this.RegistrationreportRange.value.issuedate
    }
    this.service.getRegReportbriflyrep(issuesellerbooking).subscribe((data) => {
      this.briflyconditionValue5RegReport = data;
      console.log(this.briflyconditionValue5RegReport);
      // this.addFilters();

    });
  }
  briflyDatewise() {
    this.getRegbriflyReportData();
    // setTimeout(() => {
    //   this.getReportDatewise();
    // }, 200);
  }
  briflyRegReport: any
  getRegbriflyReportData() {
    const issuesellerbooking = {
      "representativeId": this.RegistrationreportRange.value.repname,
      "startDate": this.RegistrationreportRange.value.start,
      "endDate": this.RegistrationreportRange.value.end,
      "officeRepresentativeId": this.RegistrationreportRange.value.offrepname,
      "issueNameId": this.RegistrationreportRange.value.issuename,
      "issueSellerDate": this.RegistrationreportRange.value.issuedate
    }
    this.service.getIssueSellerRegbriflyReportList(issuesellerbooking).subscribe((data) => {
      this.briflyRegReport = data;
      console.log(this.briflyRegReport);
      // this.addFilters();

    });
  }

  repwiseindetailDatewise() {
    this.getRegrepwiseindetailReportData();
    // setTimeout(() => {
    //   this.getReportDatewise();
    // }, 200);
  }
  repwiseindetailRegReport: any
  getRegrepwiseindetailReportData() {
    const issuesellerbooking = {
      "representativeId": this.RegistrationreportRange.value.repname,
      "startDate": this.RegistrationreportRange.value.start,
      "endDate": this.RegistrationreportRange.value.end,
      "officeRepresentativeId": this.RegistrationreportRange.value.offrepname,
      "issueNameId": this.RegistrationreportRange.value.issuename,
      "issueSellerDate": this.RegistrationreportRange.value.issuedate
    }
    this.service.getIssueSellerRegrepwiseindetailReportList(issuesellerbooking).subscribe((data) => {
      this.repwiseindetailRegReport = data;
      console.log(this.repwiseindetailRegReport);
      // this.addFilters();

    });
  }
  offwiseindetailDatewise() {
    this.getRegoffwiseindetailReportData();
    // setTimeout(() => {
    //   this.getReportDatewise();
    // }, 200);
  }
  offwiseindetailRegReport: any
  getRegoffwiseindetailReportData() {
    const issuesellerbooking = {
      "representativeId": this.RegistrationreportRange.value.repname,
      "startDate": this.RegistrationreportRange.value.start,
      "endDate": this.RegistrationreportRange.value.end,
      "officeRepresentativeId": this.RegistrationreportRange.value.offrepname,
      "issueNameId": this.RegistrationreportRange.value.issuename,
      "issueSellerDate": this.RegistrationreportRange.value.issuedate
    }
    this.service.getIssueSellerRegoffwiseindetailReportList(issuesellerbooking).subscribe((data) => {
      this.offwiseindetailRegReport = data;
      console.log(this.offwiseindetailRegReport);
      // this.addFilters();

    });

  }
  offwisebriflyDatewise() {
    this.getRegoffwisebriflyReportData();
    // setTimeout(() => {
    //   this.getReportDatewise();
    // }, 200);
  }
  offwisebriflyRegReport: any
  getRegoffwisebriflyReportData() {
    const issuesellerbooking = {
      "representativeId": this.RegistrationreportRange.value.repname,
      "startDate": this.RegistrationreportRange.value.start,
      "endDate": this.RegistrationreportRange.value.end,
      "officeRepresentativeId": this.RegistrationreportRange.value.offrepname,
      "issueNameId": this.RegistrationreportRange.value.issuename,
      "issueSellerDate": this.RegistrationreportRange.value.issuedate
    }
    this.service.getIssueSellerRegoffwisebriflyReportList(issuesellerbooking).subscribe((data) => {
      this.offwisebriflyRegReport = data;
      console.log(this.offwisebriflyRegReport);
      // this.addFilters();

    });
  }

  advtInvoiceDate(event) {
    // console.log(event.value);
    this.getAdvtInoivceNo(event.value);
  }

  getAdvtInoivceNo(date: any) {
    if (!date) return;

    const formattedDate = formatDate(date, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    const issuesellerbooking = { date: formattedDate };

    this.service.getNextIssueSaleInvoiceNo(issuesellerbooking).subscribe((res) => {
      console.log('API Response:', res);

      if (res && res['bill_no']) {
        // ✅ Use the backend-generated invoice directly (don’t add +1)
        this.issueSellerbillForm.get('billno')?.setValue(res['bill_no']);
      } else {
        // If no invoice exists yet, start from 0001
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const fy =
          month < 4
            ? (year - 1).toString().slice(-2) + '' + year.toString().slice(-2)
            : year.toString().slice(-2) + '' + (year + 1).toString().slice(-2);
        const bill_no = `VSA/${('0' + month).slice(-2)}/${fy}/0001`;
        this.issueSellerbillForm.get('billno')?.setValue(bill_no);
      }
    });
  }


  start: any;
  end: any;
  getChangedDateContractM11() {

    if (
      this.issueSellerFormsecond.get('start').value != null &&
      this.issueSellerFormsecond.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.start = formatDate(
        new Date(this.issueSellerbillFormsecond.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.end = formatDate(
        new Date(this.issueSellerbillFormsecond.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    this.getAllAdvtInovicesData()
  }
  startdate: any;
  enddate: any;
  getChangedDateContractM112() {

    if (
      this.issueSellerchallanFormsecond.get('start').value != null &&
      this.issueSellerchallanFormsecond.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.start = formatDate(
        new Date(this.issueSellerchallanFormsecond.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.end = formatDate(
        new Date(this.issueSellerchallanFormsecond.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }

    this.getAllChallanBillData()
  }
  getChangedDateContractM1() {
    if (
      this.PaymentReceiptRegister.get('start').value != null &&
      this.PaymentReceiptRegister.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.PaymentReceiptRegister.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.PaymentReceiptRegister.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }


  getChangedDateContractM7() {

    if (
      this.PersonalNoteform.get('start').value != null &&
      this.PersonalNoteform.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.PersonalNoteform.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.PersonalNoteform.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }





  startDateLast: any
  endDateLast: any
  getChangedDateContractM4() {
    if (
      this.GSTFullReportForm.get('start').value != null &&
      this.GSTFullReportForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.GSTFullReportForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.GSTFullReportForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
    this.startDateLast = this.startDate_contract
    this.endDateLast = this.enddate_contract
  }

  startDateLast1: any
  endDateLast1: any
  getChangedDateContractM5() {
    if (
      this.RNIFullReportForm.get('start').value != null &&
      this.RNIFullReportForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.RNIFullReportForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.RNIFullReportForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
    this.startDateLast1 = this.startDate_contract
    this.endDateLast1 = this.enddate_contract
  }



  getChangedDateContractM8() {
    if (
      this.GSTFullReportForm.get('start').value != null &&
      this.GSTFullReportForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.GSTFullReportForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.GSTFullReportForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }
  contractReportRepName = '';
  getContractRepName(event) {
    debugger
    this.contractReportRepName = event.value;
  }
  contractReportOffRepName = '';
  getContractOffRepName(event) {
    debugger
    this.contractReportOffRepName = event.value;
  }

  showContractReportReminder() {
    // console.log(this.contractData);
    if (this.contractReportType == 'Monthwise') {
      this.dialog.open(IssueCotractBriefReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderform.value.start,
          endDate: this.Sendreminderform.value.end,
          repName: this.Sendreminderform.value.Repname,
          advtName: this.Sendreminderform.value.Advtname,

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      // alert('Please select report type');
    }
  }


  showContract

  showContractReportReminderissue() {


    debugger
    // console.log(this.contractData);

    if (this.contractReportType !== '' && this.contractReportType !== 'send-reminder1' && this.contractReportType !== 'send-reminder2') {

      this.dialog.open(ContractBriefReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderissueform.value.startDate,
          endDate: this.Sendreminderissueform.value.endDate,
          repName: this.Sendreminderissueform.value.repname,
          offRepName: this.contractReportOffRepName,
          name: this.Sendreminderissueform.value.advtname,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issueDates,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else if (this.contractReportType === 'send-reminder1') {

      debugger
      this.dialog.open(SendReminderLetterIssueComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderissueform.value.startDate,
          endDate: this.Sendreminderissueform.value.endDate,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          name: this.Sendreminderissueform.value.advtname,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issueDates,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }
    else if (this.contractReportType === 'send-reminder2') {

      debugger
      this.dialog.open(SendReminderLetterIssueRepComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderissueform.value.startDate,
          endDate: this.Sendreminderissueform.value.endDate,
          repName: this.Sendreminderissueform.value.repname,
          offRepName: this.contractReportOffRepName,
          name: this.Sendreminderissueform.value.advtname,
          reportType: this.contractReportType,
          newissuedatepp: this.newissuedatepp,
          issuedatepp: this.issueDates,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {

      alert('Please select report type');

    }
  }

  showContractReportReminder1() {
    // console.log(this.contractData);
    if (this.contractReportType == 'briefly1') {
      this.dialog.open(IssueCreditVoucherPaymtRecieptBriflyReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderform.value.start,
          endDate: this.Sendreminderform.value.end,
          repName: this.Sendreminderform.value.Repname,
          advtName: this.Sendreminderform.value.Advtname,

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      // alert('Please select report type');
    }
  }

  showContractReportReminder2() {
    // console.log(this.contractData);
    if (this.contractReportType == 'InDetail-Officer') {
      this.dialog.open(IssueCreditVoucheofficerIndetailReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderform.value.start,
          endDate: this.Sendreminderform.value.end,
          repName: this.Sendreminderform.value.Repname,
          advtName: this.Sendreminderform.value.Advtname,

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      // alert('Please select report type');
    }
  }

  showContractReportReminder3() {
    // console.log(this.contractData);
    if (this.contractReportType == 'VeryBriefly-Officer') {
      this.dialog.open(IssueCreditVoucherVeryBriflyOfficerReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderform.value.start,
          endDate: this.Sendreminderform.value.end,
          repName: this.Sendreminderform.value.Repname,
          advtName: this.Sendreminderform.value.Advtname,

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      // alert('Please select report type');
    }
  }
  showContractReportReminder4() {
    // console.log(this.contractData);
    if (this.contractReportType == 'Briefly-Officer') {
      this.dialog.open(IssuecreditvoucherbrieflyofficerreportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderform.value.start,
          endDate: this.Sendreminderform.value.end,
          repName: this.Sendreminderform.value.Repname,
          advtName: this.Sendreminderform.value.Advtname,

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      // alert('Please select report type');
    }
  }

  showContractReportReminder5() {
    // console.log(this.contractData);
    if (this.contractReportType == 'InDetail') {
      this.dialog.open(IssueSellerIndetailCreditVoucherReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.Sendreminderform.value.start,
          endDate: this.Sendreminderform.value.end,
          repName: this.Sendreminderform.value.Repname,
          advtName: this.Sendreminderform.value.Advtname,

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      // alert('Please select report type');
    }
  }


  // allSelected = false;
  // @ViewChild('mySel') skillSel: MatSelect;
  toggleAllSelection121() {
    this.allSelected = !this.allSelected; // to control select-unselect
    // console.log(this.skillSel.options);
    if (this.allSelected) {
      this.skillSel.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel.options.forEach((item: MatOption) => {
        item.deselect();
      });
    }
    this.skillSel.close();
  }

  showPersonalLedgerReport() {
    if (!this.contractReportType) {
      alert('Please select report type');
      return;
    }

    let component: any;

    if (this.contractReportType === 'InDetail-personalledger') {
      component = IssueSellerPersonalLedgerComponent;
    } else if (this.contractReportType === 'briefly-personalledger') {
      component = IssueSellerBrieflyPersonalLedgerComponentComponent;
    } else {
      alert('Invalid report type selected');
      return;
    }

    this.dialog.open(component, {
      data: {
        contractData: this.contractData,
        startDate: this.startDate_contract,
        endDate: this.enddate_contract,
        repName: this.contractReportRepName,
        offRepName: this.contractReportOffRepName,
        name: this.PersonalNoteform.value.advtname,
        reportType: this.contractReportType,
      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });
  }



  showContractReport1() {
    // console.log(this.contractData);
    if (this.contractReportType == 'InDetailCreditNote') {
      this.dialog.open(IssueSellerCreditNoteRegisterInDetailComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDateLast,
          endDate: this.endDateLast,
          repName: this.Sendreminderform.value.Repname,
          advtName: this.Sendreminderform.value.Advtname,

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      // alert('Please select report type');
    }
  }


  showContractReport() {
    // console.log(this.contractData);
    if (this.contractReportType == 'GSTFullReport') {
      this.dialog.open(IssueSellerAddressGSTReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDateLast,
          endDate: this.endDateLast,
          repName: this.Sendreminderform.value.Repname,
          advtName: this.Sendreminderform.value.Advtname,

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      // alert('Please select report type');
    }
  }

  showrniContractReport() {
    // console.log(this.contractData);
    if (this.contractReportType == 'RNIFullReport') {
      this.dialog.open(IssueSellerAddressGSTReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDateLast,
          endDate: this.endDateLast,
          repName: this.Sendreminderform.value.Repname,
          advtName: this.Sendreminderform.value.Advtname,

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      // alert('Please select report type');
    }
  }
  showOutStandingReortReport() {
    debugger
    if (!this.contractReportType) {
      alert('Please select report type');
      return;
    }

    let component: any;

    if (this.contractReportType === 'IssueoutstandingInDetails') {
      component = IssueSellerOutstandibgIndetailReportsComponent;
    } else if (this.contractReportType === 'issueoutstandingbriefly') {
      component = IssueSellerOutstandibgIndetailReportsComponent;
    } else if (this.contractReportType === 'unpaidOutstandingInDetails') {
      component = IssueSellerOutstandibgIndetailReportsComponent;
    } else if (this.contractReportType === 'unpaidOutstandingbriefly') {
      component = IssueSellerOutstandibgIndetailReportsComponent;
    } else if (this.contractReportType === 'unpaidOutstandingVbriefly') {
      component = IssueSellerOutstandibgIndetailReportsComponent;
    } else if (this.contractReportType === 'creditdOutstandingindetails') {
      component = IssueSellerOutstandibgIndetailReportsComponent;
    } else if (this.contractReportType === 'IssueSellerAddress') {
      component = IssueSellerOutstandibgIndetailReportsComponent;
    }
    else if (this.contractReportType === 'AdvertisementAddressList') {
      component = IssueSellerAddressListComponentComponent;
    } else if (this.contractReportType === 'creditOutstandingbriefly') {
      component = IssueSellerOutstandibgIndetailReportsComponent;
    }
    else {
      alert('Invalid report type selected');
      return;
    }

    this.dialog.open(component, {

      data: {

        contractData: this.contractData,
        startDate: this.startDate_contract,
        endDate: this.enddate_contract,
        repName: this.OutStandingForm.value.repname,
        offRepName: this.OutStandingForm.value.offrepname,
        name: this.OutStandingForm.value.advtname,
        reportType: this.contractReportType,
        issue_name: this.OutStandingForm.value.issuename,
        issue_date: this.OutStandingForm.value.issueDates
      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });
  }
  // showContractReport122() {
  //   // console.log(this.contractData);
  //   debugger
  //   const req: any = {
  //     "rep_name": this.CreditNoteForm.value.rep_name,
  //     "start_date": this.CreditNoteForm.value.start,
  //     "end_date": this.CreditNoteForm.value.end,
  //     "off_rep_name": this.CreditNoteForm.value.off_rep_name,
  //     // "issue_name":this.CreditNoteForm.value.issue_cat,
  //     "issue_name": this.CreditNoteForm.value.issuename,
  //     "issue_date": this.CreditNoteForm.value.issueDates,
  //     "advt_name": this.advtName
  //   }
  //   this.service.getCreditRegiInDetails12(req).subscribe((data) => {

  //     this.advtcreditnotetRegiInDetailsFormBeans = data;
  //     this.PaymentadvtOffInDTotal = 0;
  //     console.log(this.advtcreditnotetRegiInDetailsFormBeans, "data receipt")

  //     for (let data1 of this.advtcreditnotetRegiInDetailsFormBeans) {
  //       this.PaymentadvtOffInDTotal += parseInt(data1.credit_v_amt) || 0;
  //     }
  //   });

  // this.service.getCreditRegiInDetails12(req).subscribe((data) => {
  //   // this.data_for_two_receipt = data;
  //   // this.data_for_two_receipt.forEach(element => {
  //   //  element.is_selected = false;
  //   // });

  //     debugger
  //     if (this.contractReportType === '') {
  //       alert('Please select report type');
  //     }
  //     else if (this.contractReportType === 'AdvertisementAddress1') {
  //       this.dialog.open(IssueSellerAddressComponent, {
  //         data: {
  //           contractData: this.contractData,
  //           startDate: this.startDate_contract,
  //           endDate: this.enddate_contract,
  //           repName: this.contractReportRepName,
  //           offRepName: this.contractReportOffRepName,
  //           name: this.advt_name,
  //           reportType: this.contractReportType,
  //           issue_date: this.CreditNoteForm.value.issueDates,
  //           issue_name: this.CreditNoteForm.value.issuename,
  //         },
  //         height: '1300px',
  //         width: '95%',
  //         maxWidth: '100%',
  //       });
  //     }
  //     else if (this.contractReportType === 'AdvertisementAddressList1') {
  //       this.dialog.open(IssueSellerAddressComponent, {
  //         data: {
  //           contractData: this.contractData,
  //           startDate: this.startDate_contract,
  //           endDate: this.enddate_contract,
  //           repName: this.contractReportRepName,
  //           offRepName: this.contractReportOffRepName,
  //           name: this.advt_name,
  //           reportType: this.contractReportType,
  //           issue_date: this.CreditNoteForm.value.issueDates,
  //           issue_name: this.CreditNoteForm.value.issuename,
  //         },
  //         height: '1300px',
  //         width: '95%',
  //         maxWidth: '100%',
  //       });
  //     }
  //     else {
  //       this.dialog.open(ContractBriefReportComponent, {
  //         data: {
  //           contractData: this.contractData,
  //           startDate: this.startDate_contract,
  //           endDate: this.enddate_contract,
  //           repName: this.contractReportRepName,
  //           offRepName: this.contractReportOffRepName,
  //           name: this.advt_name,
  //           reportType: this.contractReportType,
  //           issue_date: this.CreditNoteForm.value.issueDates,
  //           issue_name: this.CreditNoteForm.value.issuename,
  //         },
  //         height: '1300px',
  //         width: '95%',
  //         maxWidth: '100%',
  //       });
  //     }
  //   });
  // }

  addadvtCNrcpt() {
    console.log(this.contractReportRepName, this.advtCreditNoteform.value.advtname)
    console.log(this.advtCreditNoteform.value)

    const req1 = {
      issue_seller_name: this.advtCreditNoteform.value.advtname
    }
    const req2 = {
      advt_name1: this.advtCreditNoteform.value.advtname,
      cr_vocher: this.advtCreditNoteform.value.crdtvno,
      create_date: this.advtCreditNoteform.value.date,
      receipt_date: this.advtCreditNoteform.value.recptdate,
      rep_name: this.contractReportRepName,
      credit_count: this.newg
    }
    this.service.getCreditNoteissueMain(req1).subscribe((data: any) => {
      console.log("ADVT new Credit name Data=", data);
      this.advtCreditNote = (data as any);;
      // this.ngOnInit();
    });

    console.log("req2", req2)

  }

  addadvtCNrcpt1() {
    console.log(this.contractReportRepName, this.advtAdvanceStampform.value.advtname)
    console.log(this.advtAdvanceStampform.value)

    const req1 = {
      issue_seller_name: this.advtAdvanceStampform.value.advtname
    }
    // const req2 = {
    //   advt_name1: this.advtCreditNoteform.value.advtname,
    //   cr_vocher: this.advtCreditNoteform.value.crdtvno,
    //   create_date: this.advtCreditNoteform.value.date,
    //   receipt_date: this.advtCreditNoteform.value.recptdate,
    //   rep_name: this.contractReportRepName,
    //   credit_count: this.newg
    // }
    this.service.getCreditNoteissueMain(req1).subscribe((data: any) => {
      console.log("ADVT new Credit name Data=", data);
      this.advtCreditNote = (data as any);;
      // this.ngOnInit();
    });

    console.log("req1 for stamp", req1)

  }

  optionSelected(event: any, option: any): void {
    if (event.isUserInput) {
      const repName = option.name;

      this.service.getRepresentativeSummary(repName).subscribe(
        (res) => {
          if (res && typeof res === 'object') {
            this.publicationsaleForm.patchValue({
              totalCopies: res.total_copies || '',
              totalAmount: res.total_amount || '',
              distributionMode: res.distribution_modes || '',
              deliverySubModeId: res.sub_modes || ''
            });
          } else {
            this.publicationsaleForm.patchValue({
              totalCopies: '',
              totalAmount: '',
              distributionMode: '',
              deliverySubModeId: ''
            });
          }
        },
        (err) => {
          console.error('API Error:', err);
          this.publicationsaleForm.patchValue({
            totalCopies: '',
            totalAmount: '',
            distributionMode: '',
            deliverySubModeId: ''
          });
        }
      );
    }
  }




  contractReportType = '';
  getContractReportType(event) {
    // console.log(event.value);
    this.contractReportType = event.value;
  }

   contractReportAdvtRepName = '';
  getContractAdvtName(event) {


    console.log(this.Sendreminderissueform.value.advtname);
    this.contractReportAdvtRepName = event.value;
  }

 getNewAdvtName() {
  this.service.getNewissueName().subscribe((data: any) => {
    console.log("new advt receipt data=", data);
    this.newadvtname = data;
  }, error => {
    console.error("API error:", error);   // <-- add this, easy to miss silent failures
  });
}
  advtInvoiceList: any
  getAllAdvtInovicesData() {

    const req: any = {
      "startdate": this.start,
      "enddate": this.end,
    }

    this.service.getIssueSellerInvoiceByFilterList(req).subscribe((res) => {

      // console.log(res);
      this.advtInvoiceList = res;
      console.log(res, "invoice list")
      // for (let index = 0; index < this.advtInvoiceList.length; index++) {
      //   this.advtNamesData.push({
      //     id: this.advtInvoiceList[index]['id'],
      //     advt_name: this.advtInvoiceList[index]['advt_name'],
      //   });
      // }
    });
    // this.ngOnInit();
    // console.log(this.advtNamesData);
  }


  getAllChallanBillData() {

    const req: any = {
      "startdate": this.start,
      "enddate": this.end,
    }

    this.service.getIssueSellerInvoiceByFilterList(req).subscribe((res) => {

      // console.log(res);
      this.advtInvoiceList = res;
      console.log(res, "invoice list")
      // for (let index = 0; index < this.advtInvoiceList.length; index++) {
      //   this.advtNamesData.push({
      //     id: this.advtInvoiceList[index]['id'],
      //     advt_name: this.advtInvoiceList[index]['advt_name'],
      //   });
      // }
    });
    // this.ngOnInit();
    // console.log(this.advtNamesData);
  }
  // viewIssueSellerInvoice(id: number) {
  //   let data = this.advtInvoiceList.filter((a) => a.id === id);
  //   // console.log(id, data);

  //   this.openIssueSellerInvoice(data);
  // }
  // isupdate1: any = false
  // openIssueSellerInvoice(data: any) {

  //   let dialogdata = this.dialog.open(ViewIssueSellerInvoiceComponent, {
  //     data: {
  //       issuenames: data.issue_name_id,
  //       issueDates: data.issue_date,
  //       issueName: data.issue_name_id,
  //       issueSellerName: data.issue_seller_name,
  //       date: data.invoice_date,
  //       isupdate1: this.isupdate1,
  //       billno: data.invoice_no,
  //     },
  //     width: '1200px',
  //     height: '1300px',
  //     maxWidth: '100%',
  //   });

  //   dialogdata.afterClosed().subscribe((output) => {
  //     this.ngOnInit();
  //     // this.allSelectedtable = false;
  //   });
  // }

  viewIssueSellerInvoice(id: number) {
    debugger
    let data = this.advtInvoiceList.filter((a) => a.id === id);
    // console.log(id, data);
    this.openIssueSellerInvoice(data);
  }

  openIssueSellerInvoice(data: any) {
    debugger
    let dialogdata = this.dialog.open(ViewIssueSellerInvoiceComponent, {
      data: {
        advtData: data,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((output) => {
      this.ngOnInit();
      // this.allSelectedtable = false;
    });
  }

  showContractReport121() {
    // console.log(this.contractData);
    debugger
    const req: any = {
      "rep_name": this.CreditNoteForm.value.rep_name,
      "start_date": this.CreditNoteForm.value.start,
      "end_date": this.CreditNoteForm.value.end,
      "off_rep_name": this.CreditNoteForm.value.off_rep_name,
      // "issue_name":this.CreditNoteForm.value.issue_cat,
      "issue_name": this.CreditNoteForm.value.issuename,
      "issue_date": this.CreditNoteForm.value.issueDates,
      "advt_name": this.advtName
    }
    this.service.getCreditRegiInDetails12(req).subscribe((data) => {

      this.advtcreditnotetRegiInDetailsFormBeans = data;
      this.PaymentadvtOffInDTotal = 0;
      console.log(this.advtcreditnotetRegiInDetailsFormBeans, "data receipt")


      for (let data1 of this.advtcreditnotetRegiInDetailsFormBeans) {
        this.PaymentadvtOffInDTotal += parseInt(data1.credit_v_amt) || 0;
      }
    });
  }

  showContractReport122() {
    debugger;

    // ✅ Define payload once
    const req: any = {
      rep_name: this.CreditNoteForm.value.rep_name,
      start_date: this.CreditNoteForm.value.start,
      end_date: this.CreditNoteForm.value.end,
      off_rep_name: this.CreditNoteForm.value.off_rep_name,
      issue_name: this.CreditNoteForm.value.issuename,
      issue_date: this.CreditNoteForm.value.issueDates,
      advt_name: this.advtName
    };

    // ✅ Call API once (don’t duplicate)
    this.service.getCreditRegiInDetails12(req).subscribe((data) => {
      this.advtcreditnotetRegiInDetailsFormBeans = data;
      this.PaymentadvtOffInDTotal = 0;

      console.log(this.advtcreditnotetRegiInDetailsFormBeans, "data receipt");

      for (let data1 of this.advtcreditnotetRegiInDetailsFormBeans) {
        this.PaymentadvtOffInDTotal += parseInt(data1.credit_v_amt) || 0;
      }

      // ✅ Common dialog data (always same payload + reportType + contractData)
      const dialogData = {
        ...req,
        contractData: this.contractData,
        startDate: this.startDate_contract,
        endDate: this.enddate_contract,
        reportType: this.contractReportType
      };

      // ✅ Open dialog based on report type
      if (this.contractReportType === '') {
        alert('Please select report type');
        return;
      }

      let component;

      switch (this.contractReportType) {
        case 'InDetailCreditNote':
          component = IssueSellerCreditNoteRegisterInDetailComponent;
          break;
        case 'CreditNotebriefly':
          component = IssueSellerCreditNoteBrieflyComponent;
          break;
        case 'CreditMonthwise':
          component = IssueSellerCreditNoteMonthwiseComponent;
          break;
        case 'InDetail-CreditOfficer':
          component = IssueSellerCreditNoteInDetailOfficerComponent;
          break;
        case 'Briefly-OfficerCredit':
          component = IssueSellerBrieflyOfficeCreditComponent;
          break;
        default: // VeryBriefly-CreditNote
          component = IssueSellerCreditNoteVeryBrieflyCreditNoteComponent;
          break;
      }

      this.dialog.open(component, {
        data: dialogData,
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    });
  }


  allSelectedtable = false;
  someComplete(): boolean {
    if (this.advtInvoiceList == null) {
      return false;
    }
    return (
      this.advtInvoiceList.filter((t) => t.is_selected).length > 0 &&
      !this.allSelectedtable
    );
  }
  setAll(completed: boolean) {
    this.allSelectedtable = completed;
    if (this.advtInvoiceList == null) {
      return;
    }
    this.advtInvoiceList.forEach((t) => (t.is_selected = completed));
  }
  printAdvtInvoice() {
    // console.log(this.advtInvoiceList.filter((t) => t.is_selected));
    let data = this.advtInvoiceList.filter((t) => t.is_selected);
    this.openAdvtInvoice(data);
  }

  openAdvtInvoice(data: any) {
    // let dialogdata = this.dialog.open(ViewAdvtBillComponent, {
    //   data: {
    //     advtData: data,
    //   },
    //   width: '1200px',
    //   height: '1300px',
    //   maxWidth: '100%',
    // });

    // dialogdata.afterClosed().subscribe((output) => {
    //   this.ngOnInit();
    //   // this.allSelectedtable = false;
    // });
  }


  GenerateCRno2() {
    let indate = this.datePipe.transform(this.Advtremainingamt.value.invoiceDate, 'dd-MM-yyyy');

    // let indate = this.Advtremainingamt.value.invoiceDate;
    console.log(indate, "indate")
  }
  recdate1: any
  GenerateCRno() {


    // let recdate = this.advtCreditNoteform.value.recptdate ;
    this.recdate1 = this.datePipe.transform(this.advtCreditNoteform.value.recptdate, 'yyyy-MM-dd');
    // console.log(recdate);

    this.service.getCreditNoteG2(this.recdate1).subscribe((data: any) => {


      // console.log("auto CrNo=",data);
      this.autogeneratedno = (data as any);;
      // console.log(this.autogeneratedno)
      this.advtCreditNoteform.patchValue({
        crdtvno: this.autogeneratedno.new_rcpt

      })

    });
    // let newg: Number = 0;
    // // this.newg = this.autogeneratedno;
    // if (this.autogeneratedno == undefined) {
    //   this.newg = 1;
    // }
    // else {
    //   this.newg++;
    // }

    // let today = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    // let rcpt_no = `${new Date(recdate).getMonth() + 1 < 4
    //     ? (new Date(recdate).getFullYear() - 1).toString().slice(-2) +
    //     '-' +
    //     new Date(recdate).getFullYear().toString().slice(-2)
    //     : new Date(recdate).getFullYear().toString().slice(-2) +
    //     '-' +
    //     (new Date(recdate).getFullYear() + 1).toString().slice(-2)
    //   }`;
    // let no: Number = 1;

    // console.log('JCN'+this.datePipe.transform(this.currentDate, 'MM')+'00'+this.newg+'/'+rcpt_no)

    //  this.autogeneratedno ++;
  }

  recdate2: any;

  Generatechallanno() {
    this.recdate2 = this.datePipe.transform(this.publicationsaleForm.value.cdate, 'yyyy-MM-dd');

    if (this.recdate2) {
      this.service.getIssueChallanNumnerG2(this.recdate2).subscribe((data: any) => {
        this.autogeneratedno = data;

        if (this.autogeneratedno && this.autogeneratedno.new_rcpt) {
          this.publicationsaleForm.patchValue({
            challanno: this.autogeneratedno.new_rcpt
          });
        }
      });
    }
  }

  isupdate: any = false
  openAdvtBill() {
    const sellers = this.selectedItems2.value || [];
    let date = new Date(this.issueSellerbillForm.get('date').value)
    let dialogData = this.dialog.open(IssueSellerInvoiceBillComponent, {
      data: {
        issuenames: this.issueSellerbillForm.value.issuename,
        issueDates: this.issueSellerbillForm.value.issuedate,
        issueName: this.issueSellerbillForm.value.issuename,
        issueSellerName: sellers.join(', '),

        date: this.issueSellerbillForm.value.date,
        isupdate: this.isupdate,
        billno: this.issueSellerbillForm.get('billno').value,
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',

    });

    dialogData.afterClosed().subscribe((output) => {
      this.issueSellerbillForm.reset('');
      // this.getIssuesAdvtNames({ value: '' });
      console.log(output);
      this.ngOnInit();
      this.getAllAdvtInovicesData();
    });
  }

  //    isupdate1: any = false
  //  openchallanBill() {
  //   const form = this.publicationsaleForm;

  //   const dialogData = this.dialog.open(IssueSellerChallanBillComponent, {
  //     data: {
  //       challanno: this.publicationsaleForm.value.challanno,
  //       cdate: this.publicationsaleForm.value.cdate,
  //       issuegrath: this.publicationsaleForm.value.issuegrath,
  //       copies: this.publicationsaleForm.value.copies,
  //       issueDates: this.publicationsaleForm.value.issueDates,

  //       issueName: this.publicationsaleForm.value.issuename,
  //       totalamount: this.publicationsaleForm.value.totalamount,
  //       deliverymode1: this.publicationsaleForm.value.deliverymode1,
  //       distributionrep: this.publicationsaleForm.value.distributionrep,
  //      distributionm: this.publicationsaleForm.value.distributionm,
  //       subdistributionm: this.publicationsaleForm.value.subdistributionm,

  //     },
  //     width: '1200px',
  //     height: '1300px',
  //     maxWidth: '100%',
  //   });

  //   dialogData.afterClosed().subscribe((output) => {
  //     this.issueSellerbillForm.reset();
  //     this.ngOnInit();
  //     this.getAllChallanBillData();
  //   });
  // }

  openchallanBill() {
    const formValues = this.publicationsaleForm.value;
    const repName = formValues.distributionRepresentativeId;

    this.service.getchallanlistdataSummary(repName).subscribe((repData: any) => {
      if (!repData) {
        alert('Representative data not found.');
        return;
      }

      const dialogData = {
        challanno: formValues.challanno,

        cdate: this.formatDate(formValues.cdate), // formatted here
        issuegrath: formValues.issuegrath,
        issue_date: formValues.issueDates,
        distributionrep: repName,
        distributionm: formValues.distributionMode,
        subdistributionm: formValues.deliverySubModeId,
        copies: repData.total_copies,
        totalamount: repData.total_amount,
        address: repData.address,
        pincode: repData.pincode,
        state: repData.state,
        mobile_no: repData.mobile_no,
        distribution_representative: repData.distribution_representative
      };

      this.dialog.open(IssueSellerChallanBillComponent, {
        data: dialogData,
        width: '1200px',
        height: '1300px',
        maxWidth: '100%',
      });
    });
  }

  formatDate(date: any): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }



  openBookCreditReceipt() {
    debugger
    this.dialog.open(IssueSellerCreditNoteRegisterComponentComponent, {

      data: {
        receiptdata: this.newList1,

      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });

  }


  openAdvtBill3() {

    const req3: any = {
      "data": this.advtCreditNote1.issue_id,
    }
    this.service.getCreditdatabyid(req3).subscribe((data: any) => {
      console.log("Get databy id", data)
      if (data.length == 0) {
        debugger
        let dialogData = this.dialog.open(CreaditReceiptComponentComponent, {
          data: {
            name: data.name,
            add: data.address,
            mobile: data.mobile,
            invoicenum: data.invoice_no,
            cr_vocher: data.cr_vocher,
            invoicedate: data.voc_date,
            jama: data.credit_amt,
            unpaid_amt: data.unpaid_amt,
            credit_type: this.credit_type,
            credit_remark: data.credit_remark,
            cr_voucher: data.credit_voc_no,
            invoice_amt: this.invoice_amt,
            remaining_amt: this.remaining_amt

          },

          width: '1200px',
          height: '1300px',
          maxWidth: '100%',

        });
        dialogData.afterClosed().subscribe((output) => {
        });
      } else {
        let dialogData = this.dialog.open(CreaditReceiptComponentComponent, {

          data: {
            name: data[data.length - 1].name,
            add: data[data.length - 1].address,
            mobile: data[data.length - 1].mobile,
            invoicenum: data[data.length - 1].invoice_no,
            // cr_vocher : data[data.length-1].cr_vocher,
            invoicedate: data[data.length - 1].voc_date,
            jama: data[data.length - 1].credit_amt,
            unpaid_amt: data[data.length - 1].unpaid_amt,
            invoice_amt: data[data.length - 1].invoice_amt,
            remaining_amt: data[data.length - 1].remaining_amt,
            credit_remark: data[data.length - 1].credit_remark,
            credit_type: data[data.length - 1].credit_type,
            cr_voucher: data[data.length - 1].credit_voc_no,
          },

          width: '1200px',
          height: '1300px',
          maxWidth: '100%',

        });
        dialogData.afterClosed().subscribe((output) => {
        });
      }
    });
  }

  opentworeceipt() {
    debugger;

    if (!this.newList1) {
      this.newList1 = []; // Initialize if undefined
    }

    this.dialog.open(TwoReceiptIssuesaleComponentComponent, {
      data: {
        receiptdata: this.newList1,
      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });

    console.log(this.newList1, "open two receipt");
  }



  newList = []


  copydata1(data1, event) {
    debugger;

    if (!this.newList1) {
      this.newList1 = [];
    }

    if (event.checked) {
      // Only add if not already present
      const exists = this.newList1.some((item: any) => item.rcpt_no === data1.rcpt_no);
      if (!exists) {
        this.newList1.push(data1);
        this.total += data1.remain_amt;
      }
    } else {
      // Remove from list and adjust total
      this.newList1 = this.newList1.filter((person: any) => person.rcpt_no !== data1.rcpt_no);
      this.total -= data1.remain_amt;
    }

    console.log(this.newList1, "this.newList");
    console.log(this.total);
  }

  copydata2(data1, event) {
    debugger;

    if (!this.newList1) {
      this.newList1 = [];
    }

    if (event.checked) {
      // Only add if not already present
      const exists = this.newList1.some((item: any) => item.credit_voc_no === data1.credit_voc_no);
      if (!exists) {
        this.newList1.push(data1);
        this.total += data1.remain_amt;
      }
    } else {
      // Remove from list and adjust total
      this.newList1 = this.newList1.filter((person: any) => person.credit_voc_no !== data1.credit_voc_no);
      this.total -= data1.remain_amt;
    }

    console.log(this.newList1, "this.newList");
    console.log(this.total);
  }




  showContractReportPRR() {
    const req: any = {
      req: {
        "rep_name": this.PaymentReceiptRegister.value.rep_name,
        "startDate": formatDate(this.PaymentReceiptRegister.value.start, 'dd-MM-yyyy', 'en-US'),
        "endDate": formatDate(this.PaymentReceiptRegister.value.end, 'dd-MM-yyyy', 'en-US'),
        "off_rep_name": this.PaymentReceiptRegister.value.off_rep_name,
        "issue_name": this.PaymentReceiptRegister.value.issuename,
        "issue_Date": this.PaymentReceiptRegister.value.issueDates,
        "advt_name": this.PaymentReceiptRegister.value.advtname,


      }
    }

    this.service.getPaymentRegiInDetails11(req).subscribe((data) => {
      debugger
      this.advtPaymentRegiInDetailsFormBeans = data;
      this.PaymentissueOffInDTotal = 0;
      console.log(this.advtPaymentRegiInDetailsFormBeans, "data receipt")


      for (let data1 of this.advtPaymentRegiInDetailsFormBeans) {

        this.PaymentissueOffInDTotal += parseInt(data1.rcv_amt) || 0;

      }
    });



    this.service.getPaymentRegiInDetails11(req).subscribe((data) => {
      this.data_for_two_receipt = data;

      this.data_for_two_receipt.forEach(element => {
        element.is_selected = false;
      });

      if (this.contractReportType == 'Monthwise') {
        this.dialog.open(IssueCotractBriefReportComponent, {
          data: {
            reportType: this.contractReportType,
            rep_name: this.PaymentReceiptRegister.value.rep_name,
            startDate: (this.PaymentReceiptRegister.value.start),
            endDate: (this.PaymentReceiptRegister.value.end),
            off_rep_name: this.PaymentReceiptRegister.value.off_rep_name,
            issue_name: this.PaymentReceiptRegister.value.issuename,
            issue_date: this.PaymentReceiptRegister.value.issueDates, // consistent name
            advt_name: this.PaymentReceiptRegister.value.advtname
          },
          height: '1300px',
          width: '95%',
          maxWidth: '100%',
        });




      } else {
        // alert('Please select report type');
      }
    })


    if (this.contractReportType == 'briefly1') {
      this.dialog.open(IssueCreditVoucherPaymtRecieptBriflyReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }



    if (this.contractReportType == 'InDetail-Officer') {
      this.dialog.open(IssueCreditVoucheofficerIndetailReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }

    // console.log(this.contractData);
    if (this.contractReportType == 'VeryBriefly-Officer') {
      this.dialog.open(IssueCreditVoucherVeryBriflyOfficerReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }


    if (this.contractReportType == 'Briefly-Officer') {
      this.dialog.open(IssuecreditvoucherbrieflyofficerreportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }

    if (this.contractReportType == 'InDetail') {
      this.dialog.open(IssueSellerIndetailCreditVoucherReportComponent, {
        data: {
          reportType: this.contractReportType,
          rep_name: this.PaymentReceiptRegister.value.rep_name,
          startDate: (this.PaymentReceiptRegister.value.start),
          endDate: (this.PaymentReceiptRegister.value.end),
          off_rep_name: this.PaymentReceiptRegister.value.off_rep_name,
          issue_name: this.PaymentReceiptRegister.value.issuename,
          issue_date: this.PaymentReceiptRegister.value.issueDates, // consistent name
          advt_name: this.PaymentReceiptRegister.value.advtname

        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }



    // if (this.contractReportType == 'InDetail-personalledger') {
    //   this.dialog.open(IssueSellerPersonalLedgerComponent, {
    //     data: {
    //       contractData: this.contractData,
    //       startDate: this.startDate_contract,
    //       endDate: this.enddate_contract,
    //       repName: this.contractReportRepName,
    //       offRepName: this.contractReportOffRepName,
    //       advtName: this.contractReportissueRepName,
    //       reportType: this.contractReportType,
    //       issueDates: this.PaymentReceiptRegister.value.issueDates
    //     },
    //     height: '1300px',
    //     width: '95%',
    //     maxWidth: '100%',
    //   });

    // } else {
    //   // alert('Please select report type');
    // }

    // if (this.contractReportType == 'briefly-personalledger') {
    //   this.dialog.open(IssueSellerBrieflyPersonalLedgerComponentComponent, {
    //     data: {
    //       contractData: this.contractData,
    //       startDate: this.startDate_contract,
    //       endDate: this.enddate_contract,
    //       repName: this.contractReportRepName,
    //       offRepName: this.contractReportOffRepName,
    //       advtName: this.contractReportissueRepName,
    //       reportType: this.contractReportType,
    //       issueDates: this.PaymentReceiptRegister.value.issueDates
    //     },
    //     height: '1300px',
    //     width: '95%',
    //     maxWidth: '100%',
    //   });

    // } else {
    //   // alert('Please select report type');
    // }

    // if (this.contractReportType == 'IssueoutstandingInDetails') {
    //   this.dialog.open(IssueSellerOutstandibgIndetailReportsComponent, {
    //     data: {
    //       contractData: this.contractData,
    //       startDate: this.startDate_contract,
    //       endDate: this.enddate_contract,
    //       repName: this.contractReportRepName,
    //       offRepName: this.contractReportOffRepName,
    //       advtName: this.contractReportissueRepName,
    //       reportType: this.contractReportType,
    //       issueDates: this.PaymentReceiptRegister.value.issueDates
    //     },
    //     height: '1300px',
    //     width: '95%',
    //     maxWidth: '100%',
    //   });

    // } else {
    //   // alert('Please select report type');
    // }

    if (this.contractReportType == 'issueoutstandingbriefly') {
      this.dialog.open(IssueSellerOutstandibgIndetailReportsComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }
    if (this.contractReportType == 'unpaidOutstandingInDetails') {
      this.dialog.open(IssueSellerOutstandibgIndetailReportsComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }
    if (this.contractReportType == 'unpaidOutstandingbriefly') {
      this.dialog.open(IssueSellerOutstandibgIndetailReportsComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }

    if (this.contractReportType == 'unpaidOutstandingVbriefly') {
      this.dialog.open(IssueSellerOutstandibgIndetailReportsComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }

    if (this.contractReportType == 'creditdOutstandingindetails') {
      this.dialog.open(IssueSellerOutstandibgIndetailReportsComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }
    if (this.contractReportType == 'AdvertisementAddress') {
      this.dialog.open(IssueSellerOutstandibgIndetailReportsComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }

    if (this.contractReportType == 'AdvertisementAddressList') {
      this.dialog.open(IssueSellerAddressListComponentComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }
    if (this.contractReportType == 'creditOutstandingbriefly') {
      this.dialog.open(IssueSellerOutstandibgIndetailReportsComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      // alert('Please select report type');
    }


    if (this.contractReportType == 'GSTFullReport') {
      this.dialog.open(IssueSellerAddressGSTReportComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.startDate_contract,
          endDate: this.enddate_contract,
          repName: this.contractReportRepName,
          offRepName: this.contractReportOffRepName,
          advtName: this.contractReportissueRepName,
          reportType: this.contractReportType,
          issueDates: this.PaymentReceiptRegister.value.issueDates
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    } else {
      //
    }
  }

  openAdvtBill1(book) {
    debugger;
    this.advtCreditNote1 = book;
    console.log("new book", book);
    const remainval = book.remain_amt;
    console.log("remain val", remainval);
    debugger;
    this.crdtvno = this.advtCreditNoteform.value.crdtvno;

    let dialogData = this.dialog.open(OpenIssueSellerCreditNoteComponent, {
      data: {
        issuenames: this.advtNames,
        issueDates: this.advtNamesIssueDates,
        issue_id: book.issue_id,
        invoice_no: book.invoice_no,
        invoice_date: book.invoice_date,
        issue_amt: book.issue_amt,
        copies: book.copies,
        price: book.price,
        crdcopies: book.crdcopies,
        advt_name1: this.advtCreditNoteform.value.advtname,
        cr_vocher: this.advtCreditNoteform.value.crdtvno,
        create_date: this.advtCreditNoteform.value.date,
        receipt_date: formatDate(this.advtCreditNoteform.value.recptdate, 'dd-MM-yyyy', 'en-US'),
        rep_name: book.rep_name,
        credit_count: this.newg,
        remainvalue: remainval
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });

    dialogData.afterClosed().subscribe((output) => {
      if (output) {
        // Optional: capture remark and credit_type if needed
        this.credit_type = output.credit_type;
        this.remark = output.remark;

        // ✅ Refresh full page
        window.location.reload();
      }
    });
  }

  deleteCreditNote(advt: any) {
    const req: any = { id: advt };

    if (window.confirm('Are you sure you want to delete?')) {
      this.service.deleteIssuePymtCrdt(req).subscribe(
        (res: any) => {
          console.log(res);
          alert(res.message || 'Credit Note deleted successfully.');

          // ✅ Remove item from list immediately
          this.advtcreditnotetRegiInDetailsFormBeans = this.advtcreditnotetRegiInDetailsFormBeans
            .filter(item => item.id !== advt);
        },
        (error) => {
          console.error('Delete failed:', error);
          alert('Failed to delete the credit note.');
        }
      );
    }
  }

  deletePymtreceipt(advt: any) {
    const req: any = { id: advt };

    if (window.confirm('Are you sure you want to delete?')) {
      this.service.deleteIssuePymtreceipt(req).subscribe(
        (res: any) => {
          console.log(res);
          alert(res.message || 'Credit Note deleted successfully.');

          // ✅ Remove item from list immediately
          this.advtPaymentRegiInDetailsFormBeans = this.advtPaymentRegiInDetailsFormBeans
            .filter(item => item.id !== advt);
        },
        (error) => {
          console.error('Delete failed:', error);
          alert('Failed to delete the credit note.');
        }
      );
    }
  }

  selectall(event) {
    debugger
    if (event.checked) {
      debugger
      this.total = 0;
      this.data_for_two_receipt.forEach(element => {
        element.is_selected = true;
        // this.total = this.total + element.remain_amt
      })
    }

    else {
      this.data_for_two_receipt.forEach(element => {
        element.is_selected = false;
      });;
    }
  }
  deleterec: boolean = false;
  getdeleterecitcn: any;
  getdeleterecipt: any
  newordel(e) {
    ;
    if (e.value == 'deleted') {
      this.deleterec = true;
      const data: any = {
        "value": 'advt_pymt_rcpt',
      }
      this.service.getdeleteissuerecipt(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeleterecipt = data;
      });
    }
    else {
      this.deleterec = false
    }
  }
  getdeletereciptinvoice: any
  newordelinvoice(e) {
    // this.changeData();
    if (e.value == 'deleted') {
      this.deleterec = true;
      const data: any = {
        "value": 'advt_invoice',
      }
      this.service.getdeleteissuerecipt(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeletereciptinvoice = data;
      });
    }
    else {
      this.deleterec = false
    }
  }
  getdeleterecitstamp: any
  newordelstamp(e) {
    ;
    if (e.value == 'deleted') {
      this.deleterec = true;
      const data: any = {
        "value": 'advt_stamp_rcpt',
      }
      this.service.getdeleteissuerecipt(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeleterecitstamp = data;
      });
    }
    else {
      this.deleterec = false
    }
  }

  newordelcn(e) {
    ;
    if (e.value == 'deleted') {
      this.deleterec = true;
      const data: any = {
        "value": 'credit_note',
      }
      this.service.getdeleteissuerecipt(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeleterecitcn = data;
      });
    }
    else {
      this.deleterec = false
    }
  }
  dateFilter = (d: Date | null): boolean => {
    if (!d) return false;

    const selectedDate = this.issueSellerbillForm.get('date')?.value;
    if (!selectedDate) return true;

    const selectedMonth = new Date(selectedDate).getMonth();
    const selectedYear = new Date(selectedDate).getFullYear();

    return d.getMonth() === selectedMonth && d.getFullYear() === selectedYear;
  };
  advtNamesIssueDates;
  advtNamesStringDates;
  advtInvoiceNames;
  cid: any;
  newissuedate: any;
  newissuedate1: any;
  stampdata: any;
  getAdvtNameDates(e) {

    this.advtNamesIssueDates = e.value;
    this.advtNamesStringDates = this.advtNamesIssueDates.toString();

    // console.log('StringDates', this.advtNamesStringDates);
    console.log('IssueDates', this.advtNamesIssueDates);
    this.advtInvoiceNames = [];
    for (let index = 0; index < this.advtNamesIssueDates.length; index++) {
      this.service
        .getAdvtInvoiceforAdvtNames(this.advtNamesIssueDates[index])
        .subscribe((res: any) => {
          // console.log(`${index}`, res);
          if (res) {
            res?.map((a) => {
              this.advtInvoiceNames.push({ advt_name: a.name });
            });
          }
        });
      if (index == this.advtNamesIssueDates.length - 1) {
        console.log(this.advtInvoiceNames);

        //   this.advtInvoiceNames = this.uniqueid(
        //     this.advtInvoiceNames,
        //     (i) => i.advt_name
        //   );
      }
    }
    console.log(this.advtInvoiceNames);

    this.advtInvoiceNames = this.uniqueid(
      this.advtInvoiceNames,
      (i) => i.advt_name
    );
    console.log(this.advtInvoiceNames);

    this.cid = this.issueSellerbillForm.value.issuedate

    this.service.getinvoicdedetails(this.cid).subscribe((res) => {

      // console.log(res);
      this.newissuedate = res;
      // this.newissuedate1 = this.newissuedate[0].DS_ISSUEDATE
      let dates = []
      this.newissuedate = res;
      this.issueName = res;
      this.newissuedate.forEach((element: any) => {
        dates.push(element.DS_ISSUEDATE)
      });
      this.newissuedate1 = dates
      console.log(this.newissuedate1, "invoice list for new issuedaate")
      // for (let index = 0; index < this.advtInvoiceList.length; index++) {
      //   this.advtNamesData.push({
      //     id: this.advtInvoiceList[index]['id'],
      //     advt_name: this.advtInvoiceList[index]['advt_name'],
      //   });
      // }
    });

  }

  saveIssueSellerBill() {

    const issuesellerbooking = {
      billno: this.issueSellerbillForm.value.billno,
      date: this.issueSellerbillForm.value.date,
      issuename: this.issueSellerbillForm.value.issuename,
      issuedate: this.issueSellerbillForm.value.issuedate,
      issue_seller_name: this.issueSellerbillForm.value.issue_seller_name,
      newordeleted: this.issueSellerbillForm.value.newordeleted
    };
    this.service.saveIssueSellerBill(issuesellerbooking).subscribe((data) => {
      this.getIssueSellerList();
      window.alert('Issue Seller Added Successfully...');
      this.issueid = data['id']
      this.issueForm.reset();
      this.AdvtDetails = [];


    });
    // console.log(' Issue seller entry', issueseller);
  }
  updateCategoryName: any
  getIssuesForInvoice(e) {
    console.log(e);
    this.issueName = e.value;
    this.updateCategoryName = e.value;
    this.service.getAdvtSizeByCategory(e.value).subscribe((data) => {
      this.advtsizebyCategory = data;
    });
    console.log(
      'advt_mag_name_details',
      this.advt_mag_name_details.filter((a) => a.issue_name == this.issueName)
    );
    this.service.getAdvtDatesAndNames(e.value).subscribe((data) => {
      this.getMagIssueDatesandNames = data;
      console.log('Issue Dates and Names:', this.getMagIssueDatesandNames);
    });
  }
  getDates1: any
  stringdates1: any
  issueName2: any
  getIssueInvoiceDates(e) {
    // console.log(e.value.toString());
    // this.getDates1 = e.value;
    // this.getDates1 = this.getDates1.filter((a) => a != 'all');
    // this.stringdates1 = this.getDates1.toString();
    // this.issueSellerbillForm.patchValue({
    //   issuedate: e.value.toString().split(",")[0],
    // })
    // this.issueName2 = e.value.toString().split(",")[1];
    // console.log(this.issueName2);
  }
  // IssueSellerRegistrationReportComponentComponent

  advtname: any
  advtbillForm: any
  issueDate: any
  // issueName:any
  updateIssueSellerInvoice(data) {
    this.isupdate = true;
    // let date=this.datePipe.transform(data.invoice_date,'yyyy-MM-dd')

    if (data.issue_category_id != "" && data.issue_category_id != null && data.issue_category_id != undefined) {
      this.issueName = data.issue_category_id
    } else if (data.fifth_week_issue_name != "" && data.fifth_week_issue_name != null && data.fifth_week_issue_name != undefined) {
      this.issueName = data.fifth_week_issue_name
    } else if (data.third_week_issue_name != "" && data.third_week_issue_name != null && data.third_week_issue_name != undefined) {
      this.issueName = data.third_week_issue_name
    }
    else if (data.second_week_issue_name != "" && data.second_week_issue_name != null && data.second_week_issue_name != undefined) {
      this.issueName = data.second_week_issue_name
    } else if (data.first_week_issue_name != "" && data.first_week_issue_name != null && data.first_week_issue_name != undefined) {
      this.issueName = data.first_week_issue_name
    }

    this.getadvtName(this.issueName)

    if (data.fifth_week_issue_date != "" && data.fifth_week_issue_date != null && data.fifth_week_issue_date != undefined) {
      this.issueDate = data.fifth_week_issue_date
    } else if (data.fourth_week_issue_date != "" && data.fourth_week_issue_date != null && data.fourth_week_issue_date != undefined) {
      this.issueDate = data.fourth_week_issue_date
    } else if (data.third_week_issue_date != "" && data.third_week_issue_date != null && data.third_week_issue_date != undefined) {
      this.issueDate = data.third_week_issue_date
    }
    else if (data.second_week_issue_date != "" && data.second_week_issue_date != null && data.second_week_issue_date != undefined) {
      this.issueDate = data.second_week_issue_date
    } else if (data.first_week_issue_date != "" && data.first_week_issue_date != null && data.first_week_issue_date != undefined) {
      this.issueDate = data.first_week_issue_date
    }

    this.service.getAdvtDatesAndNames(this.issueName).subscribe((data) => {
      this.getMagIssueDatesandNames = data;
      console.log('Issue Dates and Names:', this.getMagIssueDatesandNames);
    });

    this.advtname = data.advt_name

    let date = data.invoice_date.split("-")
    let date1 = date[2] + "-" + date[1] + "-" + date[0]
    this.issueSellerbillForm.patchValue({
      billno: data.invoice_no,
      date: data.invoice_date,
      issuename: this.issueName,
      issue_seller_name: [data.issue_seller_name],


    })
    console.log(this.issueSellerbillForm.value)
  }

  advtNames;
  getMagIssueDatesandAdvtNames;
  getIssuesAdvtNames(e) {
    // console.log(e);
    this.advtNames = e.source.value;
    // console.log('jgfdfgh', this.advtNames);
    this.service.getAdvtDatesAndNames(e.source.value).subscribe((data) => {
      this.getMagIssueDatesandAdvtNames = data;
      console.log(this.getMagIssueDatesandAdvtNames, "this.getMagIssueDatesandAdvtNames")
      this.filterissuedate = data;
    });
  }

  getadvtName(e) {
    // console.log(e);
    // console.log('jgfdfgh', this.advtNames);
    this.service.getAdvtDatesAndNames(e).subscribe((data) => {
      this.getMagIssueDatesandAdvtNames = data;
      console.log(this.getMagIssueDatesandAdvtNames, "this.getMagIssueDatesandAdvtNames")
      this.filterissuedate = data;

      // this.advtbillForm.patchValue({
      //   issuedate :  [this.issueDate],

      // })
      this.getISN1()
    });

  }

  advtInvoiceStartDate;
  advtInvoiceEndDate;
  getChangedDateAdvtInvoice() {
    if (
      this.issueinvoiceForm.get('start').value != null &&
      this.issueinvoiceForm.get('end').value != null
    ) {
      this.advtInvoiceStartDate = formatDate(
        this.issueinvoiceForm.get('start').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.advtInvoiceEndDate = formatDate(
        this.issueinvoiceForm.get('end').value,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }

  dataforreceipt() {
    debugger
    this.service.dataforrec1().subscribe((data: any) => {
      console.log("tow receipt data=", data);
      this.data_for_two_receipt = (data as any);;
      // this.ngOnInit();
    });
  }

  getISN1() {
    this.advtNamesIssueDates = [this.issueDate];
    this.advtNamesStringDates = this.advtNamesIssueDates.toString();

    // console.log('StringDates', this.advtNamesStringDates);
    console.log('IssueDates', this.advtNamesIssueDates);
    this.advtInvoiceNames = [];
    for (let index = 0; index < this.advtNamesIssueDates.length; index++) {
      this.service
        .getAdvtInvoiceforAdvtNames(this.advtNamesIssueDates[index])
        .subscribe((res: any) => {
          // console.log(`${index}`, res);
          if (res) {
            res?.map((a) => {
              this.advtInvoiceNames.push({ advt_name: a.name });
            });
          }
        });
      if (index == this.advtNamesIssueDates.length - 1) {
        console.log(this.advtInvoiceNames);

        //   this.advtInvoiceNames = this.uniqueid(
        //     this.advtInvoiceNames,
        //     (i) => i.advt_name
        //   );
      }
    }
    // this.advtbillForm.patchValue({
    //   advt_name :  [this.advtname],

    // })
    console.log(this.advtInvoiceNames);
    this.getISN2()
    this.advtInvoiceNames = this.uniqueid(
      this.advtInvoiceNames,
      (i) => i.advt_name
    );
    console.log(this.advtInvoiceNames);
  }

  getChangedDateContractM3() {
    if (
      this.OutStandingForm.get('start').value != null &&
      this.OutStandingForm.get('end').value != null
    ) {
      // console.log(this.contractDetailsForm.value);
      this.startDate_contract = formatDate(
        new Date(this.OutStandingForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.enddate_contract = formatDate(
        new Date(this.OutStandingForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }

  fileName = 'ExportedData.xlsx';

  exportExcel(filenameBase: string = 'ExportedData'): void {
    this.fileName = `${filenameBase}.xlsx`;

    const element = document.getElementById('excel-table');
    if (!element) {
      console.error('Table element not found. Make sure <table id="excel-table"> exists.');
      return;
    }

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, this.fileName);
  }

  advtInvoicePricePerIssue = [];
  calculateRcptAmt(advtInvoice) {
    this.advtInvoicePymtRcptData.push(advtInvoice);
    const dialogdata = this.dialog.open(AddIssueSellerPerPriceComponent, {

      data: {
        advtInvoice: advtInvoice,
        crdtAmt: parseFloat(this.advtpymtrecptform.get('crdtvamt').value),
        seAmt: parseFloat(this.advtpymtrecptform.get('seamt').value),
        balAmt: parseFloat(this.advtpymtrecptform.get('balamt').value),
        bal: advtInvoice.pay_amt - advtInvoice.rcv_amt,

      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((res) => {

      console.log(res, 'res');
      if (this.newval == 0) {
        this.newval = res.newvalue;
      } else {
        this.newval = this.newval + ',' + res.newvalue
      }
      console.log(this.advtInvoiceList, "list")
      console.log(this.newval, "new val2")

      debugger;
      this.arraynew = res.invoicenumberlist;

      this.advtInvoiceListData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });
      this.advtInvoicePymtRcptData.map((a) => {
        if (a.id == res.advtInvoiceData.id) {
          a.remaining_amt = res.advtInvoiceData.remaining_amt;
        }
      });

      this.getallVouchersData.forEach((element, index) => {
        if (this.pendingAdvtData.voucher_no == element.voucher_no) {
          element.remaining_amt = res.advtInvoiceData.remaining_amt;
          if (element.remaining_amt == 0) {
            this.getallVouchersData.splice(index, 1); // Remove the object from the array
          }
        }
      });
      debugger;
      this.invoicenumberlist = this.invoicenumberlist

      this.advtpymtrecptform.get('seamt').setValue(res.selecetdAmt);
      this.advtpymtrecptform.get('balamt').setValue(res.balanceAmt);
      // res.advtInvoiceData.map((a) => {
      this.advtInvoicePricePerIssue.push(res.advtInvoiceData);
      // });
      // console.log(this.advtInvoicePricePerIssue);
    });
  }


  getISN2() {
    // console.log(e.value.toString());
    this.advtNames = this.issueName
    this.getData = [this.advtname];
    this.getData = this.getData.filter((a) => a != 'all');
    this.stringdata = this.getData.toString();
  }

  deleteIssueSellerInvoice(id: number) {
    if (confirm("Are you sure you want to delete this invoice?")) {
      this.service.deleteIssueSellerInvoice(id).subscribe((res) => {
        if (res['status'] === 'Success') {
          alert("Invoice deleted successfully.");
          this.getAllAdvtInovicesData();
        } else {
          this.getAllAdvtInovicesData();
          alert(res['message']);
        }
      });
    }
  }

  officeRepresentativeList: any;
  rep_type: any
  // getOfficeRepresentatives() {
  //   
  //   //   this.service.getDeptwiseOffRepList().subscribe((data) => {
  //   //     console.log("Office Rep Names="+JSON.stringify(data));
  //   //     this.officeRepresentativeList = data;
  //   //   });
  //   // }

  //   this.rep_type = "issue"

  //     this.service.getListofassignrep(this.rep_type).subscribe((data) => {
  //       this.officeRepresentativeList = data;
  //       console.log("Office Rep Names="+JSON.stringify(data));
  //     });
  //   }

  // contractData2 = []
  // assignoffwithtype2() {
  //   
  //   this.rep_type = "issue_office_rep";
  //   this.service.getListofassignrep(this.rep_type).subscribe((data) => {
  //     this.contractData2 = data;
  //     console.log("Assign List=", this.contractData1)
  //   });

  // }

  getCountry(event) {
    // console.log(event);
    // console.log(event.value);
    let country = this.countries.find((a) => a.country_name == event.value);
    if (country != undefined) {
      this.service.getState(country['country_code']).subscribe((data) => {
        this.states = data;
        // console.log(this.states);
      });
    } else {
    }
  } //getcountry

  contractData1 = []
  contractData11 = []

  assignoffwithtype() {

    this.rep_type = "issue";
    this.service.getListofassignrep(this.rep_type).subscribe((data) => {
      debugger

      // API may return the name as representative_name; normalize to issue_seller_representative
      data = (data || []).map((item: any) => ({
        ...item,
        issue_seller_representative: item.issue_seller_representative || item.representative_name || item.name || '',
      }));

      this.contractData1 = data;
      this.contractData11 = data;
      // re-emit so the autocomplete list refreshes now that data has loaded
      this.issueForm?.get('representativeId')?.updateValueAndValidity();
      this.getallcontarctdetails();
    });

  }

  contractData3 = []
  get_assign_office_representatives() {
    this.rep_type = "issue"
    this.service.get_assign_office_representatives(this.rep_type).subscribe((data) => {
      this.contractData3 = data;
    });

  }
  refreshIssueSaleInvoicePage() {
    location.reload();
  }

  expenseledgerStartDate = '';
  expenseledgerEndDate = '';
  expenseledgerDateRange() {

    if (
      this.expense.get('start').value != null &&
      this.expense.get('end').value != null
    ) {
      this.expenseledgerStartDate = formatDate(
        this.expense.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.expenseledgerEndDate = formatDate(
        this.expense.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }
  }

  expense_report_new() {

    debugger

    const subCtrl = this.expense.get('subexpnameother');

    // Case: sub expense is required and not selected
    if (!subCtrl?.value || subCtrl.value === '') {
      alert('Please select sub expense');
      return;
    }

    const dialogdata = this.dialog.open(ExpenseLedgerReportComponent, {
      data: {
        startDate: this.expenseledgerStartDate,
        endDate: this.expenseledgerEndDate,
        mainexp: this.expense.value.expnameother,
        subexp: this.expense.value.subexpnameother,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  getSubExpByMainExp(event: any) {
    debugger;

    // find selected main-expense (keeps your existing loop logic)
    for (let index = 0; index < Object.keys(this.mainExpData).length; index++) {
      if (this.mainExpData[index]['id'] === event.value.id) {
        this.mainexpId = this.mainExpData[index]['id'];
        this.mainexpName = this.mainExpData[index]['exp_name'];
        break;
      }
    }

    // fetch sub-expenses for selected main
    this.service.getSubExpenseLedgerWithId(event.value.id).subscribe((res: any[]) => {
      this.subExpData = res || [];

      const subCtrl = this.expense.get('subexpnameother');

      if (this.subExpData && this.subExpData.length > 0) {
        this.subexpense = true;

        if (subCtrl?.disabled) {
          subCtrl.enable({ emitEvent: false });
        }
        subCtrl?.reset();


      } else {
        this.subexpense = false;

        // clear value and state so old ids/names don't persist
        subCtrl?.reset();                  // clears value and marks pristine/touched = false
        subCtrl?.setErrors(null);         // clear any leftover errors
        subCtrl?.clearValidators();       // optional: remove validators if you don't want them
        subCtrl?.updateValueAndValidity();

        // disable so it won't be submitted if you're reading rawValue or form.value
        if (subCtrl?.enabled) {
          subCtrl.disable({ emitEvent: false });
        }
      }
    });
  }

}
function offwiseindetailDatewise() {
  throw new Error('Function not implemented.');
}

